webpackJsonp([10],{

/***/ 1150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_titleComponent__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__currentUnit__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_scheduleClass__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(82);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      locale: 'pt-br',
      showSchedule: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])({
    books: 'book/getAll',
    book: 'book/get',
    bookExists: 'book/exists',
    unit: 'unit/get',
    classes: 'lesson/getClasses',
    isClassScheduled: 'lesson/isClassScheduled',
    student: 'student/GET',
    teensBooks: 'teens/GET_BOOKS',
    teensBook: 'teens/GET_CURRENT_BOOK',
    teensUnits: 'teens/GET_UNITS',
    teensUnit: 'teens/GET_CURRENT_UNIT'
  }), {
    currentBook: function currentBook() {
      if (!this.student.teens) return this.book;

      return this.teensBook;
    },
    currentUnit: function currentUnit() {
      if (!this.student.teens) return this.unit;

      return this.teensUnit;
    },
    hasUnits: function hasUnits() {
      if (!this.hasBook) return false;

      if (!this.student.teens) return !this.book.units ? false : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.book.units).length > 0;

      return !!this.teensUnits.length;
    },
    hasBook: function hasBook() {
      if (!this.student.teens) return this.bookExists;

      return !!this.teensBooks.length;
    }
  }),
  components: {
    titleComponent: __WEBPACK_IMPORTED_MODULE_4__components_titleComponent__["a" /* default */],
    currentUnit: __WEBPACK_IMPORTED_MODULE_5__currentUnit__["a" /* default */],
    scheduleClass: __WEBPACK_IMPORTED_MODULE_6__components_scheduleClass__["a" /* default */]
  },
  methods: {
    handleDayChanged: function handleDayChanged(data) {},
    handleMonthChanged: function handleMonthChanged(data) {}
  },
  beforeMount: function beforeMount() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$store.commit('setShowLoader', true);
              _context.next = 3;
              return _this.$store.dispatch('book/setBook');

            case 3:
              _context.next = 5;
              return _this.$store.dispatch('unit/setUnit');

            case 5:
              _this.$store.commit('setShowLoader', false);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ 1151:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_trunc__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(82);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ScheduleClass',
  data: function data() {
    return {
      step: 0,
      page: 0,
      toSchedule: null,
      days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      error: null,
      isComplementary: false
    };
  },

  props: {
    close: {
      type: Function,
      required: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    'student': 'student/GET',
    'lessons': 'lesson/getLessons',
    'toReview': 'lesson/getReview',
    '_schedule_': 'lesson/schedule',
    '_nextSchedule_': 'lesson/nextSchedule'
  }), {
    schedule: function schedule() {
      var temp = (this.isComplementary ? this._nextSchedule_ : this._schedule_).map(function (s) {
        var date = new Date(s.DataInicial);
        date.setHours(date.getHours() + 3);

        return {
          class_id: s.CodAgenda,
          date: date
        };
      }).slice(this.page * 8, 8 * (this.page + 1));

      while (temp.length < 8) {
        temp.push({ date: null });
      }

      return temp;
    },
    allowBack: function allowBack() {
      return this.page > 0;
    },
    allowNext: function allowNext() {
      return this.page < __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_math_trunc___default()(this._schedule_.length / 8);
    },
    currentIndex: function currentIndex() {
      var _this = this;

      if (this.toReview.length) return this.lessons.findIndex(function (l) {
        return l.lesson_id == _this.toReview[0].lesson_id;
      });

      return this.lessons.findIndex(function (l) {
        return l.lesson_id == _this.student.lesson_id && l.order == _this.student.lesson_order;
      });
    },
    nextIndex: function nextIndex() {
      var _this2 = this;

      if (this.toReview.length) return this.lessons.findIndex(function (l) {
        return l.lesson_id == _this2.toReview[0].lesson_id;
      });

      return this.lessons.findIndex(function (l) {
        return l.book_id == _this2.student.book_id && l.order == _this2.student.lesson_order + 1;
      });
    },
    currentClass: function currentClass() {
      return this.lessons[this.currentIndex];
    }
  }),
  methods: {
    getDate: function getDate(date) {
      if (!date) return { day: '00', month: '00' };

      var day = date.getUTCDate(),
          month = date.getUTCMonth() + 1;

      if (day < 10) day = '0' + day;
      if (month < 10) month = '0' + month;

      return { day: day, month: month };
    },
    getDay: function getDay(date) {
      if (!date) return 'None';
      return this.days[date.getDay()];
    },
    getMonth: function getMonth(date) {
      if (!date) return 'None';
      return this.months[date.getMonth()];
    },
    getTime: function getTime(date) {
      if (!date) return '00:00 a.m.';

      var hours = date.getHours(),
          minutes = date.getMinutes();

      var isNight = hours > 12;

      hours = isNight ? hours % 12 : hours;

      if (hours < 10) hours = '0' + hours;
      if (minutes < 10) minutes = '0' + minutes;

      return hours + ':' + minutes + ' ' + (isNight ? 'p' : 'a') + '.m.';
    },
    nextPage: function nextPage() {
      if (this.allowNext) this.page++;
    },
    prevPage: function prevPage() {
      if (this.allowBack) this.page--;
    },
    setSchedule: function setSchedule(lesson) {
      if (!!lesson && !!lesson.date) this.toSchedule = lesson;else this.toSchedule = null;
    },
    nextStep: function nextStep() {
      this.step++;
    },
    confirmSchedule: function confirmSchedule() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this3.$store.commit('setShowLoader', true);

                _context.next = 4;
                return _this3.$store.dispatch('lesson/schedule', _this3.toSchedule.class_id);

              case 4:
                _context.next = 6;
                return _this3.$store.dispatch('lesson/getClasses');

              case 6:
                if (!(_this3.currentClass.type == 'U' && !_this3.toReview.length)) {
                  _context.next = 11;
                  break;
                }

                _context.next = 9;
                return _this3.$store.dispatch('lesson/getNextSchedule');

              case 9:
                _context.next = 13;
                break;

              case 11:
                _context.next = 13;
                return _this3.$store.dispatch('lesson/getSchedule');

              case 13:
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](0);

                _this3.error = _context.t0;

              case 18:
                _context.prev = 18;

                _this3.toSchedule = null;
                _this3.$store.commit('setShowLoader', false);
                _this3.nextStep();
                return _context.finish(18);

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 15, 18, 23]]);
      }))();
    },
    setComplementary: function setComplementary(isComplementary) {
      this.isComplementary = isComplementary;
      this.toSchedule = null;
    }
  },
  beforeCreate: function beforeCreate() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this4.$store.dispatch('lesson/getSchedule');

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this4);
    }))();
  },
  mounted: function mounted() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(_this5.currentClass.type == 'U' && !_this5.toReview.length)) {
                _context3.next = 3;
                break;
              }

              _context3.next = 3;
              return _this5.$store.dispatch('lesson/getNextSchedule');

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this5);
    }))();
  }
});

/***/ }),

/***/ 1285:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1286);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("147aff4b", content, true, {});

/***/ }),

/***/ 1286:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".cal-wrapper,.events-wrapper{margin:10px}.__vev_calendar-wrapper{position:relative;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;width:100%}.__vev_calendar-wrapper *{-webkit-box-sizing:border-box;box-sizing:border-box}.__vev_calendar-wrapper ::-webkit-scrollbar{width:8px;height:8px}.__vev_calendar-wrapper ::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 2px rgba(0,0,0,.2);box-shadow:inset 0 0 2px rgba(0,0,0,.2);border-radius:5px}.__vev_calendar-wrapper ::-webkit-scrollbar-thumb{border-radius:5px;background:rgba(0,0,0,.2)}.__vev_calendar-wrapper .cal-wrapper{border-radius:4px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:300px;flex-basis:300px;position:relative}.__vev_calendar-wrapper .cal-wrapper .cal-header{position:relative;font-weight:300;overflow:hidden;padding-bottom:10px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-top:20px;margin-bottom:10px}.__vev_calendar-wrapper .cal-wrapper .cal-header .title{background:#ddd;width:95%;margin:0 auto;padding:10px 0;text-align:center;border-radius:20px}.__vev_calendar-wrapper .cal-wrapper .cal-header .l,.__vev_calendar-wrapper .cal-wrapper .cal-header .r{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:rgba(0,0,0,0);width:30px;height:30px;font-size:14px;background:#ff9c00;border-radius:50%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#fff;margin-left:10px;margin-right:10px;-webkit-transition:.3s;transition:.3s}.__vev_calendar-wrapper .cal-wrapper .cal-header .l:hover,.__vev_calendar-wrapper .cal-wrapper .cal-header .r:hover{background:#d48202}.__vev_calendar-wrapper .cal-wrapper .cal-header .l{position:absolute;left:10px;top:6px}.__vev_calendar-wrapper .cal-wrapper .cal-header .r{position:absolute;right:10px;top:6px}.__vev_calendar-wrapper .cal-wrapper .cal-body{width:100%}.__vev_calendar-wrapper .cal-wrapper .cal-body .weeks{width:100%;overflow:hidden;text-align:center;-ms-flex-pack:distribute;justify-content:space-around}.__vev_calendar-wrapper .cal-wrapper .cal-body .weeks,.__vev_calendar-wrapper .cal-wrapper .cal-body .weeks .item{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.__vev_calendar-wrapper .cal-wrapper .cal-body .weeks .item{background:#ffa200!important;color:#fff;font-size:14px;letter-spacing:-1px;width:30px;height:30px;border-radius:5px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-weight:300!important}.__vev_calendar-wrapper .cal-wrapper .cal-body .dates{width:100%;overflow:hidden;text-align:center;font-size:14px}.__vev_calendar-wrapper .cal-wrapper .cal-body .dates .item{position:relative;float:left;display:block;width:14.285%;cursor:default;-webkit-tap-highlight-color:rgba(0,0,0,0);line-height:40px}.__vev_calendar-wrapper .cal-wrapper .cal-body .dates .item .date-num{font-size:14px;position:relative;z-index:3}.__vev_calendar-wrapper .cal-wrapper .cal-body .dates .item.today .date-num{color:#ffa200!important;font-weight:300}.__vev_calendar-wrapper .cal-wrapper .cal-body .dates .item.event{cursor:pointer;font-weight:300}.__vev_calendar-wrapper .cal-wrapper .cal-body .dates .item.selected-day .is-event{background-color:#f45}.__vev_calendar-wrapper .cal-wrapper .cal-body .dates .item .is-event{content:\"\";border:1px solid #f45;background-color:#fff;border-radius:5px;width:30px;height:30px;position:absolute;left:50%;top:50%;z-index:1;margin-left:-15px;margin-top:-15px}.__vev_calendar-wrapper .events-wrapper{border-radius:4px;-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2;-ms-flex-preferred-size:300px;flex-basis:300px;-webkit-box-sizing:border-box;box-sizing:border-box}.__vev_calendar-wrapper .events-wrapper .cal-events{margin:0;min-height:260px;overflow-y:auto}.__vev_calendar-wrapper .events-wrapper .date{text-align:center;color:#333;font-size:20px}.__vev_calendar-wrapper .events-wrapper .event-item{color:#323232;margin-top:10px}.__vev_calendar-wrapper .events-wrapper .event-item:first-child{margin-top:0}.__vev_calendar-wrapper .arrow-left.icon{color:#000;position:absolute;left:6%}.__vev_calendar-wrapper .arrow-left.icon:before{content:\"\";position:absolute;left:1px;top:-5px;width:10px;height:10px;border-top:1px solid currentColor;border-right:1px solid currentColor;-webkit-transform:rotate(-135deg);transform:rotate(-135deg)}.__vev_calendar-wrapper .arrow-right.icon{color:#000;position:absolute;right:6%}.__vev_calendar-wrapper .arrow-right.icon:before{content:\"\";position:absolute;right:1px;top:-5px;width:10px;height:10px;border-top:1px solid currentColor;border-right:1px solid currentColor;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.__vev_calendar-wrapper h3,.__vev_calendar-wrapper p{margin:0;padding:0}.lab .is-event{background:#00b4ba!important;background:linear-gradient(-206deg,#00b4ba,#00418a)!important;border:none!important}.lab .date-num{color:#fff!important}.conversation .is-event{background:#4e6bfd!important;background:linear-gradient(-206deg,#4e6bfd,#9a0eec)!important;border:none!important}.conversation .date-num{color:#fff!important}.other .is-event{background:#21a6a6!important;background:linear-gradient(-206deg,#21a6a6,#a2f095)!important;border:none!important}.other .date-num{color:#fff!important}.is-today{content:\"\";border:1px solid #ff9c00!important;background-color:#fff;border-radius:5px;width:30px;height:30px;position:absolute;left:50%;top:50%;z-index:1;margin-left:-15px;margin-top:-15px}.wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline;color:#323232;font-size:14px}.wrapper.lab .time,.wrapper.lab .title{background:#00b4ba!important;background:linear-gradient(-206deg,#00b4ba,#00418a)!important}.wrapper.other .time,.wrapper.other .title{background:#21a6a6!important;background:linear-gradient(-206deg,#21a6a6,#a2f095)!important}.wrapper.conversation .time,.wrapper.conversation .title{background:#4e6bfd!important;background:linear-gradient(-206deg,#4e6bfd,#9a0eec)!important}.wrapper .time{margin-right:5px;color:#fff;border-radius:5px;font-size:12px;line-height:15px;padding:5px 15px}.wrapper .time,.wrapper .time p{font-weight:300}.wrapper .title{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;color:#fff;font-weight:200;border-radius:5px;padding:5px 5px 5px 10px;-webkit-box-sizing:border-box;box-sizing:border-box;line-height:15px}.button{margin-top:20px}.events-wrapper button.btn{padding:10px;outline:none;background:#ffa200;font-weight:300;font-size:14px;cursor:pointer;color:#fff;-webkit-transition:.1s;transition:.1s;border:1px solid transparent;vertical-align:middle;-webkit-appearance:none;border-radius:50px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}.btn-full{width:100%}.wrapper .title{margin-bottom:0}.item{-ms-flex-wrap:wrap;flex-wrap:wrap}.item#alert{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.item div#msg:first-child{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}@media (max-width:440px){.item div#msg:first-child{-webkit-box-align:center;-ms-flex-align:center;align-items:center}}.item div#desc:nth-child(2){-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.item div#desc:nth-child(2),.item div#warn:nth-child(3){-webkit-box-align:center;-ms-flex-align:center;align-items:center}.item div#warn:nth-child(3){font-weight:300;text-transform:uppercase;background:linear-gradient(-5deg,#0073b8,#00e7ff)!important;border-radius:300px;color:#fff;height:40px!important;margin:10px 20px}.item .boxmsg,.item div#warn:nth-child(3){-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.item .boxmsg{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:50%;flex-basis:50%;height:70px}.item .boxmsg,.item .boxmsg h1{display:-webkit-box;display:-ms-flexbox;display:flex}.item .boxmsg h1{font-size:25px;font-weight:400;text-transform:uppercase;color:orange;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.item .boxmsg h1 span{height:7px;width:205px;background-color:orange;border-radius:300px;margin:0 10px 0 0}@media (max-width:440px){.item .boxmsg h1 span{width:150px}}.item .boxmsg h2{font-size:35px;font-weight:400;letter-spacing:-1px;text-transform:uppercase}@media (max-width:440px){.item .boxmsg h2{font-size:30px}}.item .boxmsg h3{font-size:15px;font-weight:200;color:gray;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-right:25px}@media (max-width:440px){.item .boxmsg h3{font-size:13px}}.item .boxmsg img{width:70px;margin:0 5px 0 20px}@media (max-width:440px){.item .boxmsg img{margin:0 5px 0 0}}.schedule__menu{position:fixed;top:0;left:0;background-color:rgba(19,0,0,.95);width:100vw;height:100%;z-index:150}.schedule__menu__icon{position:absolute;top:5vh;right:5vw;height:60px!important;width:60px!important;color:#fc7f7f;-webkit-transition:-webkit-transform .2s;transition:-webkit-transform .2s;transition:transform .2s;transition:transform .2s,-webkit-transform .2s;cursor:pointer}.schedule__menu__icon:hover{-webkit-transform:scale(1.2) rotate(90deg);transform:scale(1.2) rotate(90deg)}.show-schedule-enter-active{-webkit-animation:opaque .2s ease backwards;animation:opaque .2s ease backwards;-webkit-animation-delay:.2s;animation-delay:.2s}.show-schedule-leave-active{animation:opaque .2s ease reverse backwards}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/pages/home/index.vue"],"names":[],"mappings":"AACA,6BAEE,WAAa,CACd,AACD,wBACE,kBAAmB,AACnB,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,UAAY,CACb,AACD,0BACE,8BAA+B,AACvB,qBAAuB,CAChC,AACD,4CACE,UAAW,AACX,UAAY,CACb,AACD,kDACE,gDAAqD,AAC7C,wCAA6C,AACrD,iBAAmB,CACpB,AACD,kDACE,kBAAmB,AACnB,yBAA+B,CAChC,AACD,qCACE,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,8BAA+B,AAC3B,iBAAkB,AACtB,iBAAmB,CACpB,AACD,iDACE,kBAAmB,AACnB,gBAAiB,AACjB,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,gBAAiB,AACjB,kBAAoB,CACrB,AACD,wDACE,gBAAiB,AACjB,UAAW,AACX,cAAe,AACf,eAAgB,AAChB,kBAAmB,AACnB,kBAAoB,CACrB,AACD,wGAEE,eAAgB,AAChB,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,iBAAkB,AAC1B,0CAA8C,AAC9C,WAAY,AACZ,YAAa,AACb,eAAgB,AAChB,mBAAoB,AACpB,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,WAAY,AACZ,iBAAkB,AAClB,kBAAmB,AACnB,uBAAyB,AACzB,cAAiB,CAClB,AACD,oHAEE,kBAAoB,CACrB,AACD,oDACE,kBAAmB,AACnB,UAAW,AACX,OAAS,CACV,AACD,oDACE,kBAAmB,AACnB,WAAY,AACZ,OAAS,CACV,AACD,+CACE,UAAY,CACb,AACD,sDACE,WAAY,AACZ,gBAAiB,AACjB,kBAAmB,AAOnB,yBAA0B,AACtB,4BAA8B,CACnC,AACD,kHATE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAsB7B,AAlBD,4DACE,6BAA+B,AAC/B,WAAY,AACZ,eAAgB,AAChB,oBAAqB,AACrB,WAAY,AACZ,YAAa,AACb,kBAAmB,AAOnB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA4B,CAC7B,AACD,sDACE,WAAY,AACZ,gBAAiB,AACjB,kBAAmB,AACnB,cAAgB,CACjB,AACD,4DACE,kBAAmB,AACnB,WAAY,AACZ,cAAe,AACf,cAAe,AACf,eAAgB,AAChB,0CAA8C,AAC9C,gBAAkB,CACnB,AACD,sEACE,eAAgB,AAChB,kBAAmB,AACnB,SAAW,CACZ,AACD,4EACE,wBAA0B,AAC1B,eAAiB,CAClB,AACD,kEACE,eAAgB,AAChB,eAAiB,CAClB,AACD,mFACE,qBAA0B,CAC3B,AACD,sEACE,WAAY,AACZ,sBAA0B,AAC1B,sBAAuB,AACvB,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,SAAU,AACV,QAAS,AACT,UAAW,AACX,kBAAmB,AACnB,gBAAkB,CACnB,AACD,wCACE,kBAAmB,AACnB,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,8BAA+B,AAC3B,iBAAkB,AACtB,8BAA+B,AACvB,qBAAuB,CAChC,AACD,oDACE,SAAU,AACV,iBAAkB,AAClB,eAAiB,CAClB,AACD,8CACE,kBAAmB,AACnB,WAAY,AACZ,cAAgB,CACjB,AACD,oDACE,cAAe,AACf,eAAiB,CAClB,AACD,gEACE,YAAc,CACf,AACD,yCACE,WAAY,AACZ,kBAAmB,AACnB,OAAS,CACV,AACD,gDACE,WAAY,AACZ,kBAAmB,AACnB,SAAU,AACV,SAAU,AACV,WAAY,AACZ,YAAa,AACb,kCAAmC,AACnC,oCAAqC,AACrC,kCAAmC,AACnC,yBAA2B,CAC5B,AACD,0CACE,WAAY,AACZ,kBAAmB,AACnB,QAAU,CACX,AACD,iDACE,WAAY,AACZ,kBAAmB,AACnB,UAAW,AACX,SAAU,AACV,WAAY,AACZ,YAAa,AACb,kCAAmC,AACnC,oCAAqC,AACrC,gCAAiC,AACjC,uBAAyB,CAC1B,AACD,qDAEE,SAAU,AACV,SAAW,CACZ,AACD,eACE,6BAA+B,AAC/B,8DAA0E,AAC1E,qBAAwB,CACzB,AACD,eACE,oBAAuB,CACxB,AACD,wBACE,6BAA+B,AAC/B,8DAA0E,AAC1E,qBAAwB,CACzB,AACD,wBACE,oBAAuB,CACxB,AACD,iBACE,6BAA+B,AAC/B,8DAA0E,AAC1E,qBAAwB,CACzB,AACD,iBACE,oBAAuB,CACxB,AACD,UACE,WAAY,AACZ,mCAAqC,AACrC,sBAAuB,AACvB,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,SAAU,AACV,QAAS,AACT,UAAW,AACX,kBAAmB,AACnB,gBAAkB,CACnB,AACD,SACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,2BAA4B,AACxB,wBAAyB,AACrB,qBAAsB,AAC9B,cAAe,AACf,cAAgB,CACjB,AACD,uCAEE,6BAA+B,AAC/B,6DAA0E,CAC3E,AACD,2CAEE,6BAA+B,AAC/B,6DAA0E,CAC3E,AACD,yDAEE,6BAA+B,AAC/B,6DAA0E,CAC3E,AACD,eACE,iBAAkB,AAClB,WAAY,AAEZ,kBAAmB,AACnB,eAAgB,AAChB,iBAAkB,AAClB,gBAAkB,CACnB,AACD,gCANE,eAAiB,CAQlB,AACD,gBACE,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,WAAY,AACZ,gBAAiB,AACjB,kBAAmB,AACnB,yBAA0B,AAC1B,8BAA+B,AACvB,sBAAuB,AAC/B,gBAAkB,CACnB,AACD,QACE,eAAiB,CAClB,AACD,2BACE,aAAc,AACd,aAAc,AACd,mBAAoB,AACpB,gBAAiB,AACjB,eAAgB,AAChB,eAAgB,AAChB,WAAY,AACZ,uBAAwB,AACxB,eAAgB,AAChB,6BAA8B,AAC9B,sBAAuB,AACvB,wBAAyB,AACzB,mBAAoB,AACpB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,iBAAmB,CACpB,AACD,UACE,UAAY,CACb,AACD,gBACE,eAAiB,CAClB,AACD,MACE,mBAAoB,AAChB,cAAgB,CACrB,AACD,YACI,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC/B,AACD,0BACI,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,sBAAuB,AACnB,mBAAoB,AAChB,oBAAsB,CACjC,AACD,yBACA,0BACQ,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CACnC,CACA,AACD,4BACI,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,kBAAoB,CAI/B,AACD,wDAJI,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAgB/B,AAdD,4BACI,gBAAiB,AACjB,yBAA0B,AAC1B,4DAAgE,AAOhE,oBAAqB,AACrB,WAAa,AACb,sBAAwB,AACxB,gBAA4B,CAC/B,AACD,0CAXI,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CAsBnC,AAbD,cAOI,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,4BAA6B,AACzB,eAAgB,AACpB,WAAa,CAChB,AACD,+BAbI,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CAsBjB,AAXD,iBACM,eAAgB,AAChB,gBAAiB,AACjB,yBAA0B,AAC1B,aAAc,AAId,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CACjC,AACD,sBACQ,WAAY,AACZ,YAAa,AACb,wBAAyB,AACzB,oBAAqB,AACrB,iBAAyB,CAChC,AACD,yBACA,sBACY,WAAa,CACxB,CACA,AACD,iBACM,eAAgB,AAChB,gBAAiB,AACjB,oBAAqB,AACrB,wBAA0B,CAC/B,AACD,yBACA,iBACU,cAAgB,CACzB,CACA,AACD,iBACM,eAAgB,AAChB,gBAAiB,AACjB,WAAY,AACZ,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,kBAAoB,CACzB,AACD,yBACA,iBACU,cAAgB,CACzB,CACA,AACD,kBACM,WAAY,AACZ,mBAAyB,CAC9B,AACD,yBACA,kBACU,gBAAwB,CACjC,CACA,AACD,gBACE,eAAgB,AAChB,MAAO,AACP,OAAQ,AACR,kCAAuC,AACvC,YAAa,AACb,YAAa,AACb,WAAa,CACd,AACD,sBACI,kBAAmB,AACnB,QAAS,AACT,UAAW,AACX,sBAAwB,AACxB,qBAAuB,AACvB,cAAe,AACf,yCAA0C,AAC1C,iCAAkC,AAClC,yBAA0B,AAC1B,+CAAiD,AACjD,cAAgB,CACnB,AACD,4BACM,2CAA4C,AACpC,kCAAoC,CACjD,AACD,4BACE,4CAA6C,AACrC,oCAAqC,AAC7C,4BAA6B,AACrB,mBAAqB,CAC9B,AACD,4BACE,2CAA6C,CAC9C","file":"index.vue","sourcesContent":["\n.cal-wrapper,\n.events-wrapper {\n  margin: 10px;\n}\n.__vev_calendar-wrapper {\n  position: relative;\n  overflow: hidden;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  width: 100%;\n}\n.__vev_calendar-wrapper * {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.__vev_calendar-wrapper ::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n.__vev_calendar-wrapper ::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.2);\n          box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.2);\n  border-radius: 5px;\n}\n.__vev_calendar-wrapper ::-webkit-scrollbar-thumb {\n  border-radius: 5px;\n  background: rgba(0, 0, 0, 0.2);\n}\n.__vev_calendar-wrapper .cal-wrapper {\n  border-radius: 4px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  -ms-flex-preferred-size: 300px;\n      flex-basis: 300px;\n  position: relative;\n}\n.__vev_calendar-wrapper .cal-wrapper .cal-header {\n  position: relative;\n  font-weight: 300;\n  overflow: hidden;\n  padding-bottom: 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n.__vev_calendar-wrapper .cal-wrapper .cal-header .title {\n  background: #ddd;\n  width: 95%;\n  margin: 0 auto;\n  padding: 10px 0;\n  text-align: center;\n  border-radius: 20px;\n}\n.__vev_calendar-wrapper .cal-wrapper .cal-header .l,\n.__vev_calendar-wrapper .cal-wrapper .cal-header .r {\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  width: 30px;\n  height: 30px;\n  font-size: 14px;\n  background: #FF9C00;\n  border-radius: 50%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: #fff;\n  margin-left: 10px;\n  margin-right: 10px;\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n.__vev_calendar-wrapper .cal-wrapper .cal-header .l:hover,\n.__vev_calendar-wrapper .cal-wrapper .cal-header .r:hover {\n  background: #D48202;\n}\n.__vev_calendar-wrapper .cal-wrapper .cal-header .l {\n  position: absolute;\n  left: 10px;\n  top: 6px;\n}\n.__vev_calendar-wrapper .cal-wrapper .cal-header .r {\n  position: absolute;\n  right: 10px;\n  top: 6px;\n}\n.__vev_calendar-wrapper .cal-wrapper .cal-body {\n  width: 100%;\n}\n.__vev_calendar-wrapper .cal-wrapper .cal-body .weeks {\n  width: 100%;\n  overflow: hidden;\n  text-align: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.__vev_calendar-wrapper .cal-wrapper .cal-body .weeks .item {\n  background: #FFA200 !important;\n  color: #fff;\n  font-size: 14px;\n  letter-spacing: -1px;\n  width: 30px;\n  height: 30px;\n  border-radius: 5px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  font-weight: 300 !important;\n}\n.__vev_calendar-wrapper .cal-wrapper .cal-body .dates {\n  width: 100%;\n  overflow: hidden;\n  text-align: center;\n  font-size: 14px;\n}\n.__vev_calendar-wrapper .cal-wrapper .cal-body .dates .item {\n  position: relative;\n  float: left;\n  display: block;\n  width: 14.285%;\n  cursor: default;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  line-height: 40px;\n}\n.__vev_calendar-wrapper .cal-wrapper .cal-body .dates .item .date-num {\n  font-size: 14px;\n  position: relative;\n  z-index: 3;\n}\n.__vev_calendar-wrapper .cal-wrapper .cal-body .dates .item.today .date-num {\n  color: #FFA200 !important;\n  font-weight: 300;\n}\n.__vev_calendar-wrapper .cal-wrapper .cal-body .dates .item.event {\n  cursor: pointer;\n  font-weight: 300;\n}\n.__vev_calendar-wrapper .cal-wrapper .cal-body .dates .item.selected-day .is-event {\n  background-color: #ff4455;\n}\n.__vev_calendar-wrapper .cal-wrapper .cal-body .dates .item .is-event {\n  content: '';\n  border: 1px solid #ff4455;\n  background-color: #fff;\n  border-radius: 5px;\n  width: 30px;\n  height: 30px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  z-index: 1;\n  margin-left: -15px;\n  margin-top: -15px;\n}\n.__vev_calendar-wrapper .events-wrapper {\n  border-radius: 4px;\n  -webkit-box-flex: 2;\n      -ms-flex-positive: 2;\n          flex-grow: 2;\n  -ms-flex-preferred-size: 300px;\n      flex-basis: 300px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.__vev_calendar-wrapper .events-wrapper .cal-events {\n  margin: 0;\n  min-height: 260px;\n  overflow-y: auto;\n}\n.__vev_calendar-wrapper .events-wrapper .date {\n  text-align: center;\n  color: #333;\n  font-size: 20px;\n}\n.__vev_calendar-wrapper .events-wrapper .event-item {\n  color: #323232;\n  margin-top: 10px;\n}\n.__vev_calendar-wrapper .events-wrapper .event-item:first-child {\n  margin-top: 0;\n}\n.__vev_calendar-wrapper .arrow-left.icon {\n  color: #000;\n  position: absolute;\n  left: 6%;\n}\n.__vev_calendar-wrapper .arrow-left.icon:before {\n  content: '';\n  position: absolute;\n  left: 1px;\n  top: -5px;\n  width: 10px;\n  height: 10px;\n  border-top: solid 1px currentColor;\n  border-right: solid 1px currentColor;\n  -webkit-transform: rotate(-135deg);\n  transform: rotate(-135deg);\n}\n.__vev_calendar-wrapper .arrow-right.icon {\n  color: #000;\n  position: absolute;\n  right: 6%;\n}\n.__vev_calendar-wrapper .arrow-right.icon:before {\n  content: '';\n  position: absolute;\n  right: 1px;\n  top: -5px;\n  width: 10px;\n  height: 10px;\n  border-top: solid 1px currentColor;\n  border-right: solid 1px currentColor;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n.__vev_calendar-wrapper h3,\n.__vev_calendar-wrapper p {\n  margin: 0;\n  padding: 0;\n}\n.lab .is-event {\n  background: #00B4BA !important;\n  background: linear-gradient(-206deg, #00B4BA 0%, #00418A 100%) !important;\n  border: none !important;\n}\n.lab .date-num {\n  color: #fff !important;\n}\n.conversation .is-event {\n  background: #4E6BFD !important;\n  background: linear-gradient(-206deg, #4E6BFD 0%, #9A0EEC 100%) !important;\n  border: none !important;\n}\n.conversation .date-num {\n  color: #fff !important;\n}\n.other .is-event {\n  background: #21A6A6 !important;\n  background: linear-gradient(-206deg, #21A6A6 0%, #A2F095 100%) !important;\n  border: none !important;\n}\n.other .date-num {\n  color: #fff !important;\n}\n.is-today {\n  content: '';\n  border: 1px solid #FF9C00 !important;\n  background-color: #fff;\n  border-radius: 5px;\n  width: 30px;\n  height: 30px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  z-index: 1;\n  margin-left: -15px;\n  margin-top: -15px;\n}\n.wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: baseline;\n      -ms-flex-align: baseline;\n          align-items: baseline;\n  color: #323232;\n  font-size: 14px;\n}\n.wrapper.lab .time,\n.wrapper.lab .title {\n  background: #00B4BA !important;\n  background: linear-gradient(-206deg, #00B4BA 0%, #00418A 100%) !important;\n}\n.wrapper.other .time,\n.wrapper.other .title {\n  background: #21A6A6 !important;\n  background: linear-gradient(-206deg, #21A6A6 0%, #A2F095 100%) !important;\n}\n.wrapper.conversation .time,\n.wrapper.conversation .title {\n  background: #4E6BFD !important;\n  background: linear-gradient(-206deg, #4E6BFD 0%, #9A0EEC 100%) !important;\n}\n.wrapper .time {\n  margin-right: 5px;\n  color: #fff;\n  font-weight: 300;\n  border-radius: 5px;\n  font-size: 12px;\n  line-height: 15px;\n  padding: 5px 15px;\n}\n.wrapper .time p {\n  font-weight: 300;\n}\n.wrapper .title {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  color: #fff;\n  font-weight: 200;\n  border-radius: 5px;\n  padding: 5px 5px 5px 10px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  line-height: 15px;\n}\n.button {\n  margin-top: 20px;\n}\n.events-wrapper button.btn {\n  padding: 10px;\n  outline: none;\n  background: #FFA200;\n  font-weight: 300;\n  font-size: 14px;\n  cursor: pointer;\n  color: #fff;\n  -webkit-transition: .1s;\n  transition: .1s;\n  border: 1px solid transparent;\n  vertical-align: middle;\n  -webkit-appearance: none;\n  border-radius: 50px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  text-align: center;\n}\n.btn-full {\n  width: 100%;\n}\n.wrapper .title {\n  margin-bottom: 0;\n}\n.item {\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.item#alert {\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.item div#msg:nth-child(1) {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: end;\n        -ms-flex-align: end;\n            align-items: flex-end;\n}\n@media (max-width: 440px) {\n.item div#msg:nth-child(1) {\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n}\n}\n.item div#desc:nth-child(2) {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.item div#warn:nth-child(3) {\n    font-weight: 300;\n    text-transform: uppercase;\n    background: linear-gradient(-5deg, #0073b8, #00e7ff) !important;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    border-radius: 300px;\n    color: white;\n    height: 40px !important;\n    margin: 10px 20px 10px 20px;\n}\n.item .boxmsg {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    -ms-flex-preferred-size: 50%;\n        flex-basis: 50%;\n    height: 70px;\n}\n.item .boxmsg h1 {\n      font-size: 25px;\n      font-weight: 400;\n      text-transform: uppercase;\n      color: orange;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.item .boxmsg h1 span {\n        height: 7px;\n        width: 205px;\n        background-color: orange;\n        border-radius: 300px;\n        margin: 0px 10px 0px 0px;\n}\n@media (max-width: 440px) {\n.item .boxmsg h1 span {\n            width: 150px;\n}\n}\n.item .boxmsg h2 {\n      font-size: 35px;\n      font-weight: 400;\n      letter-spacing: -1px;\n      text-transform: uppercase;\n}\n@media (max-width: 440px) {\n.item .boxmsg h2 {\n          font-size: 30px;\n}\n}\n.item .boxmsg h3 {\n      font-size: 15px;\n      font-weight: 200;\n      color: gray;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      padding-right: 25px;\n}\n@media (max-width: 440px) {\n.item .boxmsg h3 {\n          font-size: 13px;\n}\n}\n.item .boxmsg img {\n      width: 70px;\n      margin: 0px 5px 0px 20px;\n}\n@media (max-width: 440px) {\n.item .boxmsg img {\n          margin: 0px 5px 0px 0px;\n}\n}\n.schedule__menu {\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: rgba(19, 0, 0, 0.95);\n  width: 100vw;\n  height: 100%;\n  z-index: 150;\n}\n.schedule__menu__icon {\n    position: absolute;\n    top: 5vh;\n    right: 5vw;\n    height: 60px !important;\n    width: 60px !important;\n    color: #fc7f7f;\n    -webkit-transition: -webkit-transform .2s;\n    transition: -webkit-transform .2s;\n    transition: transform .2s;\n    transition: transform .2s, -webkit-transform .2s;\n    cursor: pointer;\n}\n.schedule__menu__icon:hover {\n      -webkit-transform: scale(1.2) rotate(90deg);\n              transform: scale(1.2) rotate(90deg);\n}\n.show-schedule-enter-active {\n  -webkit-animation: opaque .2s ease backwards;\n          animation: opaque .2s ease backwards;\n  -webkit-animation-delay: .2s;\n          animation-delay: .2s;\n}\n.show-schedule-leave-active {\n  animation: opaque .2s ease reverse backwards;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1287:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(1151);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b0b8db2_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1290);
function injectStyle (ssrContext) {
  __webpack_require__(1288)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b0b8db2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b0b8db2_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1288:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1289);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("0c306ec3", content, true, {});

/***/ }),

/***/ 1289:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".sc[data-v-7b0b8db2]{max-height:570px;max-width:780px;min-height:485px}.sc__box[data-v-7b0b8db2]{-webkit-box-flex:1;-ms-flex:1;flex:1;background-color:#fefefe;border-radius:25px;-ms-flex-item-align:stretch;align-self:stretch}.sc__box__title[data-v-7b0b8db2]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;padding:25px 20px}.sc__box__title h3[data-v-7b0b8db2]{padding:0 100px;text-align:center;color:#1474bc;font-size:30px}.sc__box__title h3 span[data-v-7b0b8db2]{color:#f70;font-weight:400}.sc__box__options[data-v-7b0b8db2]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.sc__box__options button.btn[data-v-7b0b8db2]{background-color:#ff9c00;font-size:22px;padding:10px 25px}.sc__box__options button.btn.active-button[data-v-7b0b8db2]{background-color:#ffce80}.sc__box__items[data-v-7b0b8db2]{-webkit-box-flex:2;-ms-flex-positive:2;flex-grow:2}.sc__box__items__btn[data-v-7b0b8db2]{border-radius:7.25px;background-color:#dfdfdf;margin:20px 0}.sc__box__items__btn.disabled[data-v-7b0b8db2]{cursor:not-allowed;background-color:#efefef;color:#bbb}.sc__box__items__slick[data-v-7b0b8db2]{-webkit-box-pack:stretch;-ms-flex-pack:stretch;justify-content:stretch}.sc__box__items__slick__item[data-v-7b0b8db2]{-ms-flex-preferred-size:25%;flex-basis:25%;width:145px;height:155px}.sc__box__items__slick__item[data-v-7b0b8db2],.sc__box__items__slick__item__content[data-v-7b0b8db2]{-ms-flex-item-align:stretch;align-self:stretch;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.sc__box__items__slick__item__content[data-v-7b0b8db2]{width:100%;background-color:#dfdfdf;border-radius:15px;-webkit-transition:all .2s;transition:all .2s}.sc__box__items__slick__item__content[data-v-7b0b8db2]:active,.sc__box__items__slick__item__content[data-v-7b0b8db2]:hover{cursor:pointer;background-color:#ccc}.sc__box__items__slick__item__content.selected[data-v-7b0b8db2]{background-color:#ffa200}.sc__box__items__slick__item__content.selected .sc__box__items__slick__item__content__line[data-v-7b0b8db2]{background-color:#fff}.sc__box__items__slick__item__content.selected .sc__box__items__slick__item__content__info__date[data-v-7b0b8db2],.sc__box__items__slick__item__content.selected .sc__box__items__slick__item__content__info__date span[data-v-7b0b8db2]{color:#fff}.sc__box__items__slick__item__content__line[data-v-7b0b8db2]{background-color:#3dff8b;-ms-flex-preferred-size:7.5px;flex-basis:7.5px;-ms-flex-item-align:stretch;align-self:stretch;margin:5px 5px 5px 0;height:90%;border-radius:5px}.sc__box__items__slick__item__content__info[data-v-7b0b8db2]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.sc__box__items__slick__item__content__info__date[data-v-7b0b8db2]{font-size:30px;color:#747474}.sc__box__items__slick__item__content__info__date span[data-v-7b0b8db2]{font-size:40px;color:#949494}.sc__box__items__slick__item__content__info__day[data-v-7b0b8db2]{margin-top:6px;font-size:14px;color:#fff;border-radius:10px;background-color:#a95eff;padding:2.5px 7.5px;width:90%;text-align:center}.sc__box__items__slick__item__content__info__time[data-v-7b0b8db2]{margin-top:6px;font-size:14px;color:#ae5100;border-radius:10px;background-color:#ffbe3d;padding:2.5px 7.5px;width:90%;text-align:center}.sc__box__items__content[data-v-7b0b8db2]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.sc__box__items__content__unit[data-v-7b0b8db2]{margin:5px;background-color:#5effc8;color:#055c77;border-radius:15px;font-size:30px;text-transform:uppercase;padding:15px 30px}.sc__box__items__content__unit span[data-v-7b0b8db2]{font-size:14px;font-weight:400}.sc__box__items__content__date[data-v-7b0b8db2]{margin:5px;background-color:#055c77;color:#5effc8;border-radius:15px;font-size:30px;font-weight:300;text-transform:uppercase;padding:15px 30px}.sc__box__items__content__date span[data-v-7b0b8db2]{font-size:14px;font-weight:400}.sc__box__items__content__day__title[data-v-7b0b8db2]{background-color:#a95eff;color:#fff}.sc__box__items__content__day__time[data-v-7b0b8db2],.sc__box__items__content__day__title[data-v-7b0b8db2]{-webkit-box-flex:1;-ms-flex:1;flex:1;border-radius:15px;border-radius:300px;font-weight:300;padding:8px 30px;margin:5px;width:100%}.sc__box__items__content__day__time[data-v-7b0b8db2]{background-color:#ffbe3d;color:#ae5100}.sc__box__items__content__confirmtext[data-v-7b0b8db2]{font-size:18px;padding:35px 150px;text-align:center;font-weight:300;color:#8e8e8e;line-height:30px}.sc__box__feedback[data-v-7b0b8db2]{background:#fa0;width:400px;border-radius:20px;height:120px;position:relative}.sc__box__feedback img[data-v-7b0b8db2]{width:150px;position:absolute}.sc__box__coins[data-v-7b0b8db2]{font-size:18px;color:#7b5710;padding:40px 20px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;font-weight:300}.sc__box__coins span[data-v-7b0b8db2]{font-weight:400}.sc__box__coins img[data-v-7b0b8db2]{width:20px}.sc__box__footer[data-v-7b0b8db2]{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.sc__box__footer button[data-v-7b0b8db2]{font-size:22px;padding:10px 25px}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/scheduleClass/index.vue"],"names":[],"mappings":"AACA,qBACE,iBAAkB,AAClB,gBAAiB,AACjB,gBAAkB,CACnB,AACD,0BACI,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,yBAA0B,AAC1B,mBAAoB,AACpB,4BAA6B,AACzB,kBAAoB,CAC3B,AACD,iCACM,mBAAoB,AAChB,oBAAqB,AACjB,YAAa,AACrB,iBAAmB,CACxB,AACD,oCACQ,gBAAmB,AACnB,kBAAmB,AACnB,cAAe,AACf,cAAgB,CACvB,AACD,yCACU,WAAe,AACf,eAAiB,CAC1B,AACD,mCACM,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CAC1B,AACD,8CACQ,yBAA0B,AAC1B,eAAgB,AAChB,iBAAmB,CAC1B,AACD,4DACU,wBAA0B,CACnC,AACD,iCACM,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CAC1B,AACD,sCACQ,qBAAsB,AACtB,yBAA0B,AAC1B,aAAe,CACtB,AACD,+CACU,mBAAoB,AACpB,yBAA0B,AAC1B,UAAY,CACrB,AACD,wCACQ,yBAA0B,AACtB,sBAAuB,AACnB,uBAAyB,CACxC,AACD,8CACU,4BAA6B,AACzB,eAAgB,AAMpB,YAAa,AACb,YAAc,CACvB,AACD,qGARU,4BAA6B,AACzB,mBAAoB,AACxB,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CAezC,AAXD,uDAGY,WAAY,AACZ,yBAA0B,AAI1B,mBAAoB,AACpB,2BAA4B,AAC5B,kBAAoB,CAC/B,AACD,2HACc,eAAgB,AAChB,qBAAuB,CACpC,AACD,gEACc,wBAA0B,CACvC,AACD,4GACgB,qBAAuB,CACtC,AACD,yOACgB,UAAY,CAC3B,AACD,6DACc,yBAA0B,AAC1B,8BAA+B,AAC3B,iBAAkB,AACtB,4BAA6B,AACzB,mBAAoB,AACxB,qBAAwB,AACxB,WAAY,AACZ,iBAAmB,CAChC,AACD,6DACc,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CAClC,AACD,mEACgB,eAAgB,AAChB,aAAe,CAC9B,AACD,wEACkB,eAAgB,AAChB,aAAe,CAChC,AACD,kEACgB,eAAgB,AAChB,eAAgB,AAChB,WAAY,AACZ,mBAAoB,AACpB,yBAA0B,AAC1B,oBAAqB,AACrB,UAAW,AACX,iBAAmB,CAClC,AACD,mEACgB,eAAgB,AAChB,eAAgB,AAChB,cAAe,AACf,mBAAoB,AACpB,yBAA0B,AAC1B,oBAAqB,AACrB,UAAW,AACX,iBAAmB,CAClC,AACD,0CACQ,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACvC,AACD,gDACU,WAAY,AACZ,yBAA0B,AAC1B,cAAe,AACf,mBAAoB,AACpB,eAAgB,AAChB,yBAA0B,AAC1B,iBAAmB,CAC5B,AACD,qDACY,eAAgB,AAChB,eAAiB,CAC5B,AACD,gDACU,WAAY,AACZ,yBAA0B,AAC1B,cAAe,AACf,mBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,yBAA0B,AAC1B,iBAAmB,CAC5B,AACD,qDACY,eAAgB,AAChB,eAAiB,CAC5B,AACD,sDAIU,yBAA0B,AAC1B,UAAa,CAOtB,AACD,2GAZU,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAGhB,mBAAoB,AACpB,oBAAqB,AACrB,gBAAiB,AACjB,iBAAkB,AAClB,WAAY,AACZ,UAAY,CAcrB,AAZD,qDAIU,yBAA0B,AAC1B,aAAe,CAOxB,AACD,uDACU,eAAgB,AAChB,mBAAoB,AACpB,kBAAmB,AACnB,gBAAiB,AACjB,cAAe,AACf,gBAAkB,CAC3B,AACD,oCACM,gBAAoB,AACpB,YAAa,AACb,mBAAoB,AACpB,aAAc,AACd,iBAAmB,CACxB,AACD,wCACQ,YAAa,AACb,iBAAmB,CAC1B,AACD,iCACM,eAAgB,AAChB,cAAe,AACf,kBAAmB,AACnB,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,eAAiB,CACtB,AACD,sCACQ,eAAiB,CACxB,AACD,qCACQ,UAAY,CACnB,AACD,kCACM,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CAC1B,AACD,yCACQ,eAAgB,AAChB,iBAAmB,CAC1B","file":"index.vue","sourcesContent":["\n.sc[data-v-7b0b8db2] {\n  max-height: 570px;\n  max-width: 780px;\n  min-height: 485px;\n}\n.sc__box[data-v-7b0b8db2] {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1;\n    background-color: #FEFEFE;\n    border-radius: 25px;\n    -ms-flex-item-align: stretch;\n        align-self: stretch;\n}\n.sc__box__title[data-v-7b0b8db2] {\n      -webkit-box-flex: 1;\n          -ms-flex-positive: 1;\n              flex-grow: 1;\n      padding: 25px 20px;\n}\n.sc__box__title h3[data-v-7b0b8db2] {\n        padding: 0px 100px;\n        text-align: center;\n        color: #1474BC;\n        font-size: 30px;\n}\n.sc__box__title h3 span[data-v-7b0b8db2] {\n          color: #FF7700;\n          font-weight: 400;\n}\n.sc__box__options[data-v-7b0b8db2] {\n      -webkit-box-flex: 1;\n          -ms-flex-positive: 1;\n              flex-grow: 1;\n}\n.sc__box__options button.btn[data-v-7b0b8db2] {\n        background-color: #FF9C00;\n        font-size: 22px;\n        padding: 10px 25px;\n}\n.sc__box__options button.btn.active-button[data-v-7b0b8db2] {\n          background-color: #ffce80;\n}\n.sc__box__items[data-v-7b0b8db2] {\n      -webkit-box-flex: 2;\n          -ms-flex-positive: 2;\n              flex-grow: 2;\n}\n.sc__box__items__btn[data-v-7b0b8db2] {\n        border-radius: 7.25px;\n        background-color: #DFDFDF;\n        margin: 20px 0;\n}\n.sc__box__items__btn.disabled[data-v-7b0b8db2] {\n          cursor: not-allowed;\n          background-color: #EFEFEF;\n          color: #BBB;\n}\n.sc__box__items__slick[data-v-7b0b8db2] {\n        -webkit-box-pack: stretch;\n            -ms-flex-pack: stretch;\n                justify-content: stretch;\n}\n.sc__box__items__slick__item[data-v-7b0b8db2] {\n          -ms-flex-preferred-size: 25%;\n              flex-basis: 25%;\n          -ms-flex-item-align: stretch;\n              align-self: stretch;\n          -webkit-box-pack: center;\n              -ms-flex-pack: center;\n                  justify-content: center;\n          width: 145px;\n          height: 155px;\n}\n.sc__box__items__slick__item__content[data-v-7b0b8db2] {\n            -ms-flex-item-align: stretch;\n                align-self: stretch;\n            width: 100%;\n            background-color: #DFDFDF;\n            -webkit-box-pack: center;\n                -ms-flex-pack: center;\n                    justify-content: center;\n            border-radius: 15px;\n            -webkit-transition: all .2s;\n            transition: all .2s;\n}\n.sc__box__items__slick__item__content[data-v-7b0b8db2]:hover, .sc__box__items__slick__item__content[data-v-7b0b8db2]:active {\n              cursor: pointer;\n              background-color: #CCC;\n}\n.sc__box__items__slick__item__content.selected[data-v-7b0b8db2] {\n              background-color: #FFA200;\n}\n.sc__box__items__slick__item__content.selected .sc__box__items__slick__item__content__line[data-v-7b0b8db2] {\n                background-color: #FFF;\n}\n.sc__box__items__slick__item__content.selected .sc__box__items__slick__item__content__info__date[data-v-7b0b8db2], .sc__box__items__slick__item__content.selected .sc__box__items__slick__item__content__info__date span[data-v-7b0b8db2] {\n                color: #FFF;\n}\n.sc__box__items__slick__item__content__line[data-v-7b0b8db2] {\n              background-color: #3DFF8B;\n              -ms-flex-preferred-size: 7.5px;\n                  flex-basis: 7.5px;\n              -ms-flex-item-align: stretch;\n                  align-self: stretch;\n              margin: 5px 5px 5px 0px;\n              height: 90%;\n              border-radius: 5px;\n}\n.sc__box__items__slick__item__content__info[data-v-7b0b8db2] {\n              -webkit-box-flex: 1;\n                  -ms-flex-positive: 1;\n                      flex-grow: 1;\n}\n.sc__box__items__slick__item__content__info__date[data-v-7b0b8db2] {\n                font-size: 30px;\n                color: #747474;\n}\n.sc__box__items__slick__item__content__info__date span[data-v-7b0b8db2] {\n                  font-size: 40px;\n                  color: #949494;\n}\n.sc__box__items__slick__item__content__info__day[data-v-7b0b8db2] {\n                margin-top: 6px;\n                font-size: 14px;\n                color: #FFF;\n                border-radius: 10px;\n                background-color: #A95EFF;\n                padding: 2.5px 7.5px;\n                width: 90%;\n                text-align: center;\n}\n.sc__box__items__slick__item__content__info__time[data-v-7b0b8db2] {\n                margin-top: 6px;\n                font-size: 14px;\n                color: #AE5100;\n                border-radius: 10px;\n                background-color: #FFBE3D;\n                padding: 2.5px 7.5px;\n                width: 90%;\n                text-align: center;\n}\n.sc__box__items__content[data-v-7b0b8db2] {\n        -webkit-box-pack: center;\n            -ms-flex-pack: center;\n                justify-content: center;\n}\n.sc__box__items__content__unit[data-v-7b0b8db2] {\n          margin: 5px;\n          background-color: #5EFFC8;\n          color: #055C77;\n          border-radius: 15px;\n          font-size: 30px;\n          text-transform: uppercase;\n          padding: 15px 30px;\n}\n.sc__box__items__content__unit span[data-v-7b0b8db2] {\n            font-size: 14px;\n            font-weight: 400;\n}\n.sc__box__items__content__date[data-v-7b0b8db2] {\n          margin: 5px;\n          background-color: #055C77;\n          color: #5EFFC8;\n          border-radius: 15px;\n          font-size: 30px;\n          font-weight: 300;\n          text-transform: uppercase;\n          padding: 15px 30px;\n}\n.sc__box__items__content__date span[data-v-7b0b8db2] {\n            font-size: 14px;\n            font-weight: 400;\n}\n.sc__box__items__content__day__title[data-v-7b0b8db2] {\n          -webkit-box-flex: 1;\n              -ms-flex: 1;\n                  flex: 1;\n          background-color: #A95EFF;\n          color: white;\n          border-radius: 15px;\n          border-radius: 300px;\n          font-weight: 300;\n          padding: 8px 30px;\n          margin: 5px;\n          width: 100%;\n}\n.sc__box__items__content__day__time[data-v-7b0b8db2] {\n          -webkit-box-flex: 1;\n              -ms-flex: 1;\n                  flex: 1;\n          background-color: #FFBE3D;\n          color: #AE5100;\n          border-radius: 15px;\n          border-radius: 300px;\n          font-weight: 300;\n          padding: 8px 30px;\n          margin: 5px;\n          width: 100%;\n}\n.sc__box__items__content__confirmtext[data-v-7b0b8db2] {\n          font-size: 18px;\n          padding: 35px 150px;\n          text-align: center;\n          font-weight: 300;\n          color: #8e8e8e;\n          line-height: 30px;\n}\n.sc__box__feedback[data-v-7b0b8db2] {\n      background: #FFAA00;\n      width: 400px;\n      border-radius: 20px;\n      height: 120px;\n      position: relative;\n}\n.sc__box__feedback img[data-v-7b0b8db2] {\n        width: 150px;\n        position: absolute;\n}\n.sc__box__coins[data-v-7b0b8db2] {\n      font-size: 18px;\n      color: #7B5710;\n      padding: 40px 20px;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      font-weight: 300;\n}\n.sc__box__coins span[data-v-7b0b8db2] {\n        font-weight: 400;\n}\n.sc__box__coins img[data-v-7b0b8db2] {\n        width: 20px;\n}\n.sc__box__footer[data-v-7b0b8db2] {\n      -webkit-box-flex: 1;\n          -ms-flex-positive: 1;\n              flex-grow: 1;\n}\n.sc__box__footer button[data-v-7b0b8db2] {\n        font-size: 22px;\n        padding: 10px 25px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc container",on:{"click":function($event){$event.stopPropagation();}}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.step === 0)?_c('div',{staticClass:"sc__box full-width full-height padding-20 container column justify-center align-center"},[_c('div',{staticClass:"sc__box__title align-center"},[_c('h3',[_vm._v("Por favor, escolha o dia para agendar sua "),_c('span',[_vm._v(_vm._s((_vm.isComplementary ? _vm.lessons[_vm.nextIndex] : _vm.currentClass).lesson_name))])])]),_vm._v(" "),((_vm.currentClass && _vm.currentClass.type == 'U') && !_vm.toReview.length)?_c('div',{staticClass:"sc__box__options align-center"},[_c('button',{staticClass:"btn btn-full btn-rounded margin-right-10",class:{ 'active-button': !_vm.isComplementary },attrs:{"type":"button","name":"button"},on:{"click":function($event){return _vm.setComplementary(false)}}},[_vm._v(_vm._s(_vm.currentClass.lesson_name))]),_vm._v(" "),_c('button',{staticClass:"btn btn-full btn-rounded",class:{ 'active-button': _vm.isComplementary },attrs:{"type":"button","name":"button"},on:{"click":function($event){return _vm.setComplementary(true)}}},[_vm._v(_vm._s(_vm.lessons[_vm.nextIndex].lesson_name))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"sc__box__items container"},[_c('div',{staticClass:"sc__box__items__btn container justify-center align-center padding-10",class:{ disabled: !_vm.allowBack },on:{"click":function($event){return _vm.prevPage()}}},[_c('font-awesome-icon',{attrs:{"icon":"caret-left"}})],1),_vm._v(" "),_c('div',{staticClass:"sc__box__items__slick container wrap align-center padding-10"},_vm._l((_vm.schedule),function(s,index){return _c('div',{key:index,staticClass:"sc__box__items__slick__item padding-10 container align-center",on:{"click":function($event){return _vm.setSchedule(s)}}},[_c('div',{staticClass:"sc__box__items__slick__item__content padding-10 container align-center",class:{ selected: (!!_vm.toSchedule && (_vm.toSchedule.class_id == s.class_id) && !!s.date) }},[_c('div',{staticClass:"sc__box__items__slick__item__content__line"}),_vm._v(" "),_c('div',{staticClass:"sc__box__items__slick__item__content__info container column align-center"},[_c('div',{staticClass:"sc__box__items__slick__item__content__info__date"},[_c('span',[_vm._v(_vm._s(_vm.getDate(s.date).day))]),_vm._v("/"+_vm._s(_vm.getDate(s.date).month)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"sc__box__items__slick__item__content__info__day"},[_vm._v("\n                  "+_vm._s(_vm.getDay(s.date))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"sc__box__items__slick__item__content__info__time"},[_vm._v("\n                  "+_vm._s(_vm.getTime(s.date))+"\n                ")])])])])}),0),_vm._v(" "),_c('div',{staticClass:"sc__box__items__btn container justify-center align-center padding-10",class:{ disabled: !_vm.allowNext },on:{"click":function($event){return _vm.nextPage()}}},[_c('font-awesome-icon',{attrs:{"icon":"caret-right"}})],1)]),_vm._v(" "),_c('div',{staticClass:"sc__box__footer container align-center margin-10"},[_c('button',{staticClass:"btn btn-full btn-gradient-red btn-rounded margin-right-10",staticStyle:{"width":"200px"},attrs:{"type":"button","name":"button"},on:{"click":function($event){return _vm.close()}}},[_vm._v("Close")]),_vm._v(" "),_c('button',{staticClass:"btn btn-full btn-gradient-green btn-rounded",class:{ disabled: !_vm.toSchedule },staticStyle:{"width":"200px"},attrs:{"type":"button","name":"button","disabled":!_vm.toSchedule},on:{"click":function($event){return _vm.nextStep()}}},[_vm._v("Next")])])]):(_vm.step === 1)?_c('div',{staticClass:"sc__box full-width full-height padding-20 container column justify-center align-center padding-20"},[_c('div',{staticClass:"sc__box__title"},[_c('h3',[_c('span',[_vm._v("CONFIRM")]),_vm._v(" YOUR CLASS")])]),_vm._v(" "),_c('div',{staticClass:"sc__box__items container column padding-10"},[_c('div',{staticClass:"sc__box__items__content container align-center"},[_c('div',{staticClass:"sc__box__items__content__unit container column align-center justify-center"},[_c('span',[_vm._v("class")]),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s((_vm.isComplementary ? _vm.lessons[_vm.nextIndex] : _vm.currentClass).lesson_name)+" ")])]),_vm._v(" "),_c('div',{staticClass:"sc__box__items__content__date container column align-center justify-center"},[_c('span',[_vm._v("Day")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.getDate(_vm.toSchedule.date).day)+"/"+_vm._s(_vm.getDate(_vm.toSchedule.date).month))])]),_vm._v(" "),_c('div',{staticClass:"sc__box__items__content__day container column align-center justify-center margin-left-10"},[_c('div',{staticClass:"sc__box__items__content__day__title justify-center align-center"},[_vm._v("\n              "+_vm._s(_vm.getDay(_vm.toSchedule.date))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"sc__box__items__content__day__time justify-center align-center"},[_vm._v("\n              "+_vm._s(_vm.getTime(_vm.toSchedule.date))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"sc__box__items__content__confirmtext"},[_vm._v("\n          You Scheduled a class, day "+_vm._s(_vm.getDate(_vm.toSchedule.date).day)+", of "+_vm._s(_vm.getMonth(_vm.toSchedule.date))+", for "+_vm._s((_vm.isComplementary ? _vm.lessons[_vm.nextIndex] : _vm.currentClass).lesson_name)+". Is this information correct?\n        ")])]),_vm._v(" "),_c('div',{staticClass:"sc__box__footer align-center"},[_c('button',{staticClass:"btn btn-full btn-gradient-red btn-rounded margin-right-10",staticStyle:{"width":"200px"},attrs:{"type":"button","name":"button"},on:{"click":function($event){return _vm.close()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"btn btn-full btn-gradient-green btn-rounded",staticStyle:{"width":"200px"},attrs:{"type":"button","name":"button"},on:{"click":function($event){return _vm.confirmSchedule()}}},[_vm._v("Confirm")])])]):(_vm.step === 2)?_c('div',{staticClass:"sc__box full-width full-height padding-20 container column justify-center align-center padding-20"},[_c('div',{staticClass:"sc__box__title"},[(!_vm.error)?_c('h3',[_vm._v("YOUR CLASS WAS SCHEDULED "),_c('span',[_vm._v("SUCCESSFULLY")])]):_c('h3',[_vm._v("SCHEDULING "),_c('span',[_vm._v("FAILED")])])]),_vm._v(" "),_c('div',{staticClass:"sc__box__items container column justify-center align-center padding-10"},[_c('div',{staticClass:"sc__box__feedback justify-center align-center"},[(!_vm.error)?_c('img',{attrs:{"src":__webpack_require__(656),"alt":"Check"}}):_c('img',{attrs:{"src":__webpack_require__(195),"alt":"Cancel"}})]),_vm._v(" "),_c('div',{staticClass:"sc__box__coins justify-center align-center"},[_c('img',{attrs:{"src":__webpack_require__(679),"alt":"Check"}}),_vm._v(" "),(!_vm.error)?_c('p',[_vm._v("You won "),_c('span',[_vm._v("3 coin")])]):_c('p',[_c('strong',[_vm._v(_vm._s(_vm.error.message || 'Failed to schedule class'))])])])]),_vm._v(" "),_c('div',{staticClass:"sc__box__footer align-center"},[_c('button',{staticClass:"btn btn-full btn-gradient-red btn-rounded",staticStyle:{"width":"200px"},attrs:{"type":"button","name":"button"},on:{"click":function($event){return _vm.close()}}},[_vm._v("CLOSE")])])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.hasBook && _vm.hasUnits)?_c('div',{staticClass:"margin-page box-content shadow-box hidden animation-bottom animation-delay-01 container column"},[_c('titleComponent',{attrs:{"mark":("book " + (_vm.currentBook.title.replace('Book ', '').toLowerCase())),"value":"<b>UNIDADE</b> ATUAL","color":"background-red","button":"Exibir todas unidades","showTimer":true,"showOnlineClass":_vm.student.test_mode}}),_vm._v(" "),_c('currentUnit',{attrs:{"data":_vm.currentUnit}})],1):(_vm.hasBook && !_vm.hasUnits)?_c('div',{staticClass:"box-content shadow-box hidden animation-bottom animation-delay-01 container justify-content-center color-red"},[_vm._m(0)]):(!_vm.hasBook && !_vm.hasUnits)?_c('div',{staticClass:"box-content shadow-box hidden animation-bottom animation-delay-01 container justify-content-center color-red"},[_c('div',{staticClass:"container item full-width",attrs:{"id":"alert"}},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"boxmsg",staticStyle:{"cursor":"pointer"},attrs:{"id":"warn"},on:{"click":function($event){return _vm.$router.push({ name: 'books' })}}},[_vm._v("Add your first book")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"box-content shadow-box hidden animation-bottom animation-delay-02"},[_c('titleComponent',{attrs:{"mark":"Presencial","value":"<b>PRÓXIMA</b> AULA","color":"background-orange container column","calendar":true,"titleBtn":!_vm.isClassScheduled,"btnAction":function () { return _vm.showSchedule = true; }}}),_vm._v(" "),_c('vue-event-calendar',{attrs:{"events":_vm.classes,"local":_vm.locale},on:{"day-changed":_vm.handleDayChanged,"month-changed":_vm.handleMonthChanged}})],1),_vm._v(" "),_c('transition',{attrs:{"name":"show-schedule"}},[(_vm.showSchedule)?_c('div',{staticClass:"schedule__menu padding-20 container justify-center align-center",on:{"click":function($event){_vm.showSchedule = false}}},[_c('font-awesome-icon',{staticClass:"schedule__menu__icon",attrs:{"icon":"times"},on:{"click":function($event){_vm.showSchedule = false}}}),_vm._v(" "),_c('scheduleClass',{attrs:{"close":function () { return _vm.showSchedule = false; }}})],1):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('h3',[_vm._v("No Units in Library :(")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxmsg",attrs:{"id":"msg"}},[_c('h1',[_c('span'),_vm._v(" Attention!")]),_vm._v(" "),_c('h2',[_vm._v("No Books in Library!")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxmsg",attrs:{"id":"desc"}},[_c('img',{attrs:{"src":__webpack_require__(762),"height":"60px","alt":"Attention"}}),_vm._v(" "),_c('h3',{staticClass:"container"},[_vm._v("Você ainda não possui nenhum conteúdo cadastrado. Adicione usando o token impresso na capa do livro.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 587:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(1150);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_084b96ad_hasScoped_false_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1291);
function injectStyle (ssrContext) {
  __webpack_require__(1285)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_084b96ad_hasScoped_false_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 656:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 664:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'metaPercentage',
  data: function data() {
    return {};
  },

  props: {
    percentage: {
      type: String
    },
    borderRadius: {
      type: String,
      default: '20'
    },
    height: {
      type: String,
      default: '10'
    }
  }
});

/***/ }),

/***/ 665:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


//

// Check if the request came from the browser and is not server rendered
if (typeof window !== 'undefined') {
  Promise.resolve().then(function () { return slick$1; });
}

var script = {
  props: {
    options: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },

  mounted: function() {
    this.create();
  },

  destroyed: function() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('unslick');
  },

  methods: {
    create: function() {
      var $slick = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el);

      $slick.on('afterChange', this.onAfterChange);
      $slick.on('beforeChange', this.onBeforeChange);
      $slick.on('breakpoint', this.onBreakpoint);
      $slick.on('destroy', this.onDestroy);
      $slick.on('edge', this.onEdge);
      $slick.on('init', this.onInit);
      $slick.on('reInit', this.onReInit);
      $slick.on('setPosition', this.onSetPosition);
      $slick.on('swipe', this.onSwipe);
      $slick.on('lazyLoaded', this.onLazyLoaded);
      $slick.on('lazyLoadError', this.onLazyLoadError);

      $slick.slick(this.options);
    },

    destroy: function() {
      var $slick = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el);

      $slick.off('afterChange', this.onAfterChange);
      $slick.off('beforeChange', this.onBeforeChange);
      $slick.off('breakpoint', this.onBreakpoint);
      $slick.off('destroy', this.onDestroy);
      $slick.off('edge', this.onEdge);
      $slick.off('init', this.onInit);
      $slick.off('reInit', this.onReInit);
      $slick.off('setPosition', this.onSetPosition);
      $slick.off('swipe', this.onSwipe);
      $slick.off('lazyLoaded', this.onLazyLoaded);
      $slick.off('lazyLoadError', this.onLazyLoadError);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('unslick');
    },

    reSlick: function() {
      this.destroy();
      this.create();
    },

    next: function() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('slickNext');
    },

    prev: function() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('slickPrev');
    },

    pause: function() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('slickPause');
    },

    play: function() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('slickPlay');
    },

    goTo: function(index, dontAnimate) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('slickGoTo', index, dontAnimate);
    },

    currentSlide: function() {
      return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('slickCurrentSlide');
    },

    add: function(element, index, addBefore) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('slickAdd', element, index, addBefore);
    },

    remove: function(index, removeBefore) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('slickRemove', index, removeBefore);
    },

    filter: function(filterData) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('slickFilter', filterData);
    },

    unfilter: function() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('slickUnfilter');
    },

    getOption: function(option) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('slickGetOption', option);
    },

    setOption: function(option, value, refresh) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('slickSetOption', option, value, refresh);
    },

    setPosition: function() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.$el).slick('setPosition');
    },

    // Events
    onAfterChange: function(event, slick, currentSlide) {
      this.$emit('afterChange', event, slick, currentSlide);
    },

    onBeforeChange: function(event, slick, currentSlide, nextSlide) {
      this.$emit('beforeChange', event, slick, currentSlide, nextSlide);
    },

    onBreakpoint: function(event, slick, breakpoint) {
      this.$emit('breakpoint', event, slick, breakpoint);
    },

    onDestroy: function(event, slick) {
      this.$emit('destroy', event, slick);
    },

    onEdge: function(event, slick, direction) {
      this.$emit('edge', event, slick, direction);
    },

    onInit: function(event, slick) {
      this.$emit('init', event, slick);
    },

    onReInit: function(event, slick) {
      this.$emit('reInit', event, slick);
    },

    onSetPosition: function(event, slick) {
      this.$emit('setPosition', event, slick);
    },

    onSwipe: function(event, slick, direction) {
      this.$emit('swipe', event, slick, direction);
    },

    onLazyLoaded: function(event, slick, image, imageSource) {
      this.$emit('lazyLoaded', event, slick, image, imageSource);
    },

    onLazyLoadError: function(event, slick, image, imageSource) {
      this.$emit('lazyLoadError', event, slick, image, imageSource);
    },
  },

};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [_vm._t("default")], 2)
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Slick = normalizeComponent_1(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

var install = function installMyComponent(Vue, opt) {
  // Don't install if already installed, or SSR
  if (install.installed || Vue.prototype.$isServer) { return }
  install.installed = true;

  Vue.component('slick', Slick);
};

// Inject install function into component - allows component
// to be registered via Vue.use() as well as Vue.component()
Slick.install = install;

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var slick = createCommonjsModule(function (module, exports) {
(function(factory) {
    {
        module.exports = factory(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a);
    }

}(function($$$1) {
    var Slick = window.Slick || {};

    Slick = (function() {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this, dataSettings;

            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $$$1(element),
                appendDots: $$$1(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function(slider, i) {
                    return $$$1('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                focusOnChange: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $$$1.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $$$1(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $$$1(element).data('slick') || {};

            _.options = $$$1.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $$$1.proxy(_.autoPlay, _);
            _.autoPlayClear = $$$1.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $$$1.proxy(_.autoPlayIterator, _);
            _.changeSlide = $$$1.proxy(_.changeSlide, _);
            _.clickHandler = $$$1.proxy(_.clickHandler, _);
            _.selectHandler = $$$1.proxy(_.selectHandler, _);
            _.setPosition = $$$1.proxy(_.setPosition, _);
            _.swipeHandler = $$$1.proxy(_.swipeHandler, _);
            _.dragHandler = $$$1.proxy(_.dragHandler, _);
            _.keyHandler = $$$1.proxy(_.keyHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;


            _.registerBreakpoints();
            _.init(true);

        }

        return Slick;

    }());

    Slick.prototype.activateADA = function() {
        var _ = this;

        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });

    };

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || (index >= _.slideCount)) {
            return false;
        }

        _.unload();

        if (typeof(index) === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $$$1(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $$$1(markup).insertBefore(_.$slides.eq(index));
            } else {
                $$$1(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $$$1(markup).prependTo(_.$slideTrack);
            } else {
                $$$1(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function(index, element) {
            $$$1(element).attr('data-slick-index', index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function(targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }

        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -(_.currentLeft);
                }
                $$$1({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' +
                                now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' +
                                now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });

            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function() {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }

            }

        }

    };

    Slick.prototype.getNavTarget = function() {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if ( asNavFor && asNavFor !== null ) {
            asNavFor = $$$1(asNavFor).not(_.$slider);
        }

        return asNavFor;

    };

    Slick.prototype.asNavFor = function(index) {

        var _ = this,
            asNavFor = _.getNavTarget();

        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
            asNavFor.each(function() {
                var target = $$$1(this).slick('getSlick');
                if(!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }

    };

    Slick.prototype.applyTransition = function(slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.autoPlay = function() {

        var _ = this;

        _.autoPlayClear();

        if ( _.slideCount > _.options.slidesToShow ) {
            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
        }

    };

    Slick.prototype.autoPlayClear = function() {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }

    };

    Slick.prototype.autoPlayIterator = function() {

        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

        if ( !_.paused && !_.interrupted && !_.focussed ) {

            if ( _.options.infinite === false ) {

                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
                    _.direction = 0;
                }

                else if ( _.direction === 0 ) {

                    slideTo = _.currentSlide - _.options.slidesToScroll;

                    if ( _.currentSlide - 1 === 0 ) {
                        _.direction = 1;
                    }

                }

            }

            _.slideHandler( slideTo );

        }

    };

    Slick.prototype.buildArrows = function() {

        var _ = this;

        if (_.options.arrows === true ) {

            _.$prevArrow = $$$1(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $$$1(_.options.nextArrow).addClass('slick-arrow');

            if( _.slideCount > _.options.slidesToShow ) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow
                        .addClass('slick-disabled')
                        .attr('aria-disabled', 'true');
                }

            } else {

                _.$prevArrow.add( _.$nextArrow )

                    .addClass('slick-hidden')
                    .attr({
                        'aria-disabled': 'true',
                        'tabindex': '-1'
                    });

            }

        }

    };

    Slick.prototype.buildDots = function() {

        var _ = this,
            i, dot;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$slider.addClass('slick-dotted');

            dot = $$$1('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($$$1('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active');

        }

    };

    Slick.prototype.buildOut = function() {

        var _ = this;

        _.$slides =
            _.$slider
                .children( _.options.slide + ':not(.slick-cloned)')
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function(index, element) {
            $$$1(element)
                .attr('data-slick-index', index)
                .data('originalStyling', $$$1(element).attr('style') || '');
        });

        _.$slider.addClass('slick-slider');

        _.$slideTrack = (_.slideCount === 0) ?
            $$$1('<div class="slick-track"/>').appendTo(_.$slider) :
            _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap(
            '<div class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $$$1('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();


        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }

    };

    Slick.prototype.buildRows = function() {

        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if(_.options.rows > 0) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(
                originalSlides.length / slidesPerSection
            );

            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++) {
                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children()
                .css({
                    'width':(100 / _.options.slidesPerRow) + '%',
                    'display': 'inline-block'
                });

        }

    };

    Slick.prototype.checkResponsive = function(initial, forceUpdate) {

        var _ = this,
            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $$$1(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if ( _.options.responsive &&
            _.options.responsive.length &&
            _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint =
                            targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $$$1.extend({}, _.originalSettings,
                                _.breakpointSettings[
                                    targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $$$1.extend({}, _.originalSettings,
                            _.breakpointSettings[
                                targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if( !initial && triggerBreakpoint !== false ) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }

    };

    Slick.prototype.changeSlide = function(event, dontAnimate) {

        var _ = this,
            $target = $$$1(event.currentTarget),
            indexOffset, slideOffset, unevenOffset;

        // If target is a link, prevent default action.
        if($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if(!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 :
                    event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }

    };

    Slick.prototype.checkNavigable = function(index) {

        var _ = this,
            navigables, prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function() {

        var _ = this;

        if (_.options.dots && _.$dots !== null) {

            $$$1('li', _.$dots)
                .off('click.slick', _.changeSlide)
                .off('mouseenter.slick', $$$1.proxy(_.interrupt, _, true))
                .off('mouseleave.slick', $$$1.proxy(_.interrupt, _, false));

            if (_.options.accessibility === true) {
                _.$dots.off('keydown.slick', _.keyHandler);
            }
        }

        _.$slider.off('focus.slick blur.slick');

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
            }
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $$$1(document).off(_.visibilityChange, _.visibility);

        _.cleanUpSlideEvents();

        if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $$$1(_.$slideTrack).children().off('click.slick', _.selectHandler);
        }

        $$$1(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $$$1(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $$$1('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $$$1(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);

    };

    Slick.prototype.cleanUpSlideEvents = function() {

        var _ = this;

        _.$list.off('mouseenter.slick', $$$1.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $$$1.proxy(_.interrupt, _, false));

    };

    Slick.prototype.cleanUpRows = function() {

        var _ = this, originalSlides;

        if(_.options.rows > 0) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }

    };

    Slick.prototype.clickHandler = function(event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }

    };

    Slick.prototype.destroy = function(refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $$$1('.slick-cloned', _.$slider).detach();

        if (_.$dots) {
            _.$dots.remove();
        }

        if ( _.$prevArrow && _.$prevArrow.length ) {

            _.$prevArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.prevArrow )) {
                _.$prevArrow.remove();
            }
        }

        if ( _.$nextArrow && _.$nextArrow.length ) {

            _.$nextArrow
                .removeClass('slick-disabled slick-arrow slick-hidden')
                .removeAttr('aria-hidden aria-disabled tabindex')
                .css('display','');

            if ( _.htmlExpr.test( _.options.nextArrow )) {
                _.$nextArrow.remove();
            }
        }


        if (_.$slides) {

            _.$slides
                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
                .removeAttr('aria-hidden')
                .removeAttr('data-slick-index')
                .each(function(){
                    $$$1(this).attr('style', $$$1(this).data('originalStyling'));
                });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');

        _.unslicked = true;

        if(!refresh) {
            _.$slider.trigger('destroy', [_]);
        }

    };

    Slick.prototype.disableTransition = function(slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }

    };

    Slick.prototype.fadeSlide = function(slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function() {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }

        }

    };

    Slick.prototype.fadeSlideOut = function(slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);

        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });

        }

    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.focusHandler = function() {

        var _ = this;

        _.$slider
            .off('focus.slick blur.slick')
            .on('focus.slick blur.slick', '*', function(event) {

            event.stopImmediatePropagation();
            var $sf = $$$1(this);

            setTimeout(function() {

                if( _.options.pauseOnFocus ) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }

            }, 0);

        });
    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {

        var _ = this;
        return _.currentSlide;

    };

    Slick.prototype.getDotCount = function() {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) {
                 ++pagerQty;
            } else {
                while (breakPoint < _.slideCount) {
                    ++pagerQty;
                    breakPoint = counter + _.options.slidesToScroll;
                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
                }
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if(!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        }else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;

    };

    Slick.prototype.getLeft = function(slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide,
            coef;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
                coef = -1;

                if (_.options.vertical === true && _.options.centerMode === true) {
                    if (_.options.slidesToShow === 2) {
                        coef = -1.5;
                    } else if (_.options.slidesToShow === 1) {
                        coef = -2;
                    }
                }
                verticalOffset = (verticalHeight * _.options.slidesToShow) * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
                    } else {
                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
            _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
        } else if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
        } else {
            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft =  0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft =  0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;

    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {

        var _ = this;

        return _.options[option];

    };

    Slick.prototype.getNavigableIndexes = function() {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;

    };

    Slick.prototype.getSlick = function() {

        return this;

    };

    Slick.prototype.getSlideCount = function() {

        var _ = this,
            slidesTraversed, swipedSlide, centerOffset;

        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + ($$$1(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($$$1(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;

        } else {
            return _.options.slidesToScroll;
        }

    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);

    };

    Slick.prototype.init = function(creation) {

        var _ = this;

        if (!$$$1(_.$slider).hasClass('slick-initialized')) {

            $$$1(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();

        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if (_.options.accessibility === true) {
            _.initADA();
        }

        if ( _.options.autoplay ) {

            _.paused = false;
            _.autoPlay();

        }

    };

    Slick.prototype.initADA = function() {
        var _ = this,
                numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
                tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
                    return (val >= 0) && (val < _.slideCount);
                });

        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });

        if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);

                $$$1(this).attr({
                    'role': 'tabpanel',
                    'id': 'slick-slide' + _.instanceUid + i,
                    'tabindex': -1
                });

                if (slideControlIndex !== -1) {
                   var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex;
                   if ($$$1('#' + ariaButtonControl).length) {
                     $$$1(this).attr({
                         'aria-describedby': ariaButtonControl
                     });
                   }
                }
            });

            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                var mappedSlideIndex = tabControlIndexes[i];

                $$$1(this).attr({
                    'role': 'presentation'
                });

                $$$1(this).find('button').first().attr({
                    'role': 'tab',
                    'id': 'slick-slide-control' + _.instanceUid + i,
                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                    'aria-label': (i + 1) + ' of ' + numDotGroups,
                    'aria-selected': null,
                    'tabindex': '-1'
                });

            }).eq(_.currentSlide).find('button').attr({
                'aria-selected': 'true',
                'tabindex': '0'
            }).end();
        }

        for (var i=_.currentSlide, max=i+_.options.slidesToShow; i < max; i++) {
          if (_.options.focusOnChange) {
            _.$slides.eq(i).attr({'tabindex': '0'});
          } else {
            _.$slides.eq(i).removeAttr('tabindex');
          }
        }

        _.activateADA();

    };

    Slick.prototype.initArrowEvents = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'previous'
               }, _.changeSlide);
            _.$nextArrow
               .off('click.slick')
               .on('click.slick', {
                    message: 'next'
               }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow.on('keydown.slick', _.keyHandler);
                _.$nextArrow.on('keydown.slick', _.keyHandler);
            }
        }

    };

    Slick.prototype.initDotEvents = function() {

        var _ = this;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $$$1('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$dots.on('keydown.slick', _.keyHandler);
            }
        }

        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {

            $$$1('li', _.$dots)
                .on('mouseenter.slick', $$$1.proxy(_.interrupt, _, true))
                .on('mouseleave.slick', $$$1.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initSlideEvents = function() {

        var _ = this;

        if ( _.options.pauseOnHover ) {

            _.$list.on('mouseenter.slick', $$$1.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $$$1.proxy(_.interrupt, _, false));

        }

    };

    Slick.prototype.initializeEvents = function() {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();
        _.initSlideEvents();

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $$$1(document).on(_.visibilityChange, $$$1.proxy(_.visibility, _));

        if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $$$1(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        $$$1(window).on('orientationchange.slick.slick-' + _.instanceUid, $$$1.proxy(_.orientationChange, _));

        $$$1(window).on('resize.slick.slick-' + _.instanceUid, $$$1.proxy(_.resize, _));

        $$$1('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $$$1(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $$$1(_.setPosition);

    };

    Slick.prototype.initUI = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();

        }

    };

    Slick.prototype.keyHandler = function(event) {

        var _ = this;
         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'next' :  'previous'
                    }
                });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'previous' : 'next'
                    }
                });
            }
        }

    };

    Slick.prototype.lazyLoad = function() {

        var _ = this,
            loadRange, cloneRange, rangeStart, rangeEnd;

        function loadImages(imagesScope) {

            $$$1('img[data-lazy]', imagesScope).each(function() {

                var image = $$$1(this),
                    imageSource = $$$1(this).attr('data-lazy'),
                    imageSrcSet = $$$1(this).attr('data-srcset'),
                    imageSizes  = $$$1(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function() {

                    image
                        .animate({ opacity: 0 }, 100, function() {

                            if (imageSrcSet) {
                                image
                                    .attr('srcset', imageSrcSet );

                                if (imageSizes) {
                                    image
                                        .attr('sizes', imageSizes );
                                }
                            }

                            image
                                .attr('src', imageSource)
                                .animate({ opacity: 1 }, 200, function() {
                                    image
                                        .removeAttr('data-lazy data-srcset data-sizes')
                                        .removeClass('slick-loading');
                                });
                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                        });

                };

                imageToLoad.onerror = function() {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                };

                imageToLoad.src = imageSource;

            });

        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) { rangeStart--; }
                if (rangeEnd <= _.slideCount) { rangeEnd++; }
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

        if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1,
                nextSlide = rangeEnd,
                $slides = _.$slider.find('.slick-slide');

            for (var i = 0; i < _.options.slidesToScroll; i++) {
                if (prevSlide < 0) { prevSlide = _.slideCount - 1; }
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }

        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else
        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }

    };

    Slick.prototype.loadSlider = function() {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }

    };

    Slick.prototype.next = Slick.prototype.slickNext = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });

    };

    Slick.prototype.orientationChange = function() {

        var _ = this;

        _.checkResponsive();
        _.setPosition();

    };

    Slick.prototype.pause = Slick.prototype.slickPause = function() {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;

    };

    Slick.prototype.play = Slick.prototype.slickPlay = function() {

        var _ = this;

        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;

    };

    Slick.prototype.postSlide = function(index) {

        var _ = this;

        if( !_.unslicked ) {

            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            if (_.slideCount > _.options.slidesToShow) {
                _.setPosition();
            }

            _.swipeLeft = null;

            if ( _.options.autoplay ) {
                _.autoPlay();
            }

            if (_.options.accessibility === true) {
                _.initADA();

                if (_.options.focusOnChange) {
                    var $currentSlide = $$$1(_.$slides.get(_.currentSlide));
                    $currentSlide.attr('tabindex', 0).focus();
                }
            }

        }

    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function() {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });

    };

    Slick.prototype.preventDefault = function(event) {

        event.preventDefault();

    };

    Slick.prototype.progressiveLazyLoad = function( tryCount ) {

        tryCount = tryCount || 1;

        var _ = this,
            $imgsToLoad = $$$1( 'img[data-lazy]', _.$slider ),
            image,
            imageSource,
            imageSrcSet,
            imageSizes,
            imageToLoad;

        if ( $imgsToLoad.length ) {

            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageSrcSet = image.attr('data-srcset');
            imageSizes  = image.attr('data-sizes') || _.$slider.attr('data-sizes');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function() {

                if (imageSrcSet) {
                    image
                        .attr('srcset', imageSrcSet );

                    if (imageSizes) {
                        image
                            .attr('sizes', imageSizes );
                    }
                }

                image
                    .attr( 'src', imageSource )
                    .removeAttr('data-lazy data-srcset data-sizes')
                    .removeClass('slick-loading');

                if ( _.options.adaptiveHeight === true ) {
                    _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
                _.progressiveLazyLoad();

            };

            imageToLoad.onerror = function() {

                if ( tryCount < 3 ) {

                    /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */
                    setTimeout( function() {
                        _.progressiveLazyLoad( tryCount + 1 );
                    }, 500 );

                } else {

                    image
                        .removeAttr( 'data-lazy' )
                        .removeClass( 'slick-loading' )
                        .addClass( 'slick-lazyload-error' );

                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);

                    _.progressiveLazyLoad();

                }

            };

            imageToLoad.src = imageSource;

        } else {

            _.$slider.trigger('allImagesLoaded', [ _ ]);

        }

    };

    Slick.prototype.refresh = function( initializing ) {

        var _ = this, currentSlide, lastVisibleIndex;

        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
            _.currentSlide = lastVisibleIndex;
        }

        // if less slides than to show, go to start.
        if ( _.slideCount <= _.options.slidesToShow ) {
            _.currentSlide = 0;

        }

        currentSlide = _.currentSlide;

        _.destroy(true);

        $$$1.extend(_, _.initials, { currentSlide: currentSlide });

        _.init();

        if( !initializing ) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);

        }

    };

    Slick.prototype.registerBreakpoints = function() {

        var _ = this, breakpoint, currentBreakpoint, l,
            responsiveSettings = _.options.responsive || null;

        if ( $$$1.type(responsiveSettings) === 'array' && responsiveSettings.length ) {

            _.respondTo = _.options.respondTo || 'window';

            for ( breakpoint in responsiveSettings ) {

                l = _.breakpoints.length-1;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while( l >= 0 ) {
                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
                            _.breakpoints.splice(l,1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;

                }

            }

            _.breakpoints.sort(function(a, b) {
                return ( _.options.mobileFirst ) ? a-b : b-a;
            });

        }

    };

    Slick.prototype.reinit = function() {

        var _ = this;

        _.$slides =
            _.$slideTrack
                .children(_.options.slide)
                .addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();

        _.checkResponsive(false, true);

        if (_.options.focusOnSelect === true) {
            $$$1(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        _.setPosition();
        _.focusHandler();

        _.paused = !_.options.autoplay;
        _.autoPlay();

        _.$slider.trigger('reInit', [_]);

    };

    Slick.prototype.resize = function() {

        var _ = this;

        if ($$$1(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $$$1(window).width();
                _.checkResponsive();
                if( !_.unslicked ) { _.setPosition(); }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {

        var _ = this;

        if (typeof(index) === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();

    };

    Slick.prototype.setCSS = function(position) {

        var _ = this,
            positionProps = {},
            x, y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }

    };

    Slick.prototype.setDimensions = function() {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: ('0px ' + _.options.centerPadding)
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: (_.options.centerPadding + ' 0px')
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();


        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));

        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) { _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset); }

    };

    Slick.prototype.setFade = function() {

        var _ = this,
            targetLeft;

        _.$slides.each(function(index, element) {
            targetLeft = (_.slideWidth * index) * -1;
            if (_.options.rtl === true) {
                $$$1(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $$$1(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });

    };

    Slick.prototype.setHeight = function() {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }

    };

    Slick.prototype.setOption =
    Slick.prototype.slickSetOption = function() {

        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */

        var _ = this, l, item, option, value, refresh = false, type;

        if( $$$1.type( arguments[0] ) === 'object' ) {

            option =  arguments[0];
            refresh = arguments[1];
            type = 'multiple';

        } else if ( $$$1.type( arguments[0] ) === 'string' ) {

            option =  arguments[0];
            value = arguments[1];
            refresh = arguments[2];

            if ( arguments[0] === 'responsive' && $$$1.type( arguments[1] ) === 'array' ) {

                type = 'responsive';

            } else if ( typeof arguments[1] !== 'undefined' ) {

                type = 'single';

            }

        }

        if ( type === 'single' ) {

            _.options[option] = value;


        } else if ( type === 'multiple' ) {

            $$$1.each( option , function( opt, val ) {

                _.options[opt] = val;

            });


        } else if ( type === 'responsive' ) {

            for ( item in value ) {

                if( $$$1.type( _.options.responsive ) !== 'array' ) {

                    _.options.responsive = [ value[item] ];

                } else {

                    l = _.options.responsive.length-1;

                    // loop through the responsive object and splice out duplicates.
                    while( l >= 0 ) {

                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {

                            _.options.responsive.splice(l,1);

                        }

                        l--;

                    }

                    _.options.responsive.push( value[item] );

                }

            }

        }

        if ( refresh ) {

            _.unload();
            _.reinit();

        }

    };

    Slick.prototype.setPosition = function() {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);

    };

    Slick.prototype.setProps = function() {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined ||
            bodyStyle.MozTransition !== undefined ||
            bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if ( _.options.fade ) {
            if ( typeof _.options.zIndex === 'number' ) {
                if( _.options.zIndex < 3 ) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) { _.animType = false; }
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) { _.animType = false; }
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) { _.animType = false; }
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) { _.animType = false; }
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
    };


    Slick.prototype.setSlideClasses = function(index) {

        var _ = this,
            centerOffset, allSlides, indexOffset, remainder;

        allSlides = _.$slider
            .find('.slick-slide')
            .removeClass('slick-active slick-center slick-current')
            .attr('aria-hidden', 'true');

        _.$slides
            .eq(index)
            .addClass('slick-current');

        if (_.options.centerMode === true) {

            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
                    _.$slides
                        .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides
                        .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

                if (index === 0) {

                    allSlides
                        .eq(allSlides.length - 1 - _.options.slidesToShow)
                        .addClass('slick-center');

                } else if (index === _.slideCount - 1) {

                    allSlides
                        .eq(_.options.slidesToShow)
                        .addClass('slick-center');

                }

            }

            _.$slides
                .eq(index)
                .addClass('slick-center');

        } else {

            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {

                _.$slides
                    .slice(index, index + _.options.slidesToShow)
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides
                    .addClass('slick-active')
                    .attr('aria-hidden', 'false');

            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {

                    allSlides
                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                } else {

                    allSlides
                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
                        .addClass('slick-active')
                        .attr('aria-hidden', 'false');

                }

            }

        }

        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
            _.lazyLoad();
        }
    };

    Slick.prototype.setupInfinite = function() {

        var _ = this,
            i, slideIndex, infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > (_.slideCount -
                        infiniteCount); i -= 1) {
                    slideIndex = i - 1;
                    $$$1(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex - _.slideCount)
                        .prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount  + _.slideCount; i += 1) {
                    slideIndex = i;
                    $$$1(_.$slides[slideIndex]).clone(true).attr('id', '')
                        .attr('data-slick-index', slideIndex + _.slideCount)
                        .appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $$$1(this).attr('id', '');
                });

            }

        }

    };

    Slick.prototype.interrupt = function( toggle ) {

        var _ = this;

        if( !toggle ) {
            _.autoPlay();
        }
        _.interrupted = toggle;

    };

    Slick.prototype.selectHandler = function(event) {

        var _ = this;

        var targetElement =
            $$$1(event.target).is('.slick-slide') ?
                $$$1(event.target) :
                $$$1(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) { index = 0; }

        if (_.slideCount <= _.options.slidesToShow) {

            _.slideHandler(index, false, true);
            return;

        }

        _.slideHandler(index);

    };

    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {

        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
            _ = this, navTarget;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function() {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if ( _.options.autoplay ) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        if ( _.options.asNavFor ) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
                navTarget.setSlideClasses(_.currentSlide);
            }

        }

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });

            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
            _.animateSlide(targetLeft, function() {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }

    };

    Slick.prototype.startLoad = function() {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();

        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();

        }

        _.$slider.addClass('slick-loading');

    };

    Slick.prototype.swipeDirection = function() {

        var xDist, yDist, r, swipeAngle, _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
            return (_.options.rtl === false ? 'left' : 'right');
        }
        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
            return (_.options.rtl === false ? 'right' : 'left');
        }
        if (_.options.verticalSwiping === true) {
            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
                return 'down';
            } else {
                return 'up';
            }
        }

        return 'vertical';

    };

    Slick.prototype.swipeEnd = function(event) {

        var _ = this,
            slideCount,
            direction;

        _.dragging = false;
        _.swiping = false;

        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }

        _.interrupted = false;
        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;

        if ( _.touchObject.curX === undefined ) {
            return false;
        }

        if ( _.touchObject.edgeHit === true ) {
            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
        }

        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {

            direction = _.swipeDirection();

            switch ( direction ) {

                case 'left':
                case 'down':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
                            _.currentSlide + _.getSlideCount();

                    _.currentDirection = 0;

                    break;

                case 'right':
                case 'up':

                    slideCount =
                        _.options.swipeToSlide ?
                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
                            _.currentSlide - _.getSlideCount();

                    _.currentDirection = 1;

                    break;

                default:


            }

            if( direction != 'vertical' ) {

                _.slideHandler( slideCount );
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction ]);

            }

        } else {

            if ( _.touchObject.startX !== _.touchObject.curX ) {

                _.slideHandler( _.currentSlide );
                _.touchObject = {};

            }

        }

    };

    Slick.prototype.swipeHandler = function(event) {

        var _ = this;

        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
            event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options
            .touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options
                .touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                _.swipeEnd(event);
                break;

        }

    };

    Slick.prototype.swipeMove = function(event) {

        var _ = this,
            curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        verticalSwipeLength = Math.round(Math.sqrt(
            Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = verticalSwipeLength;
        }

        swipeDirection = _.swipeDirection();

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }


        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);

    };

    Slick.prototype.swipeStart = function(event) {

        var _ = this,
            touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;

    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();

        }

    };

    Slick.prototype.unload = function() {

        var _ = this;

        $$$1('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides
            .removeClass('slick-slide slick-active slick-visible slick-current')
            .attr('aria-hidden', 'true')
            .css('width', '');

    };

    Slick.prototype.unslick = function(fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();

    };

    Slick.prototype.updateArrows = function() {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if ( _.options.arrows === true &&
            _.slideCount > _.options.slidesToShow &&
            !_.options.infinite ) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            }

        }

    };

    Slick.prototype.updateDots = function() {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots
                .find('li')
                    .removeClass('slick-active')
                    .end();

            _.$dots
                .find('li')
                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
                .addClass('slick-active');

        }

    };

    Slick.prototype.visibility = function() {

        var _ = this;

        if ( _.options.autoplay ) {

            if ( document[_.hidden] ) {

                _.interrupted = true;

            } else {

                _.interrupted = false;

            }

        }

    };

    $$$1.fn.slick = function() {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                { _[i].slick = new Slick(_[i], opt); }
            else
                { ret = _[i].slick[opt].apply(_[i].slick, args); }
            if (typeof ret != 'undefined') { return ret; }
        }
        return _;
    };

}));
});

var slick$1 = /*#__PURE__*/Object.freeze({
  default: slick,
  __moduleExports: slick
});

/* harmony default export */ __webpack_exports__["a"] = (Slick);


/***/ }),

/***/ 667:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.6.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2022-08-26T17:52Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.6.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.6
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2021-02-16
 */
( function( window ) {
var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ( {} ).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	pushNative = arr.push,
	push = arr.push,
	slice = arr.slice,

	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[ i ] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
		"ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5]
		// or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
		whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
		"*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
			whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
			whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		return nonHex ?

			// Strip the backslash prefix from a non-hex escape sequence
			nonHex :

			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" +
				ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android<4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;

			// Can't trust NodeList.length
			while ( ( target[ j++ ] = els[ i++ ] ) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

				// Support: IE 8 only
				// Exclude object elements
				( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					if ( newContext !== context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split( "|" ),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[ i ] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( ( cur = cur.nextSibling ) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return ( name === "input" || name === "button" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
					inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem && elem.namespaceURI,
		docElem = elem && ( elem.ownerDocument || elem ).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
	// Safari 4 - 5 only, Opera <=11.6 - 12.x only
	// IE/Edge & older browsers don't support the :scope pseudo-class.
	// Support: Safari 6.0 only
	// Safari 6.0 supports :scope but it's an alias of :root there.
	support.scope = assert( function( el ) {
		docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
		return typeof el.querySelectorAll !== "undefined" &&
			!el.querySelectorAll( ":scope fieldset div" ).length;
	} );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert( function( el ) {
		el.className = "i";
		return !el.getAttribute( "className" );
	} );

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert( function( el ) {
		el.appendChild( document.createComment( "" ) );
		return !el.getElementsByTagName( "*" ).length;
	} );

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter[ "ID" ] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter[ "ID" ] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find[ "TAG" ] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {

			var input;

			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}

			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}

			// Support: Firefox <=3.6 - 5 only
			// Old Firefox doesn't throw on a badly-escaped identifier.
			el.querySelectorAll( "\\\f" );
			rbuggyQSA.push( "[\\r\\n\\f]" );
		} );

		assert( function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll( "[name=d]" ).length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: Opera 10 - 11 only
			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll( "*,:x" );
			rbuggyQSA.push( ",.*:" );
		} );
	}

	if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector ) ) ) ) {

		assert( function( el ) {

			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		} );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			) );
		} :
		function( a, b ) {
			if ( b ) {
				while ( ( b = b.parentNode ) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a == document || a.ownerDocument == preferredDoc &&
				contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b == document || b.ownerDocument == preferredDoc &&
				contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {

		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			return a == document ? -1 :
				b == document ? 1 :
				/* eslint-enable eqeqeq */
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( ( cur = cur.parentNode ) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( ( cur = cur.parentNode ) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[ i ] === bp[ i ] ) {
			i++;
		}

		return i ?

			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[ i ], bp[ i ] ) :

			// Otherwise nodes in our document sort first
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			ap[ i ] == preferredDoc ? -1 :
			bp[ i ] == preferredDoc ? 1 :
			/* eslint-enable eqeqeq */
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

				// As well, disconnected nodes are said to be in a document
				// fragment in IE 9
				elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			( val = elem.getAttributeNode( name ) ) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {

		// If no nodeType, this is expected to be an array
		while ( ( node = elem[ i++ ] ) ) {

			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {

			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}

	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
				match[ 5 ] || "" ).replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

				// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				Sizzle.error( match[ 0 ] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace +
					")" + className + "(" + whitespace + "|$)" ) ) && classCache(
						className, function( elem ) {
							return pattern.test(
								typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
							);
				} );
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				/* eslint-disable max-len */

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
				/* eslint-enable max-len */

			};
		},

		"CHILD": function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || ( node[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								( outerCache[ node.uniqueID ] = {} );

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {

								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												( outerCache[ node.uniqueID ] = {} );

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		"not": markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element (issue #299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		"has": markFunction( function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		} ),

		"contains": markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement &&
				( !document.hasFocus || document.hasFocus() ) &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return ( nodeName === "input" && !!elem.checked ) ||
				( nodeName === "option" && !!elem.selected );
		},

		"selected": function( elem ) {

			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {

			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos[ "empty" ]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		"last": createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		"even": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"odd": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rcombinators.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrim, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :

			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] ||
							( outerCache[ elem.uniqueID ] = {} );

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = uniqueCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts(
				selector || "*",
				context.nodeType ? [ context ] : context,
				[]
			),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?

				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

					// If the preceding token was a descendant combinator, insert an implicit any-element `*`
					tokens
						.slice( 0, i - 1 )
						.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache(
			selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers )
		);

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
			context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
				.replace( runescape, funescape ), context ) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
						context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert( function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute( "href" ) === "#";
} ) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	} );
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert( function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
} ) ) {
	addHandle( "value", function( elem, _name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	} );
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert( function( el ) {
	return el.getAttribute( "disabled" ) == null;
} ) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
		}
	} );
}

return Sizzle;

} )( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See trac-6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see trac-8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (trac-14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (trac-11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (trac-14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (trac-13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (trac-12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (trac-13208)
				// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (trac-13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						// Support: Chrome 86+
						// In Chrome, if an element having a focusout handler is blurred by
						// clicking outside of it, it invokes the handler synchronously. If
						// that handler calls `.remove()` on the element, the data is cleared,
						// leaving `result` undefined. We need to guard against this.
						return result && result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (trac-504, trac-13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		// Suppress native focus or blur if we're currently inside
		// a leveraged native-event stack
		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

	rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (trac-8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {

							// Unwrap a CDATA section containing script contents. This shouldn't be
							// needed as in XML documents they're already not visible when
							// inspecting element contents and in HTML documents they have no
							// meaning but we're preserving that logic for backwards compatibility.
							// This will be removed completely in 4.0. See gh-4904.
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;


var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );

var whitespace = "[\\x20\\t\\r\\n\\f]";


var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);




( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (trac-8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is display: block
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		isCustomProp = rcustomProp.test( name ),

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, trac-12537)
	//   .css('--customProperty) (gh-3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		// trim whitespace for custom property (issue gh-4926)
		if ( isCustomProp ) {

			// rtrim treats U+000D CARRIAGE RETURN and U+000C FORM FEED
			// as whitespace while CSS does not, but this is not a problem
			// because CSS preprocessing replaces them with U+000A LINE FEED
			// (which *is* CSS whitespace)
			// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
			ret = ret.replace( rtrimCSS, "$1" );
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (trac-7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug trac-9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (trac-7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// Use proper attribute retrieval (trac-12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				// This expression is here for better compressibility (see addClass)
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Remove *all* instances
						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self,
			type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		return this.each( function() {
			if ( isValidValue ) {

				// Toggle individual class names
				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (trac-2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (trac-9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (trac-6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {

				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (trac-10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket trac-12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// trac-9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (trac-11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// trac-14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "$1" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(674), __esModule: true };

/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(675);
module.exports = __webpack_require__(9).Math.trunc;


/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(29);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),

/***/ 679:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 681:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(882);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79cbbf1d_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(971);
function injectStyle (ssrContext) {
  __webpack_require__(967)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79cbbf1d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79cbbf1d_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 695:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 697:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 698:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2My41OSA1OC4zMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNmZmE3MDA7fS5jbHMtMntmaWxsOiNmZGZkZmQ7fS5jbHMtM3tmaWxsOiM4NTNlMDA7fS5jbHMtNHtmaWxsOiM2NzAwMDA7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT53YXJuaW5nPC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxnIGlkPSJ3YXJuaW5nIj48ZyBpZD0iR3J1cG9fMTk4NCIgZGF0YS1uYW1lPSJHcnVwbyAxOTg0Ij48cGF0aCBpZD0iQ2FtaW5ob183NjE5LTIiIGRhdGEtbmFtZT0iQ2FtaW5obyA3NjE5LTIiIGNsYXNzPSJjbHMtMSIgZD0iTTMxLjgsNDAuMTRhMy4xMywzLjEzLDAsMSwxLTMuMTMsMy4xMiwzLjEyLDMuMTIsMCwwLDEsMy4xMy0zLjEyWk01MC45NCwyMy44LDQxLjQyLDcuMzFhMTAuNzMsMTAuNzMsMCwwLDAtMTguODktLjZMMTIuNjcsMjMuNzhsMCwwLDAsMEwzLjMzLDQwYTEwLjc0LDEwLjc0LDAsMCwwLDguNzYsMTdINTEuNTR2MGExMC43MiwxMC43MiwwLDAsMCw5LjI3LTE2LjFMNTEsMjMuNzhoMFptLTE2LTUuNDlWMzEuODJhMy4xMywzLjEzLDAsMCwxLTYuMjUsMFYxOC4zMWEzLjEzLDMuMTMsMCwxLDEsNi4yNSwwWiIvPjxnIGlkPSJHcnVwb18xOTgzIiBkYXRhLW5hbWU9IkdydXBvIDE5ODMiPjxjaXJjbGUgaWQ9IkVsaXBzZV8xNDQiIGRhdGEtbmFtZT0iRWxpcHNlIDE0NCIgY2xhc3M9ImNscy0yIiBjeD0iMzEuOCIgY3k9IjQxLjc4IiByPSIzLjEyIi8+PHBhdGggaWQ9IkNhbWluaG9fNzYyMCIgZGF0YS1uYW1lPSJDYW1pbmhvIDc2MjAiIGNsYXNzPSJjbHMtMiIgZD0iTTMxLjgsMzMuNDdhMy4xMywzLjEzLDAsMCwwLDMuMTItMy4xM1YxNi44M2EzLjEzLDMuMTMsMCwwLDAtNi4yNSwwVjMwLjM0QTMuMTQsMy4xNCwwLDAsMCwzMS44LDMzLjQ3WiIvPjwvZz48L2c+PGcgaWQ9IkdydXBvXzE5ODUiIGRhdGEtbmFtZT0iR3J1cG8gMTk4NSI+PHBhdGggaWQ9IkNhbWluaG9fNzYyMSIgZGF0YS1uYW1lPSJDYW1pbmhvIDc2MjEiIGNsYXNzPSJjbHMtMyIgZD0iTTYyLDQwLjE5LDUyLjEyLDIzLjExYTEuMzMsMS4zMywwLDAsMC0uMTQtLjE5TDQyLjYsNi42NkExMi4wNywxMi4wNywwLDAsMCwyMS4zNyw2TDExLjUxLDIzLjFhMS40NywxLjQ3LDAsMCwwLS4xLjIybC05LjIxLDE2YTEyLjA4LDEyLjA4LDAsMCwwLDkuODksMTlINTEuNTRhLjgyLjgyLDAsMCwwLC4yNywwQTEyLjA3LDEyLjA3LDAsMCwwLDYyLDQwLjE5Wm0tMS4zNyw4LjQ2YTkuMzgsOS4zOCwwLDAsMS05LjA3LDdsLS4yNiwwSDEyLjA5QTkuNDIsOS40MiwwLDAsMSw0LjQyLDQwLjc4bC4wNy0uMTEsOS4zMy0xNi4xOCwwLDBhMS42MywxLjYzLDAsMCwwLC4xMS0uMjNMMjMuNjksNy4zN2E5LjM4LDkuMzgsMCwwLDEsMTYuNTMuNTMuMjUuMjUsMCwwLDAsMCwuMDdsOS41MiwxNi40OWExLjI3LDEuMjcsMCwwLDAsLjEzLjE5bDkuNzUsMTYuODlhOS4zNSw5LjM1LDAsMCwxLDEsNy4xMVoiLz48cGF0aCBpZD0iQ2FtaW5ob183NjIyIiBkYXRhLW5hbWU9IkNhbWluaG8gNzYyMiIgY2xhc3M9ImNscy0zIiBkPSJNMjAuNzUsMjAuNTlhMS4zMywxLjMzLDAsMCwwLTEuODMuNDhMMTAuNCwzNS43NGExLjM0LDEuMzQsMCwwLDAsMi4yNywxLjQybDAtLjA4LDguNTMtMTQuNjdhMS4zMywxLjMzLDAsMCwwLS40OS0xLjgyWiIvPjxwYXRoIGlkPSJDYW1pbmhvXzc2MjMiIGRhdGEtbmFtZT0iQ2FtaW5obyA3NjIzIiBjbGFzcz0iY2xzLTMiIGQ9Ik0xMC4zNiwzOC40NGExLjM0LDEuMzQsMCwwLDAtMS44My40OWwwLDBhMS4zNCwxLjM0LDAsMCwwLDIuMjgsMS40bDAtLjA2LDAsMEExLjM0LDEuMzQsMCwwLDAsMTAuMzYsMzguNDRaIi8+PHBhdGggaWQ9IkNhbWluaG9fNzYyNCIgZGF0YS1uYW1lPSJDYW1pbmhvIDc2MjQiIGNsYXNzPSJjbHMtMyIgZD0iTTUwLjY2LDUwLjMySDQwLjU5YTEuMzQsMS4zNCwwLDAsMCwwLDIuNjhINTAuNjZhMS4zNCwxLjM0LDAsMCwwLDAtMi42OFoiLz48cGF0aCBpZD0iQ2FtaW5ob183NjI1IiBkYXRhLW5hbWU9IkNhbWluaG8gNzYyNSIgY2xhc3M9ImNscy0zIiBkPSJNNTMuNTgsNDkuNzhoMGExLjM0LDEuMzQsMCwwLDAsMS4yMiwyLjM5bC4wNywwLC4wOS0uMDZhMS4zMywxLjMzLDAsMCwwLTEuMzUtMi4zWiIvPjxwYXRoIGlkPSJDYW1pbmhvXzc2MjYiIGRhdGEtbmFtZT0iQ2FtaW5obyA3NjI2IiBjbGFzcz0iY2xzLTQiIGQ9Ik0zMS44LDM1LjI4YTQuNDYsNC40NiwwLDAsMCw0LjQ2LTQuNDZWMTcuMzFhNC40Niw0LjQ2LDAsMSwwLTguOTIsMHYxMy41QTQuNDYsNC40NiwwLDAsMCwzMS44LDM1LjI4Wk0zMCwxNy4zMWExLjc5LDEuNzksMCwwLDEsMy41NywwdjEzLjVBMS43OSwxLjc5LDAsMCwxLDMxLjgsMzIuNmgwQTEuNzksMS43OSwwLDAsMSwzMCwzMC44MVYxNy4zMVoiLz48cGF0aCBpZD0iQ2FtaW5ob183NjI3IiBkYXRhLW5hbWU9IkNhbWluaG8gNzYyNyIgY2xhc3M9ImNscy00IiBkPSJNMzEuOCwzNy43OWE0LjQ3LDQuNDcsMCwxLDAsNC40Niw0LjQ2QTQuNDYsNC40NiwwLDAsMCwzMS44LDM3Ljc5Wm0wLDYuMjVhMS43OSwxLjc5LDAsMSwxLDEuNzktMS43OWgwQTEuNzksMS43OSwwLDAsMSwzMS44LDQ0WiIvPjwvZz48L2c+PC9nPjwvZz48L3N2Zz4="

/***/ }),

/***/ 699:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 700:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjUxMnB0IiB2aWV3Qm94PSItNjEgMCA1MTIgNTEyIiB3aWR0aD0iNTEycHQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTMxNC43NzczNDQgMTY0LjkzMzU5NGMzNC0zMy45OTYwOTQgNTIuNzIyNjU2LTc5LjE5OTIxOSA1Mi43MjI2NTYtMTI3LjI3NzM0NHYtMTEuNjU2MjVjLTguMzY3MTg4IDAtMzQwLjg5MDYyNSAwLTM0NSAwdjExLjY1NjI1YzAgNDguMDc4MTI1IDE4LjcyMjY1NiA5My4yODEyNSA1Mi43MjI2NTYgMTI3LjI3NzM0NGw3Ni4yMTQ4NDQgNzYuMjE4NzVjOC4yMDMxMjUgOC4xOTkyMTggOC4yMDMxMjUgMjEuNDk2MDk0IDAgMjkuNjk5MjE4bC03Ni4yMTQ4NDQgNzYuMjE0ODQ0Yy0zNCAzMy45OTYwOTQtNTIuNzIyNjU2IDc5LjE5OTIxOS01Mi43MjI2NTYgMTI3LjI4MTI1djExLjY1MjM0NGgzNDV2LTExLjY1MjM0NGMwLTQ4LjA4MjAzMS0xOC43MjI2NTYtOTMuMjg1MTU2LTUyLjcyMjY1Ni0xMjcuMjgxMjVsLTc2LjIxNDg0NC03Ni4yMTQ4NDRjLTguMjAzMTI1LTguMjAzMTI0LTguMjAzMTI1LTIxLjUgMC0yOS42OTkyMTh6bTAgMCIgZmlsbD0iI2ZmZjllYiIvPjxwYXRoIGQ9Im0zMzcuNSAzNy42NTIzNDRjMCA0MC4wNzAzMTItMTUuNjAxNTYyIDc3LjczODI4MS00My45MzM1OTQgMTA2LjA2NjQwNmwtNzYuMjE4NzUgNzYuMjE4NzVjLTE5Ljg4MjgxMiAxOS44ODI4MTItMTkuODgyODEyIDUyLjIzODI4MSAwIDcyLjEyNWw3Ni4yMTg3NSA3Ni4yMTg3NWMyOC4zMzIwMzIgMjguMzI4MTI1IDQzLjkzMzU5NCA2NS45OTYwOTQgNDMuOTMzNTk0IDEwNi4wNjI1djExLjY1NjI1aDMwdi0xMS42NTIzNDRjMC00OC4wODIwMzEtMTguNzIyNjU2LTkzLjI4NTE1Ni01Mi43MjI2NTYtMTI3LjI4MTI1bC03Ni4yMTQ4NDQtNzYuMjE0ODQ0Yy04LjIwMzEyNS04LjIwMzEyNC04LjIwMzEyNS0yMS41IDAtMjkuNjk5MjE4bDc2LjIxNDg0NC03Ni4yMTg3NWMzNC0zMy45OTYwOTQgNTIuNzIyNjU2LTc5LjE5OTIxOSA1Mi43MjI2NTYtMTI3LjI3NzM0NHYtMTEuNjU2MjVoLTMwem0wIDAiIGZpbGw9IiNkM2NkYmYiLz48cGF0aCBkPSJtMjc5Ljc3MzQzOCAzODMuMzk4NDM4LTEzLjMxMjUuMDc4MTI0aC0uMjY5NTMyYy02LjcyMjY1Ni0uMjAzMTI0LTEzLjE3MTg3NS0xLjM1MTU2Mi0xOS4yODkwNjItMy4yOTY4NzQtMTkuNDgwNDY5LTYuMTk1MzEzLTM1LjIzODI4Mi0yMC44NzEwOTQtNDQuMDI3MzQ0LTM5LjU1MDc4MmgtMTVjLTExLjU1MDc4MSAyNC40ODQzNzUtMzUuOTMzNTk0IDQxLjkwMjM0NC02NC4wNzAzMTIgNDIuNzVsLTEzLjU2NjQwNy4wMDM5MDZjLTE4LjgzNTkzNyAyMC41OTc2NTctMzAuNjEzMjgxIDQ1Ljk1MzEyNi0zNC4xMzY3MTkgNzMuNTQ2ODc2djI1LjA3MDMxMmgyMzcuNzkyOTY5di0yNS4wNzAzMTJjLTMuNTE5NTMxLTI3LjU4MjAzMi0xNS4yODkwNjItNTIuOTI1NzgyLTM0LjEyMTA5My03My41MzEyNXptMCAwIiBmaWxsPSIjZmZiNTQ1Ii8+PHBhdGggZD0ibTI3OS43NzM0MzggMzgzLjM5ODQzOC0xMy4zMTI1LjA3ODEyNGgtLjI2OTUzMmMtNi42ODM1OTQtLjIwMzEyNC0xMy4xNTIzNDQtMS4zNTE1NjItMTkuMjg5MDYyLTMuMjk2ODc0bDE2LjAxMTcxOCAxOC4xMjEwOTMuMjUuMjc3MzQ0Yy4yODUxNTcuMzEyNS41NzAzMTMuNjI4OTA2Ljg1NTQ2OS45NDUzMTMuMDU4NTk0LjA2NjQwNi4xMTcxODguMTMyODEyLjE3NTc4MS4yMDMxMjQgNy41ODIwMzIgOC42NzE4NzYgMS4xNzk2ODggMjIuMjczNDM4LTEwLjMzOTg0MyAyMi4yNzM0MzhoLTE2OC4zOTQ1MzFjLTIuMDUwNzgyIDQuODc4OTA2LTMuNzkyOTY5IDkuODg2NzE5LTUuMjUgMTVoLS4wMTk1MzJjLTQuOTYwOTM3IDE3LjQyNTc4MS00LjA4NTkzNyAyMi41OTM3NS00LjA4NTkzNyA0NWgyMzcuNzkyOTY5di0yMWMtLjAwMzkwNy0xNS40NTMxMjUtOC4yNjU2MjYtNDkuMzA4NTk0LTM0LjEyNS03Ny42MDE1NjJ6bTAgMCIgZmlsbD0iI2ZmOTgzYiIvPjxwYXRoIGQ9Im0xOTQuOTk2MDk0IDIxNC4yOTI5NjljLTEuNzgxMjUtMi40NjQ4NDQtMy43NzM0MzgtNC44MDg1OTQtNS45NjQ4NDQtN2wtNjAuMTg3NS02MC4xOTE0MDdjLTQuNzIyNjU2LTQuNzI2NTYyLTEuMzc1LTEyLjgwNDY4NyA1LjMwNDY4OC0xMi44MDQ2ODdoMTIxLjcwMzEyNGM2LjY3OTY4OCAwIDEwLjAyNzM0NCA4LjA3NDIxOSA1LjMwMDc4MiAxMi44MDA3ODFsLTYwLjIxMDkzOCA2MC4yMTg3NWMtMi4xODM1OTQgMi4xODc1LTQuMTY3OTY4IDQuNTE5NTMyLTUuOTQ1MzEyIDYuOTc2NTYzem0wIDAiIGZpbGw9IiNmZmI1NDUiLz48cGF0aCBkPSJtMjU1Ljg0NzY1NiAxMzQuMjk2ODc1aC0yNC4zMTY0MDZsLTU3Ljc0NjA5NCA1Ny43NSAxNC4wOTM3NSAxNC4wODk4NDQgMTUtLjc1NzgxMyA1OC4yNzM0MzgtNTguMjgxMjVjNC43MjY1NjItNC43MjY1NjIgMS4zNzg5MDYtMTIuODA0Njg3LTUuMzA0Njg4LTEyLjgwMDc4MXptMCAwIiBmaWxsPSIjZmY5ODNiIi8+PHBhdGggZD0ibTM2Ny41IDcuNWMtNC45MzM1OTQgMC0zNDAuMDY2NDA2IDAtMzQ1IDAtOC4yODUxNTYgMC0xNSA2LjcxNDg0NC0xNSAxNXYyMi41YzAgOC4yODUxNTYgNi43MTQ4NDQgMTUgMTUgMTVoMzQ1YzguMjg1MTU2IDAgMTUtNi43MTQ4NDQgMTUtMTV2LTIyLjVjMC04LjI4NTE1Ni02LjcxNDg0NC0xNS0xNS0xNXptMCAwIiBmaWxsPSIjYTA1YTRiIi8+PHBhdGggZD0ibTM2Ny41IDcuNWgtMTVjMCAxMi40MjU3ODEtMTAuMDc0MjE5IDIyLjUtMjIuNSAyMi41LTguNzUzOTA2IDAtMzE5LjA2NjQwNiAwLTMyMi41IDB2MTVjMCA4LjI4NTE1NiA2LjcxNDg0NCAxNSAxNSAxNWgzNDVjOC4yODUxNTYgMCAxNS02LjcxNDg0NCAxNS0xNXYtMjIuNWMwLTguMjg1MTU2LTYuNzE0ODQ0LTE1LTE1LTE1em0wIDAiIGZpbGw9IiM4MTQ5M2IiLz48cGF0aCBkPSJtMzY3LjUgNDUyYy00LjkzMzU5NCAwLTM0MC4wNjY0MDYgMC0zNDUgMC04LjI4NTE1NiAwLTE1IDYuNzE0ODQ0LTE1IDE1djIyLjVjMCA4LjI4NTE1NiA2LjcxNDg0NCAxNSAxNSAxNWgzNDVjOC4yODUxNTYgMCAxNS02LjcxNDg0NCAxNS0xNXYtMjIuNWMwLTguMjg1MTU2LTYuNzE0ODQ0LTE1LTE1LTE1em0wIDAiIGZpbGw9IiNhMDVhNGIiLz48cGF0aCBkPSJtMzY3LjUgNDUyaC0xNWMwIDEyLjQyNTc4MS0xMC4wNzQyMTkgMjIuNS0yMi41IDIyLjUtOC43NTM5MDYgMC0zMTkuMDY2NDA2IDAtMzIyLjUgMHYxNWMwIDguMjg1MTU2IDYuNzE0ODQ0IDE1IDE1IDE1aDM0NWM4LjI4NTE1NiAwIDE1LTYuNzE0ODQ0IDE1LTE1di0yMi41YzAtOC4yODUxNTYtNi43MTQ4NDQtMTUtMTUtMTV6bTAgMCIgZmlsbD0iIzgxNDkzYiIvPjxnIGZpbGw9IiMwMjAyMDEiPjxwYXRoIGQ9Im0yMjUuNTg5ODQ0IDQwNmMwIDQuMTQwNjI1LTMuMzU5Mzc1IDcuNS03LjUgNy41LTQuMTQ0NTMyIDAtNy41LTMuMzU5Mzc1LTcuNS03LjVzMy4zNTU0NjgtNy41IDcuNS03LjVjNC4xNDA2MjUgMCA3LjUgMy4zNTkzNzUgNy41IDcuNXptMCAwIi8+PHBhdGggZD0ibTI1NS41ODk4NDQgNDIyYzAgNC4xNDA2MjUtMy4zNTkzNzUgNy41LTcuNSA3LjUtNC4xNDQ1MzIgMC03LjUtMy4zNTkzNzUtNy41LTcuNXMzLjM1NTQ2OC03LjUgNy41LTcuNWM0LjE0MDYyNSAwIDcuNSAzLjM1OTM3NSA3LjUgNy41em0wIDAiLz48cGF0aCBkPSJtMTg1LjU4OTg0NCA0MjJjMCA0LjE0MDYyNS0zLjM1OTM3NSA3LjUtNy41IDcuNS00LjE0NDUzMiAwLTcuNS0zLjM1OTM3NS03LjUtNy41czMuMzU1NDY4LTcuNSA3LjUtNy41YzQuMTQwNjI1IDAgNy41IDMuMzU5Mzc1IDcuNSA3LjV6bTAgMCIvPjxwYXRoIGQ9Im0xNTUuNTg5ODQ0IDQwNmMwIDQuMTQwNjI1LTMuMzU5Mzc1IDcuNS03LjUgNy41LTQuMTQ0NTMyIDAtNy41LTMuMzU5Mzc1LTcuNS03LjVzMy4zNTU0NjgtNy41IDcuNS03LjVjNC4xNDA2MjUgMCA3LjUgMy4zNTkzNzUgNy41IDcuNXptMCAwIi8+PHBhdGggZD0ibTE4MS41ODk4NDQgMTU3YzAgNC4xNDA2MjUtMy4zNTkzNzUgNy41LTcuNSA3LjUtNC4xNDQ1MzIgMC03LjUtMy4zNTkzNzUtNy41LTcuNXMzLjM1NTQ2OC03LjUgNy41LTcuNWM0LjE0MDYyNSAwIDcuNSAzLjM1OTM3NSA3LjUgNy41em0wIDAiLz48cGF0aCBkPSJtMjExLjU4OTg0NCAxNjdjMCA0LjE0MDYyNS0zLjM1OTM3NSA3LjUtNy41IDcuNS00LjE0NDUzMiAwLTcuNS0zLjM1OTM3NS03LjUtNy41czMuMzU1NDY4LTcuNSA3LjUtNy41YzQuMTQwNjI1IDAgNy41IDMuMzU5Mzc1IDcuNSA3LjV6bTAgMCIvPjxwYXRoIGQ9Im0zMjAuMDgyMDMxIDE3MC4yMzgyODFjMjguNDQxNDA3LTI4LjQ0MTQwNiA0Ni41NjI1LTY0LjA3NDIxOSA1Mi42NTYyNS0xMDMuMzU5Mzc1IDkuODg2NzE5LTIuMzcxMDk0IDE3LjI2MTcxOS0xMS4yNzczNDQgMTcuMjYxNzE5LTIxLjg3ODkwNnYtMjIuNWMwLTEyLjQwNjI1LTEwLjA5Mzc1LTIyLjUtMjIuNS0yMi41aC0zNDVjLTEyLjQwNjI1IDAtMjIuNSAxMC4wOTM3NS0yMi41IDIyLjV2MjIuNWMwIDEyLjQwNjI1IDEwLjA5Mzc1IDIyLjUgMjIuNSAyMi41aDMzNC45Mzc1Yy02LjAzNTE1NiAzNC45NjQ4NDQtMjIuNTAzOTA2IDY2LjY3MTg3NS00Ny45NjA5MzggOTIuMTI4OTA2bC03Ni4yMTg3NSA3Ni4yMTg3NWMtMTEuMTA5Mzc0IDExLjExMzI4Mi0xMS4xMDkzNzQgMjkuMTkxNDA2IDAgNDAuMzA0Njg4bDc2LjIxODc1IDc2LjIxODc1YzI1LjQ1NzAzMiAyNS40NTcwMzEgNDEuOTI1NzgyIDU3LjE2NDA2MiA0Ny45NjA5MzggOTIuMTI4OTA2aC0zOC4wNTg1OTRjLTUuMjE4NzUtMjQuNjI4OTA2LTE2LjkxNDA2Mi00Ny4zOTg0MzgtMzQuMDg1OTM3LTY2LjE3OTY4OC0xLjQyMTg3NS0xLjU1MDc4MS0zLjQyOTY4OC0yLjQzNzUtNS41MzEyNS0yLjQzNzVsLTEzLjQ0OTIxOS0uMDAzOTA2Yy0xNi4xNTIzNDQtLjUxNTYyNS0zMS41ODIwMzEtNy4xOTkyMTgtNDMuNDQ1MzEyLTE4LjgyODEyNS0xMS4yNzczNDQtMTEuMDUwNzgxLTE0LjU1NDY4OC0yMS41NzgxMjUtMjAuMzYzMjgyLTM1Ljc2OTUzMXYtMTA0Ljg3ODkwNmw3Ni43NTc4MTMtNzYuODEyNWM0LjcwNzAzMS00LjcwNzAzMiAxLjM2NzE4Ny0xMi44MDA3ODItNS4zMDA3ODEtMTIuODAwNzgybC0xNTcuOTE3OTY5LjAxMTcxOWMtNi42Nzk2ODggMC0xMC4wMTU2MjUgOC4wODU5MzgtNS4zMDA3ODEgMTIuODAwNzgxbDU3LjczODI4MSA1Ny43Njk1MzJjMi45NzI2NTYgMi45NzI2NTYgNy43MjY1NjIgMi44OTQ1MzEgMTAuNjEzMjgxLjAxMTcxOCAyLjk1NzAzMS0yLjk2MDkzNyAyLjkwNjI1LTcuNjgzNTkzLjAwNzgxMi0xMC42MDE1NjJsLTQ0Ljk2MDkzNy00NC45ODA0NjkgMTIxLjcxMDkzNy0uMDExNzE5LTY2LjE2MDE1NiA2Ni4xOTkyMTljLS4wMTE3MTguMDExNzE5LS4wMTk1MzEuMDMxMjUtLjA0Mjk2OC4wMzkwNjMtMS40Mjk2ODggMS40Njg3NS0yLjE0ODQzOCAzLjMzMjAzMS0yLjE0ODQzOCA1LjI2MTcxOHYxMDUuOTc2NTYzYy00LjE5NTMxMiAxMi4xMzY3MTktNy41NzgxMjUgMjUuMjUtMjAuMzYzMjgxIDM3Ljc4NTE1Ni0xMS44NjcxODggMTEuNjI4OTA3LTI3LjI5Mjk2OSAxOC4zMTI1LTQzLjQ0OTIxOSAxOC44MjgxMjVsLTEzLjQ0NTMxMi4wMDM5MDZjLTIuMTA1NDY5IDAtNC4xMTMyODIuODg2NzE5LTUuNTM1MTU3IDIuNDM3NS0xNy4xNjc5NjkgMTguNzc3MzQ0LTI4Ljg2MzI4MSA0MS41NDY4NzYtMzQuMDgyMDMxIDY2LjE3OTY4OGgtMzguMDU4NTk0YzYuMDQyOTY5LTM0Ljk3MjY1NiAyMi41MTE3MTktNjYuNjc5Njg4IDQ3Ljk1MzEyNS05Mi4xMjg5MDZsNzYuMjIyNjU3LTc2LjIyMjY1NmMxMS4xMjg5MDYtMTEuMTMyODEzIDExLjEzMjgxMi0yOS4xNjQwNjMgMC00MC4zMDA3ODJsLTc2LjIyMjY1Ny03Ni4yMTg3NWMtMjAuMjY5NTMxLTIwLjI4MTI1LTM1LjI1NzgxMi00NS4zMjgxMjUtNDMuMzM5ODQzLTcyLjQ0MTQwNi0xLjE2MDE1Ny0zLjkwMjM0NC01LjM0Mzc1LTYuMjQyMTg4LTkuMzI4MTI2LTUuMDQ2ODc1LTMuOTQxNDA2IDEuMTY3OTY5LTYuMjM4MjgxIDUuMzIwMzEzLTUuMDUwNzgxIDkuMzI4MTI1IDguODQzNzUgMjkuNjQ4NDM4IDI0Ljk0OTIxOSA1Ni42MDE1NjIgNDcuMTIxMDk0IDc4Ljc2OTUzMWw3Ni4yMTA5MzcgNzYuMjEwOTM4YzUuMjc3MzQ0IDUuMzAwNzgxIDUuMjczNDM4IDEzLjgwNDY4NyAwIDE5LjEwMTU2MmwtNzYuMjEwOTM3IDc2LjIxMDkzOGMtMTQuODIwMzEzIDE0LjgxNjQwNi0yNi45NDkyMTkgMzEuNzY5NTMxLTM2LjAzOTA2MyA1MC4zNzg5MDYtOC4xODM1OTMgMTYuNzQyMTg3LTEzLjc1MzkwNiAzNC41MzkwNjMtMTYuNjIxMDkzIDUyLjk4MDQ2OS05Ljg5MDYyNSAyLjM3MTA5NC0xNy4yNjE3MTkgMTEuMjc3MzQ0LTE3LjI2MTcxOSAyMS44Nzg5MDZ2MjIuNWMwIDEyLjQwNjI1IDEwLjA5Mzc1IDIyLjUgMjIuNSAyMi41aDM0NWMxMi40MDYyNSAwIDIyLjUtMTAuMDkzNzUgMjIuNS0yMi41di0yMi41YzAtMTAuNjAxNTYyLTcuMzc1LTE5LjUwNzgxMi0xNy4yNjE3MTktMjEuODc4OTA2LTYuMDkzNzUtMzkuMjg1MTU2LTI0LjIxNDg0My03NC45MTc5NjktNTIuNjU2MjUtMTAzLjM1OTM3NWwtNzYuMjE0ODQzLTc2LjIxNDg0NGMtNS4yNjU2MjYtNS4yNjU2MjUtNS4yNjU2MjYtMTMuODI4MTI1IDAtMTkuMDkzNzV6bS0yOTcuNTgyMDMxLTExNy43MzgyODFjLTQuMTM2NzE5IDAtNy41LTMuMzYzMjgxLTcuNS03LjV2LTIyLjVjMC00LjEzNjcxOSAzLjM2MzI4MS03LjUgNy41LTcuNWgzNDVjNC4xMzY3MTkgMCA3LjUgMy4zNjMyODEgNy41IDcuNXYyMi41YzAgNC4xMzY3MTktMy4zNjMyODEgNy41LTcuNSA3LjV6bTkxLjEwMTU2MiAzMzguMzgyODEyIDEwLjIwNzAzMi0uMDAzOTA2Yy4wNzQyMTggMCAuMTQ4NDM3IDAgLjIyMjY1Ni0uMDAzOTA2IDI5LjQ3NjU2Mi0uODg2NzE5IDU3LjcwMzEyNS0xOC41MzEyNSA3MC45Njg3NS00OC4zNDM3NSA2LjIxNDg0NCAxMy45Njg3NSAxNS4zMzIwMzEgMjQuOTQxNDA2IDI3LjA0Njg3NSAzMy4zNTE1NjJoLTI3LjA0Njg3NWMtNC4xNDA2MjUgMC03LjUgMy4zNTU0NjktNy41IDcuNSAwIDQuMTQwNjI2IDMuMzU5Mzc1IDcuNSA3LjUgNy41aDgxLjM5ODQzOGMxMy40Njg3NSAxNS41IDIyLjkwMjM0MyAzMy44NDM3NSAyNy42MTcxODcgNTMuNjE3MTg4aC0yMTguMDMxMjVjNC43MTQ4NDQtMTkuNzczNDM4IDE0LjE0ODQzNy0zOC4xMTcxODggMjcuNjE3MTg3LTUzLjYxNzE4OHptMjYxLjM5ODQzOCA3Ni4xMTcxODh2MjIuNWMwIDQuMTM2NzE5LTMuMzYzMjgxIDcuNS03LjUgNy41aC0zNDVjLTQuMTM2NzE5IDAtNy41LTMuMzYzMjgxLTcuNS03LjV2LTIyLjVjMC00LjEzNjcxOSAzLjM2MzI4MS03LjUgNy41LTcuNWgzNDVjNC4xMzY3MTkgMCA3LjUgMy4zNjMyODEgNy41IDcuNXptMCAwIi8+PC9nPjwvc3ZnPg=="

/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/negative.e3be99f.svg";

/***/ }),

/***/ 702:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 703:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 708:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 709:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 710:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 711:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 712:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 719:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDQ2IDQ2IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0NiA0NjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4NCgkuc3Qwe2ZpbGw6IzYzMkIwRjt9DQo8L3N0eWxlPg0KPGc+DQoJPGc+DQoJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xNC44LDQ2Yy0xLjQsMC0yLjgtMC41LTMuOS0xLjZjLTIuMy0yLjItMi40LTUuOC0wLjItOC4xTDIzLjQsMjNMMTAuNiw5LjZjLTIuMi0yLjMtMi4xLTUuOSwwLjItOC4xDQoJCQljMi4zLTIuMiw1LjktMi4xLDguMSwwLjJMMzUuNCwxOWMyLjEsMi4yLDIuMSw1LjcsMCw3LjlMMTguOSw0NC4yQzE3LjgsNDUuNCwxNi4zLDQ2LDE0LjgsNDZ6Ii8+DQoJPC9nPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ 734:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(664);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ca5f500_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(737);
function injectStyle (ssrContext) {
  __webpack_require__(735)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ca5f500"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ca5f500_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 735:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(736);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("5a0cf69f", content, true, {});

/***/ }),

/***/ 736:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".container--percentage[data-v-3ca5f500]{width:100%;background:#d8d8d8;margin-bottom:20px;height:10px;overflow:hidden;border-radius:20px}.container--percentage .container--percentage--block[data-v-3ca5f500]{overflow:hidden}.container--percentage .container--percentage--block .container--percentage--block-anima[data-v-3ca5f500]{background:#255f83;background:-webkit-gradient(linear,right top,left bottom,from(#276c8c),to(#0ba6b2));background:linear-gradient(top right,#276c8c,#0ba6b2);-webkit-animation-name:animaPercentage-data-v-3ca5f500;animation-name:animaPercentage-data-v-3ca5f500;-webkit-animation-duration:.5s;animation-duration:.5s;-webkit-animation-delay:2s;animation-delay:2s;height:10px;-webkit-animation-fill-mode:backwards;animation-fill-mode:backwards}@-webkit-keyframes animaPercentage-data-v-3ca5f500{0%{width:0}to{width:100%}}@keyframes animaPercentage-data-v-3ca5f500{0%{width:0}to{width:100%}}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/metaPercentage/index.vue"],"names":[],"mappings":"AACA,wCACE,WAAY,AACZ,mBAAoB,AACpB,mBAAoB,AACpB,YAAa,AACb,gBAAiB,AACjB,kBAAoB,CACrB,AACD,sEACI,eAAiB,CACpB,AACD,0GACM,mBAAoB,AACpB,oFAAyF,AACzF,sDAAyD,AACzD,uDAAwD,AACxD,+CAAgD,AAChD,+BAAiC,AACjC,uBAAyB,AACzB,2BAA4B,AAC5B,mBAAoB,AACpB,YAAa,AACb,sCAAuC,AACvC,6BAA+B,CACpC,AACD,mDACA,GACI,OAAS,CACZ,AACD,GACI,UAAY,CACf,CACA,AACD,2CACA,GACI,OAAS,CACZ,AACD,GACI,UAAY,CACf,CACA","file":"index.vue","sourcesContent":["\n.container--percentage[data-v-3ca5f500] {\n  width: 100%;\n  background: #D8D8D8;\n  margin-bottom: 20px;\n  height: 10px;\n  overflow: hidden;\n  border-radius: 20px;\n}\n.container--percentage .container--percentage--block[data-v-3ca5f500] {\n    overflow: hidden;\n}\n.container--percentage .container--percentage--block .container--percentage--block-anima[data-v-3ca5f500] {\n      background: #255F83;\n      background: -webkit-gradient(linear, right top, left bottom, from(#276C8C), to(#0BA6B2));\n      background: linear-gradient(top right, #276C8C, #0BA6B2);\n      -webkit-animation-name: animaPercentage-data-v-3ca5f500;\n      animation-name: animaPercentage-data-v-3ca5f500;\n      -webkit-animation-duration: 0.5s;\n      animation-duration: 0.5s;\n      -webkit-animation-delay: 2s;\n      animation-delay: 2s;\n      height: 10px;\n      -webkit-animation-fill-mode: backwards;\n      animation-fill-mode: backwards;\n}\n@-webkit-keyframes animaPercentage-data-v-3ca5f500 {\nfrom {\n    width: 0;\n}\nto {\n    width: 100%;\n}\n}\n@keyframes animaPercentage-data-v-3ca5f500 {\nfrom {\n    width: 0;\n}\nto {\n    width: 100%;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 737:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container--percentage",style:({ height: _vm.height + 'px', borderRadius: _vm.borderRadius + 'px'})},[_c('div',{staticClass:"container--percentage--block",style:({ width: _vm.percentage + '%', height: _vm.height + 'px', borderRadius: _vm.borderRadius + 'px' })},[_c('div',{staticClass:"container--percentage--block-anima",style:({ height: _vm.height + 'px' })})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 762:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 801:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slick__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_metaPercentage__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(82);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'currentUnit',
  props: {
    data: {
      type: Object
    }
  },
  data: function data() {
    return {
      date: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      },
      lastClass: 0,
      interval: null,
      slickOptions: {
        prevArrow: '<button type="button" class="btn btn__slickHome btn__slickHome__prev"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 50 80"><defs><style>.a{fill:#fff;}</style></defs><g transform="translate(-55, -130), rotate(180 50 100)"><path class="a" d="M14.8,46a5.444,5.444,0,0,1-3.9-1.6,5.706,5.706,0,0,1-.2-8.1L23.4,23,10.6,9.6a5.729,5.729,0,1,1,8.3-7.9L35.4,19a5.741,5.741,0,0,1,0,7.9L18.9,44.2A5.54,5.54,0,0,1,14.8,46Z"/></g></svg></button>',
        nextArrow: '<button type="button" class="btn btn__slickHome btn__slickHome__next"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 50 80"><defs><style>.a{fill:#fff;}</style></defs><g transform="translate(5, 20), rotate(0 50 100)"><path class="a" d="M14.8,46a5.444,5.444,0,0,1-3.9-1.6,5.706,5.706,0,0,1-.2-8.1L23.4,23,10.6,9.6a5.729,5.729,0,1,1,8.3-7.9L35.4,19a5.741,5.741,0,0,1,0,7.9L18.9,44.2A5.54,5.54,0,0,1,14.8,46Z"/></g></svg></button>',
        slidesToShow: 5,
        slidesToScroll: 5,
        infinite: false,
        dots: false,
        speed: 300,
        responsive: [{
          breakpoint: 900,
          settings: {
            slidesToScroll: 4,
            slidesToShow: 4
          }
        }, {
          breakpoint: 700,
          settings: {
            slidesToScroll: 3,
            slidesToShow: 3
          }
        }, {
          breakpoint: 600,
          settings: {
            slidesToScroll: 2,
            slidesToShow: 2
          }
        }, {
          breakpoint: 320,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      },
      clicked: false,
      topicImage: {
        0: 'words_attack',
        1: 'all_ears',
        2: 'game',
        3: 'another_brick',
        4: 'assessment'
      },
      speakup: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])({
    'student': 'student/GET',
    'books': 'book/getAll',
    'book': 'book/get',
    'units': 'unit/getAll',
    'unit': 'unit/get',
    'unit_id': 'unit/id',
    'classes': 'lesson/getOriginalClasses',
    'lessons': 'lesson/getLessons',
    '_topics_': 'topic/getAll',
    'currentTopic': 'topic/get',
    'toReview': 'lesson/getReview',
    'isReview': 'isReview',
    'revision': 'unit/revision',
    'hasSpeakUp': 'speakup/hasSpeakUp',
    'teensTopics': 'teens/GET_TOPICS',
    'teensBook': 'teens/GET_BOOK',
    'teensUnit': 'teens/GET_UNIT'
  }), {
    topics: function topics() {
      if (!!this.student.teens) return this.teensTopics.map(function (t) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, t, { name: t.title });
      });

      if (this.isReview) return this._topics_.map(function (topic) {
        return {
          _id: topic._id,
          name: topic.title,
          value: topic.value,
          score: 0,
          finished: topic.finished,
          subTopics: topic.subTopics
          // image: topic.title.split(' ').map(str => str.toLowerCase()).join('_')
        };
      });

      return this._topics_.map(function (topic) {
        return {
          _id: topic._id,
          name: topic.title,
          value: topic.value,
          score: topic.score,
          finished: topic.finished,
          subTopics: topic.subTopics
          // image: topic.title.split(' ').map(str => str.toLowerCase()).join('_')
        };
      });
    },
    isFinished: function isFinished() {
      if (this.isReview) return false;

      if (this.haveSpeakUp) return false;

      if (this.currentClass && !this.currentClass.lesson_name.includes('UNIT')) return false;

      if (this.unit.finished) return true;

      var finished = 0;

      this.topics.forEach(function (topic) {
        if (topic.finished) if (!!topic.value) finished++;
      });

      return finished == 4;
    },
    isUnitClass: function isUnitClass() {
      var _this = this;

      if (this.isReview) return true;

      if (this.revision) return true;

      if (this.haveSpeakup) return false;

      var book = this.books.find(function (b) {
        return b.id.toUpperCase() == _this.student.book_id;
      });

      if (!book || !this.currentClass) return false;

      return this.currentClass.lesson_name.includes('UNIT');
    },
    speakupClass: function speakupClass() {
      return this.classes.find(function (c) {
        return c.status == 'A' && ['A', 'I'].includes(c.status_test) && c.lesson.match('SPEAK UP');
      });
    },
    haveSpeakUp: function haveSpeakUp() {
      if (!this.student.allow_test) return false;

      if (!this.speakupClass) return false;

      var startTime = new Date(this.speakupClass.start.split('.').shift()).getTime(),
          current = Date.now();

      return current >= startTime;
    },
    inTime: function inTime() {
      var _this2 = this;

      if (this.isReview) return false;

      if (!this.unit.ead) return false;

      var currentIndex = this.units.findIndex(function (u) {
        return _this2.unit._id == u._id;
      });

      if (currentIndex < 0) return false;

      var previousUnit = this.units[currentIndex - 1],
          endedDate = new Date(previousUnit.end),
          endedTime = endedDate.getTime();

      if (previousUnit.exempt) return false;

      this.lastClass = endedTime + 432000000 - endedDate.getHours() * 60 * 60 * 1000;

      return !(this.lastClass - Date.now() < 0);
    },
    hasClass: function hasClass() {
      var _this3 = this;

      if (this.isReview) return false;

      if (this.revision) {
        if (!this.currentReview) return false;

        return this.classes.filter(function (c) {
          return c.status == 'A' && c.lesson_id == _this3.currentReview.lesson_id;
        }).length > 0;
      }

      return this.thisUnitClass ? true : false;
    },
    notFinished: function notFinished() {
      if (this.isReview) return false;

      if (!this.hasClass) return false;

      if (!this.thisUnitClass) return false;

      var startTime = new Date(this.thisUnitClass.start),
          currTime = Date.now();

      return currTime >= startTime.getTime();
    },
    unityDonePercent: function unityDonePercent() {
      var score = 0;

      this.topics.forEach(function (x) {
        if (x.finished) score += x.score;
      });

      var percent = score / this.topics.length;

      if (isNaN(percent)) return "0";

      return percent.toString();
    },
    currentClass: function currentClass() {
      var _this4 = this;

      if (this.revision) return this.lessons.find(function (l) {
        return l.lesson_id == (_this4.toReview[0] || {}).lesson_id;
      }) || {};

      return this.lessons.find(function (l) {
        return l.lesson_id == _this4.student.lesson_id && l.order == _this4.student.lesson_order && l.book_id == _this4.student.book_id;
      });
    },
    currentReview: function currentReview() {
      return this.revision ? this.toReview[0] : null;
    },
    thisUnitClass: function thisUnitClass() {
      var _this5 = this;

      var unit = this.classes.filter(function (c) {
        return c.status == 'A';
      }).find(function (c) {
        return parseInt(c.lesson.split(' ').pop()) == _this5.unit.number;
      });

      if (unit && this.unit.started) this.$store.dispatch('unit/stopUnit');

      return unit ? unit : null;
    }
  }),
  components: {
    metaPercentage: __WEBPACK_IMPORTED_MODULE_5__components_metaPercentage__["a" /* default */],
    Slick: __WEBPACK_IMPORTED_MODULE_4_vue_slick__["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapMutations */])({
    setShowLoader: 'setShowLoader'
  }), {
    startReview: function startReview(review) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                try {
                  _this6.setShowLoader(true);

                  _this6.$router.push({ name: 'revision' });
                } catch (error) {
                  console.warn(error);
                } finally {
                  _this6.setShowLoader(false);
                }

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    },
    cancelClass: function cancelClass(lesson) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var current;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this7.setShowLoader(true);

                current = _this7.classes.find(function (c) {
                  return c.type == 'U' && c.lesson_id == lesson.lesson_id && c.book_id == _this7.student.book_id;
                });

                if (!current) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 5;
                return _this7.$store.dispatch('lesson/removeClass', current.class_id);

              case 5:

                _this7.setShowLoader(false);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this7);
      }))();
    },
    startUnit: function startUnit() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var start;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // console.log('Starting unit');
                _this8.setShowLoader(true);

                start = performance.now();
                _context3.next = 4;
                return _this8.$store.dispatch('unit/startUnit');

              case 4:
                // console.log(`Start Unit took: ${(performance.now() - start)/1000}`)
                _this8.setShowLoader(false);

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this8);
      }))();
    },
    goTopic: function goTopic(topic) {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var book, unit, isCurrent, isGame, _book, _unit;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this9.clicked) {
                  _context4.next = 39;
                  break;
                }

                _this9.clicked = true;

                _this9.setShowLoader(true);

                if (_this9.student.teens) {
                  _context4.next = 33;
                  break;
                }

                book = _this9.book.title, unit = _this9.unit.number, isCurrent = topic._id == _this9.currentTopic._id, isGame = !topic.value;

                if (!_this9.revision) {
                  _context4.next = 16;
                  break;
                }

                if (!(isCurrent || topic.finished)) {
                  _context4.next = 14;
                  break;
                }

                if (!(!isGame && !topic.finished && !_this9.unit.exempt)) {
                  _context4.next = 10;
                  break;
                }

                _context4.next = 10;
                return _this9.$store.dispatch('lesson/getClasses');

              case 10:
                if (!(!_this9.inTime && !_this9.hasClass && !_this9.unit.exempt && !isGame)) {
                  _context4.next = 14;
                  break;
                }

                _context4.next = 13;
                return _this9.$store.dispatch('topic/fetchTopic', topic._id);

              case 13:

                _this9.$router.push({ name: 'topic-revision', params: { topic: topic.name } });

              case 14:
                _context4.next = 31;
                break;

              case 16:
                if (!_this9.isReview) {
                  _context4.next = 23;
                  break;
                }

                if (!topic.value) {
                  _context4.next = 21;
                  break;
                }

                _context4.next = 20;
                return _this9.$store.dispatch('topic/fetchTopic', topic._id);

              case 20:

                _this9.$router.push({ name: 'topic-review', params: { book: book, unit: unit, topic: topic.name } });

              case 21:
                _context4.next = 31;
                break;

              case 23:
                if (!(!_this9.inTime && !_this9.hasClass && (!_this9.unit.exempt || isGame))) {
                  _context4.next = 31;
                  break;
                }

                if (!(isCurrent || isGame)) {
                  _context4.next = 31;
                  break;
                }

                if (isGame) {
                  _context4.next = 28;
                  break;
                }

                _context4.next = 28;
                return _this9.$store.dispatch('lesson/getClasses');

              case 28:
                _context4.next = 30;
                return _this9.$store.dispatch('topic/fetchTopic', topic._id);

              case 30:
                _this9.$router.push({ name: 'topic', params: { book: book, unit: unit, topic: topic.name } });

              case 31:
                _context4.next = 37;
                break;

              case 33:
                _book = _this9.teensBook.title, _unit = _this9.teensUnit.number;
                _context4.next = 36;
                return _this9.$store.dispatch('teens/setTopic', topic._id);

              case 36:

                _this9.$router.push({ name: 'topic', params: { book: _book, unit: _unit, topic: topic.name } });

              case 37:

                _this9.setShowLoader(false);
                _this9.clicked = false;

              case 39:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this9);
      }))();
    },
    setInterval: function (_setInterval) {
      function setInterval() {
        return _setInterval.apply(this, arguments);
      }

      setInterval.toString = function () {
        return _setInterval.toString();
      };

      return setInterval;
    }(function () {
      var _this10 = this;

      this.interval = setInterval(function () {
        var distance = _this10.lastClass - Date.now();

        _this10.date.days = Math.floor(distance / (1000 * 60 * 60 * 24));
        _this10.date.hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
        _this10.date.minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));
        _this10.date.seconds = Math.floor(distance % (1000 * 60) / 1000);
      }, 1000);
    }),
    toDate: function toDate(date) {
      var d = new Date(date);
      return d.getTime();
    },
    madeOnPresential: function madeOnPresential(topic) {
      if (this.isReview) return false;

      if (!topic.value) return false;

      if (!this.unit.finished) return false;

      if (!this.unit.started) return true;
    },
    getPreviousClass: function getPreviousClass(lesson) {
      var _this11 = this;

      if (!lesson) return '';

      var sorted_lessons = this.lessons.filter(function (i) {
        return i.book_id == _this11.student.book_id;
      }).sort(function (a, b) {
        return a.order - b.order;
      }),
          cur_index = sorted_lessons.findIndex(function (l) {
        return l.lesson_id == lesson.lesson_id && l.order == lesson.order;
      }),
          prev_lesson = cur_index < 1 ? '' : sorted_lessons[cur_index - 1].lesson_name;

      return prev_lesson;
    },
    goToSpeakUp: function goToSpeakUp() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!_this12.haveSpeakUp) {
                  _context5.next = 19;
                  break;
                }

                _context5.prev = 1;

                _this12.setShowLoader(true);

                _context5.next = 5;
                return _this12.$store.dispatch('speakup/getSpeakUp', _this12.speakupClass.class_id);

              case 5:
                if (_this12.hasSpeakUp) {
                  _context5.next = 10;
                  break;
                }

                _context5.next = 8;
                return _this12.$store.dispatch('speakup/addSpeakUp', {
                  class_id: _this12.speakupClass.class_id,
                  date: _this12.speakupClass.start,
                  lesson_id: _this12.speakupClass.lesson_id
                });

              case 8:
                _context5.next = 10;
                return _this12.$store.dispatch('speakup/getSpeakUp', _this12.speakupClass.class_id);

              case 10:

                if (_this12.hasSpeakUp) _this12.$router.push('/speakup/' + _this12.speakupClass.class_id);
                _context5.next = 16;
                break;

              case 13:
                _context5.prev = 13;
                _context5.t0 = _context5['catch'](1);

                console.log(_context5.t0);

              case 16:
                _context5.prev = 16;

                _this12.setShowLoader(false);
                return _context5.finish(16);

              case 19:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this12, [[1, 13, 16, 19]]);
      }))();
    }
  }),
  watch: {
    unit: function unit() {
      this.$nextTick();
    },
    inTime: function inTime(val) {
      if (val) this.setInterval();else clearInterval(this.interval);
    },
    speakupClass: function speakupClass(val) {
      var _this13 = this;

      this.speakup = null;

      if (val) {
        this.$store.dispatch('speakup/verifySpeakUp', {
          lesson_id: val.lesson_id
        }).then(function (doc) {
          _this13.speakup = doc;
        }).catch(function (error) {
          console.log(error);
        });
      }
    }
  },
  beforeMount: function beforeMount() {
    var _this14 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this14.$store.dispatch('topic/setTopic');

            case 2:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this14);
    }))();
  },
  mounted: function mounted() {
    var _this15 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (_this15.inTime) _this15.setInterval();

              if (_this15.speakupClass) {
                _this15.$store.dispatch('speakup/verifySpeakUp', {
                  lesson_id: _this15.speakupClass.lesson_id
                }).then(function (doc) {
                  _this15.speakup = doc;
                }).catch(function (error) {
                  console.log(error);
                });
              }

            case 2:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this15);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.interval) clearInterval(this.interval);
  }
});

/***/ }),

/***/ 882:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_appBus__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n_js__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tools_js__ = __webpack_require__(970);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var inBrowser = typeof window !== 'undefined';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'titleComponent',
  data: function data() {
    return {
      // date: {
      //   hours: 0,
      //   minutes: 0,
      //   seconds: 0
      // },
      interval: null,
      currentDate: Date.now()
    };
  },

  props: {
    value: {
      type: String
    },
    mark: {
      type: String
    },
    color: {
      type: String,
      default: 'background-red'
    },
    button: {
      type: String
    },
    titleBtn: {
      type: Boolean,
      default: false
    },
    calendar: {
      type: Boolean,
      default: false
    },
    btnAction: {
      type: Function,
      default: function _default() {
        return console.log('Button click');
      }
    },
    showTimer: {
      type: Boolean,
      default: false
    },
    showOnlineClass: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    calendarOps: function calendarOps() {
      var dateObj = new Date();
      if (inBrowser) {
        return window.VueCalendarBarEventBus.CALENDAR_EVENTS_DATA;
      } else {
        return {
          options: {
            locale: 'pt-br',
            color: ' #ff4455'
          },
          params: {
            curYear: dateObj.getFullYear(),
            curMonth: dateObj.getMonth(),
            curDate: dateObj.getUTCDate(),
            curEventsDate: 'all'
          }
        };
      }
    },
    curYearMonth: function curYearMonth() {
      var tempDate = Date.parse(new Date(this.calendarOps.params.curYear + '/' + (this.calendarOps.params.curMonth + 1) + '/01'));
      var date = Object(__WEBPACK_IMPORTED_MODULE_4__tools_js__["a" /* dateTimeFormatter */])(tempDate, __WEBPACK_IMPORTED_MODULE_2__i18n_js__["a" /* default */][this.calendarOps.options.locale].format);
      return date;
    },
    formatedMonth: function formatedMonth() {
      var splitted = this.curYearMonth.split('/');
      switch (parseInt(splitted[0])) {
        case 1:
          splitted[0] = 'January';
          break;
        case 2:
          splitted[0] = 'February';
          break;
        case 3:
          splitted[0] = 'March';
          break;
        case 4:
          splitted[0] = 'April';
          break;
        case 5:
          splitted[0] = 'May';
          break;
        case 6:
          splitted[0] = 'June';
          break;
        case 7:
          splitted[0] = 'July';
          break;
        case 8:
          splitted[0] = 'August';
          break;
        case 9:
          splitted[0] = 'September';
          break;
        case 10:
          splitted[0] = 'October';
          break;
        case 11:
          splitted[0] = 'November';
          break;
        case 12:
          splitted[0] = 'December';
          break;
      }
      return splitted.join(' - ');
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    bookExists: 'book/exists',
    book: 'book/get',
    unitStarted: 'unit/hasStarted',
    inTime: 'unit/inTime',
    date: 'unit/date',
    student: 'student/GET',
    teensBook: 'teens/GET_CURRENT_BOOK'
  }), {
    hasBook: function hasBook() {
      if (!this.student.teens) return this.bookExists;

      return !!this.teensBook;
    },
    currentBook: function currentBook() {
      if (!this.student.teens) return this.book;

      return this.teensBook;
    }
  }),
  methods: {
    // setToday() {
    //   this.$EventCalendar.toDate(dateTimeFormatter(new Date, i18n[this.calendarOps.options.locale].format))
    // },
    nextMonth: function nextMonth() {
      this.$EventCalendar.nextMonth();
      this.$emit('month-changed', this.curYearMonth);
      var month = parseFloat(this.curYearMonth.split('/')[0]);
      this.$store.commit('lesson/setCurMonth', month);
    },
    preMonth: function preMonth() {
      this.$EventCalendar.preMonth();
      this.$emit('month-changed', this.curYearMonth);
      var month = parseFloat(this.curYearMonth.split('/')[0]);
      this.$store.commit('lesson/setCurMonth', month);
    }
  }
  // mounted () {
  //   this.setToday()
  // }
});

/***/ }),

/***/ 904:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_currentUnit_vue__ = __webpack_require__(801);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_120cbde0_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_currentUnit_vue__ = __webpack_require__(907);
function injectStyle (ssrContext) {
  __webpack_require__(905)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-120cbde0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_currentUnit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_120cbde0_hasScoped_true_transformToRequire_video_src_poster_audio_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_currentUnit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 905:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(906);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("8c6ab7f2", content, true, {});

/***/ }),

/***/ 906:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, ".slick--unit__exercices__item[data-v-120cbde0]{padding-top:13px;padding-bottom:5px;display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-transition:.1s;transition:.1s;font-weight:300}.slick--unit__exercices__item[data-v-120cbde0]:hover{cursor:pointer}.slick--unit__exercices__item:hover .slick--unit__exercices__item__image img[data-v-120cbde0]{-webkit-transform:scale(1.2);transform:scale(1.2)}.slick--unit__exercices__item .slick--unit__exercices__item__image[data-v-120cbde0]{-webkit-transition:.1s;transition:.1s;width:90px;height:80px;background:-webkit-gradient(linear,left top,left bottom,from(#e3e3e3),to(#aaa8a8));background:linear-gradient(180deg,#e3e3e3,#aaa8a8);border-radius:0 20px 0 0;position:relative}.slick--unit__exercices__item .slick--unit__exercices__item__image img[data-v-120cbde0]{-webkit-transition:.3s;transition:.3s}.slick--unit__exercices__item .slick--unit__exercices__item__image .slick--unit__exercices__item__number[data-v-120cbde0]{border-radius:8px;width:25px;height:25px;color:#fff;font-size:13px;background:#adadad;border:2px solid #dadada;position:absolute;top:-10px;left:-10px}.slick--unit__exercices__item .slick--unit__exercices__item__text[data-v-120cbde0]{background:silver;-webkit-box-shadow:0 1px 1px 0 rgba(38,174,191,.13),0 5px 4px 0 rgba(38,174,191,.17),0 -2px 1px 0 rgba(38,174,191,.13);box-shadow:0 1px 1px 0 rgba(38,174,191,.13),0 5px 4px 0 rgba(38,174,191,.17),0 -2px 1px 0 rgba(38,174,191,.13);border-radius:5px 5px 10px 10px;width:100px;height:24px;font-size:14px;color:#757575;text-align:center;font-size:12px;letter-spacing:.4px}.slick--unit__exercices__item .slick--unit__exercices__item__level .item__level--container[data-v-120cbde0]{width:100px;height:10px;margin-top:10px}.slick--unit__exercices__item .slick--unit__exercices__item__level .item__level--container .item--level[data-v-120cbde0]{width:16px;height:5px;background:#d8d8d8;margin:2px;border-radius:5px}.slick--unit__exercices__item .slick--unit__exercices__item__level .item__level--container .item--level.check[data-v-120cbde0]{background:#f5a623}.container--current-unit .container--current-unit__unit[data-v-120cbde0]{-ms-flex-preferred-size:120px;flex-basis:120px;-ms-flex-negative:100px;flex-shrink:100px;min-width:100px;margin-right:10px}.container--current-unit .container--current-unit__unit .max-width[data-v-120cbde0]{max-width:128px}.container--current-unit .container--current-unit__unit .unit-color[data-v-120cbde0]{font-size:46px;letter-spacing:.5px;line-height:40px;font-weight:700;color:#255f83}.container--current-unit .container--current-unit__unit .unit-color span[data-v-120cbde0]{color:#04b4bb}@media (max-width:440px){.container--current-unit .container--current-unit__unit .unit-color[data-v-120cbde0]{background:#dedede;padding:10px 80px;border-radius:50px;margin-bottom:20px}}.container--current-unit .container--current-unit__exercices[data-v-120cbde0]{-ms-flex-preferred-size:200px;flex-basis:200px;max-width:100%;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.container--current-unit .container--current-unit__exercices .slick--unit__exercices[data-v-120cbde0]{width:100%}@media (max-width:440px){.container--current-unit .container--current-unit__exercices[data-v-120cbde0]{min-height:220px;margin:0 0 40px}}@media (max-width:1126px){.container--current-unit[data-v-120cbde0]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-wrap:wrap;flex-wrap:wrap}}.finish .slick--unit__exercices__item__image[data-v-120cbde0]{background:-webkit-gradient(linear,left top,left bottom,from(#00ffb1),to(#039ba8));background:linear-gradient(180deg,#00ffb1,#039ba8)}.finish .slick--unit__exercices__item__image .slick--unit__exercices__item__number[data-v-120cbde0]{background:#039ba8;border-color:#00ffb1}.finish .slick--unit__exercices__item__text[data-v-120cbde0]{color:#005d64;background:#00ffb1}.finish .slick--unit__exercices__item__level .item__level--container .item--level.check[data-v-120cbde0]{background:#00ffb1}.current .slick--unit__exercices__item__image[data-v-120cbde0]{background:-webkit-gradient(linear,left top,left bottom,from(#ffac2b),to(#ff7f26));background:linear-gradient(180deg,#ffac2b,#ff7f26)}.current .slick--unit__exercices__item__image .slick--unit__exercices__item__number[data-v-120cbde0]{background:#ff7f26;border-color:#ffac2b}.current .slick--unit__exercices__item__text[data-v-120cbde0]{color:#750000;background:#ffac2b}.current .slick--unit__exercices__item__level .item__level--container .item--level.check[data-v-120cbde0]{background:#ffac2b}.todo.slick--unit__exercices__item[data-v-120cbde0]{cursor:not-allowed;opacity:.5}.todo.slick--unit__exercices__item:hover .slick--unit__exercices__item__image img[data-v-120cbde0],.todo.slick--unit__exercices__item[data-v-120cbde0]:hover{-webkit-transform:none;transform:none}.saving[data-v-120cbde0]{text-align:center;font-size:12px;color:#ff5c00;margin-bottom:5px}.saving span[data-v-120cbde0]{color:#255f83}@media (max-width:440px){.mobile_hide[data-v-120cbde0]{display:none}}.presential-unit[data-v-120cbde0]{cursor:not-allowed;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:32px;width:100%;height:100%;background-color:hsla(0,0%,100%,.85);position:absolute;top:0;left:0;border-radius:10px}@media (max-width:440px){.presential-unit[data-v-120cbde0]{height:250px}}.has-class[data-v-120cbde0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.has-class p[data-v-120cbde0]:first-child{margin-bottom:5px}.topic-warning[data-v-120cbde0]{position:absolute;z-index:100;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;font-weight:700;height:calc(100% - 70px);color:#c7031d;height:100%;width:100%;padding-top:13px;padding-bottom:21px}.topic-warning p[data-v-120cbde0]{width:100px;height:24px;padding:5px 10px;background:hsla(0,0%,100%,.6);border-radius:5px 5px 10px 10px}.topic-warning svg[data-v-120cbde0]{width:50px;height:50px;background:hsla(0,0%,100%,.6);padding:5px;border-radius:50%}[data-v-120cbde0]:focus{outline:none!important;outline-color:none!important}.bgwhite[data-v-120cbde0]{background:#fff!important}.letter-spacing-05[data-v-120cbde0]{letter-spacing:.5px}.item[data-v-120cbde0]{-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:100%}.item__alert[data-v-120cbde0]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-left:30px;-ms-flex-preferred-size:35%;flex-basis:35%;margin-right:20px}.item__msg[data-v-120cbde0]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-preferred-size:50%;flex-basis:50%}@media (max-width:440px){.item__msg[data-v-120cbde0]{margin-left:15px}}.item__msgtwo[data-v-120cbde0]{font-weight:300;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:40px!important;margin:5px 20px 23px;-ms-flex-preferred-size:100%;flex-basis:100%;height:70px}@media (max-width:440px){.item__msgtwo p[data-v-120cbde0]{white-space:normal}}.item__btn[data-v-120cbde0]{width:100%;height:100%;font-size:15px!important;border-radius:300px;padding:0;text-transform:uppercase}@media (max-width:440px){.item__btn[data-v-120cbde0]{margin-top:20px}}.item__status[data-v-120cbde0]{width:100%;height:100%;padding:0;color:#797979;background:#eaeaea;border:2px solid #b4b4b4;border-radius:300px;font-weight:300;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center;display:-webkit-box;display:-ms-flexbox;display:flex}@media (max-width:440px){.item__status[data-v-120cbde0]{padding:30px;margin-top:30px}}.item .boxmsg[data-v-120cbde0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.item .boxmsg h1[data-v-120cbde0]{font-size:25px;font-weight:400;text-transform:uppercase;color:orange;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.item .boxmsg h1 span[data-v-120cbde0]{height:7px;width:102px;background-color:orange;border-radius:300px;margin:0 10px 0 0}.item .boxmsg h2[data-v-120cbde0]{font-weight:400;letter-spacing:-1px;text-transform:uppercase;margin-top:-5px}.item .boxmsg h3[data-v-120cbde0]{font-size:15px;font-weight:200;color:gray;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-right:15px}.item .boxmsg h3 span[data-v-120cbde0]{font-weight:400;font-size:16px;color:#ff7f00;display:contents}.item .boxmsg img[data-v-120cbde0]{width:70px;margin:0 5px 0 0}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/pages/home/currentUnit.vue"],"names":[],"mappings":"AACA,+CACE,iBAAkB,AAClB,mBAAoB,AACpB,8BAAgC,AAChC,8BAAgC,AAChC,uBAAyB,AACzB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,uBAAyB,AACzB,eAAiB,AACjB,eAAiB,CAClB,AACD,qDACI,cAAgB,CACnB,AACD,8FACM,6BAAmC,AAC3B,oBAA2B,CACxC,AACD,oFACI,uBAAyB,AACzB,eAAiB,AACjB,WAAY,AACZ,YAAa,AACb,mFAAwF,AACxF,mDAAyD,AACzD,yBAA0B,AAC1B,iBAAmB,CACtB,AACD,wFACM,uBAAyB,AACzB,cAAiB,CACtB,AACD,0HACM,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,eAAgB,AAChB,mBAAoB,AACpB,yBAA0B,AAC1B,kBAAmB,AACnB,UAAW,AACX,UAAY,CACjB,AACD,mFACI,kBAAoB,AACpB,uHAAsI,AAC9H,+GAA8H,AACtI,gCAAiC,AACjC,YAAa,AACb,YAAa,AACb,eAAgB,AAChB,cAAe,AACf,kBAAmB,AACnB,eAAgB,AAChB,mBAAqB,CACxB,AACD,4GACI,YAAa,AACb,YAAa,AACb,eAAiB,CACpB,AACD,yHACM,WAAY,AACZ,WAAY,AACZ,mBAAoB,AACpB,WAAY,AACZ,iBAAmB,CACxB,AACD,+HACQ,kBAAoB,CAC3B,AACD,yEACE,8BAA+B,AAC3B,iBAAkB,AACtB,wBAAyB,AACrB,kBAAmB,AACvB,gBAAiB,AACjB,iBAAmB,CACpB,AACD,oFACI,eAAiB,CACpB,AACD,qFACI,eAAgB,AAChB,oBAAqB,AACrB,iBAAkB,AAClB,gBAAkB,AAClB,aAAe,CAClB,AACD,0FACM,aAAe,CACpB,AACD,yBACA,qFACQ,mBAAoB,AACpB,kBAAmB,AACnB,mBAAoB,AACpB,kBAAoB,CAC3B,CACA,AACD,8EACE,8BAA+B,AAC3B,iBAAkB,AACtB,eAAgB,AAChB,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CACtB,AACD,sGACI,UAAY,CACf,AACD,yBACA,8EACM,iBAAkB,AAClB,eAAyB,CAC9B,CACA,AACD,0BACA,0CACI,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,mBAAoB,AAChB,cAAgB,CACvB,CACA,AACD,8DACE,mFAAwF,AACxF,kDAAyD,CAC1D,AACD,oGACI,mBAAoB,AACpB,oBAAsB,CACzB,AACD,6DACE,cAAe,AACf,kBAAoB,CACrB,AACD,yGACE,kBAAoB,CACrB,AACD,+DACE,mFAAwF,AACxF,kDAAyD,CAC1D,AACD,qGACI,mBAAoB,AACpB,oBAAsB,CACzB,AACD,8DACE,cAAe,AACf,kBAAoB,CACrB,AACD,0GACE,kBAAoB,CACrB,AACD,oDACE,mBAAoB,AACpB,UAAa,CACd,AAKD,6JACM,uBAAwB,AAChB,cAAgB,CAC7B,AACD,yBACE,kBAAmB,AACnB,eAAgB,AAChB,cAAe,AACf,iBAAmB,CACpB,AACD,8BACI,aAAe,CAClB,AACD,yBACA,8BACI,YAAc,CACjB,CACA,AACD,kCACE,mBAAoB,AACpB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,eAAgB,AAChB,WAAY,AACZ,YAAa,AACb,qCAA4C,AAC5C,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,kBAAoB,CACrB,AACD,yBACA,kCACM,YAAc,CACnB,CACA,AACD,4BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAChC,AACD,0CACI,iBAAmB,CACtB,AACD,gCACE,kBAAmB,AACnB,YAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,6BAA8B,AAClC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,gBAAkB,AAClB,yBAA0B,AAC1B,cAAe,AACf,YAAa,AACb,WAAY,AACZ,iBAAkB,AAClB,mBAAqB,CACtB,AACD,kCACI,YAAa,AACb,YAAa,AACb,iBAAkB,AAClB,8BAAqC,AACrC,+BAAiC,CACpC,AACD,oCACI,WAAY,AACZ,YAAa,AACb,8BAAqC,AACrC,YAAa,AACb,iBAAmB,CACtB,AACD,wBACE,uBAAyB,AACzB,4BAA+B,CAChC,AACD,0BACE,yBAA6B,CAC9B,AACD,oCACE,mBAAqB,CACtB,AACD,uBACE,mBAAoB,AAChB,eAAgB,AACpB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,WAAa,CACd,AACD,8BACI,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,kBAAmB,AACnB,4BAA6B,AACzB,eAAgB,AACpB,iBAAmB,CACtB,AACD,4BACI,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,4BAA6B,AACzB,cAAgB,CACvB,AACD,yBACA,4BACQ,gBAAkB,CACzB,CACA,AACD,+BACI,gBAAiB,AACjB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,sBAAwB,AACxB,qBAA2B,AAC3B,6BAA8B,AAC1B,gBAAiB,AACrB,WAAa,CAChB,AACD,yBACA,iCACQ,kBAAoB,CAC3B,CACA,AACD,4BACI,WAAY,AACZ,YAAa,AACb,yBAA2B,AAC3B,oBAAqB,AACrB,UAAa,AACb,wBAA0B,CAC7B,AACD,yBACA,4BACQ,eAAiB,CACxB,CACA,AACD,+BACI,WAAY,AACZ,YAAa,AACb,UAAa,AACb,cAAe,AACf,mBAAoB,AACpB,yBAA0B,AAC1B,oBAAqB,AACrB,gBAAiB,AACjB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AACD,yBACA,+BACQ,aAAc,AACd,eAAiB,CACxB,CACA,AACD,+BACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,mBAAoB,AAChB,oBAAqB,AACjB,WAAa,CACxB,AACD,kCACM,eAAgB,AAChB,gBAAiB,AACjB,yBAA0B,AAC1B,aAAc,AACd,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CACjC,AACD,uCACQ,WAAY,AACZ,YAAa,AACb,wBAAyB,AACzB,oBAAqB,AACrB,iBAAyB,CAChC,AACD,kCACM,gBAAiB,AACjB,oBAAqB,AACrB,yBAA0B,AAC1B,eAAiB,CACtB,AACD,kCACM,eAAgB,AAChB,gBAAiB,AACjB,WAAY,AACZ,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,kBAAoB,CACzB,AACD,uCACQ,gBAAiB,AACjB,eAAgB,AAChB,cAAe,AACf,gBAAkB,CACzB,AACD,mCACM,WAAY,AACZ,gBAAwB,CAC7B","file":"currentUnit.vue","sourcesContent":["\n.slick--unit__exercices__item[data-v-120cbde0] {\n  padding-top: 13px;\n  padding-bottom: 5px;\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-transition: 0.1s;\n  transition: 0.1s;\n  font-weight: 300;\n}\n.slick--unit__exercices__item[data-v-120cbde0]:hover {\n    cursor: pointer;\n}\n.slick--unit__exercices__item:hover .slick--unit__exercices__item__image img[data-v-120cbde0] {\n      -webkit-transform: scale(1.2, 1.2);\n              transform: scale(1.2, 1.2);\n}\n.slick--unit__exercices__item .slick--unit__exercices__item__image[data-v-120cbde0] {\n    -webkit-transition: 0.1s;\n    transition: 0.1s;\n    width: 90px;\n    height: 80px;\n    background: -webkit-gradient(linear, left top, left bottom, from(#E3E3E3), to(#AAA8A8));\n    background: linear-gradient(to bottom, #E3E3E3, #AAA8A8);\n    border-radius: 0 20px 0 0;\n    position: relative;\n}\n.slick--unit__exercices__item .slick--unit__exercices__item__image img[data-v-120cbde0] {\n      -webkit-transition: 0.3s;\n      transition: 0.3s;\n}\n.slick--unit__exercices__item .slick--unit__exercices__item__image .slick--unit__exercices__item__number[data-v-120cbde0] {\n      border-radius: 8px;\n      width: 25px;\n      height: 25px;\n      color: #fff;\n      font-size: 13px;\n      background: #ADADAD;\n      border: 2px solid #DADADA;\n      position: absolute;\n      top: -10px;\n      left: -10px;\n}\n.slick--unit__exercices__item .slick--unit__exercices__item__text[data-v-120cbde0] {\n    background: #c0c0c0;\n    -webkit-box-shadow: 0 1px 1px 0 rgba(38, 174, 191, 0.13), 0 5px 4px 0 rgba(38, 174, 191, 0.17), 0 -2px 1px 0 rgba(38, 174, 191, 0.13);\n            box-shadow: 0 1px 1px 0 rgba(38, 174, 191, 0.13), 0 5px 4px 0 rgba(38, 174, 191, 0.17), 0 -2px 1px 0 rgba(38, 174, 191, 0.13);\n    border-radius: 5px 5px 10px 10px;\n    width: 100px;\n    height: 24px;\n    font-size: 14px;\n    color: #757575;\n    text-align: center;\n    font-size: 12px;\n    letter-spacing: .4px;\n}\n.slick--unit__exercices__item .slick--unit__exercices__item__level .item__level--container[data-v-120cbde0] {\n    width: 100px;\n    height: 10px;\n    margin-top: 10px;\n}\n.slick--unit__exercices__item .slick--unit__exercices__item__level .item__level--container .item--level[data-v-120cbde0] {\n      width: 16px;\n      height: 5px;\n      background: #D8D8D8;\n      margin: 2px;\n      border-radius: 5px;\n}\n.slick--unit__exercices__item .slick--unit__exercices__item__level .item__level--container .item--level.check[data-v-120cbde0] {\n        background: #F5A623;\n}\n.container--current-unit .container--current-unit__unit[data-v-120cbde0] {\n  -ms-flex-preferred-size: 120px;\n      flex-basis: 120px;\n  -ms-flex-negative: 100px;\n      flex-shrink: 100px;\n  min-width: 100px;\n  margin-right: 10px;\n}\n.container--current-unit .container--current-unit__unit .max-width[data-v-120cbde0] {\n    max-width: 128px;\n}\n.container--current-unit .container--current-unit__unit .unit-color[data-v-120cbde0] {\n    font-size: 46px;\n    letter-spacing: .5px;\n    line-height: 40px;\n    font-weight: bold;\n    color: #255F83;\n}\n.container--current-unit .container--current-unit__unit .unit-color span[data-v-120cbde0] {\n      color: #04B4BB;\n}\n@media (max-width: 440px) {\n.container--current-unit .container--current-unit__unit .unit-color[data-v-120cbde0] {\n        background: #dedede;\n        padding: 10px 80px;\n        border-radius: 50px;\n        margin-bottom: 20px;\n}\n}\n.container--current-unit .container--current-unit__exercices[data-v-120cbde0] {\n  -ms-flex-preferred-size: 200px;\n      flex-basis: 200px;\n  max-width: 100%;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n.container--current-unit .container--current-unit__exercices .slick--unit__exercices[data-v-120cbde0] {\n    width: 100%;\n}\n@media (max-width: 440px) {\n.container--current-unit .container--current-unit__exercices[data-v-120cbde0] {\n      min-height: 220px;\n      margin: 0px 0px 40px 0px;\n}\n}\n@media (max-width: 1126px) {\n.container--current-unit[data-v-120cbde0] {\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n}\n.finish .slick--unit__exercices__item__image[data-v-120cbde0] {\n  background: -webkit-gradient(linear, left top, left bottom, from(#00FFB1), to(#039BA8));\n  background: linear-gradient(to bottom, #00FFB1, #039BA8);\n}\n.finish .slick--unit__exercices__item__image .slick--unit__exercices__item__number[data-v-120cbde0] {\n    background: #039BA8;\n    border-color: #00FFB1;\n}\n.finish .slick--unit__exercices__item__text[data-v-120cbde0] {\n  color: #005D64;\n  background: #00FFB1;\n}\n.finish .slick--unit__exercices__item__level .item__level--container .item--level.check[data-v-120cbde0] {\n  background: #00FFB1;\n}\n.current .slick--unit__exercices__item__image[data-v-120cbde0] {\n  background: -webkit-gradient(linear, left top, left bottom, from(#FFAC2B), to(#FF7F26));\n  background: linear-gradient(to bottom, #FFAC2B, #FF7F26);\n}\n.current .slick--unit__exercices__item__image .slick--unit__exercices__item__number[data-v-120cbde0] {\n    background: #FF7F26;\n    border-color: #FFAC2B;\n}\n.current .slick--unit__exercices__item__text[data-v-120cbde0] {\n  color: #750000;\n  background: #FFAC2B;\n}\n.current .slick--unit__exercices__item__level .item__level--container .item--level.check[data-v-120cbde0] {\n  background: #FFAC2B;\n}\n.todo.slick--unit__exercices__item[data-v-120cbde0] {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n.todo.slick--unit__exercices__item[data-v-120cbde0]:hover {\n    -webkit-transform: none;\n            transform: none;\n}\n.todo.slick--unit__exercices__item:hover .slick--unit__exercices__item__image img[data-v-120cbde0] {\n      -webkit-transform: none;\n              transform: none;\n}\n.saving[data-v-120cbde0] {\n  text-align: center;\n  font-size: 12px;\n  color: #FF5C00;\n  margin-bottom: 5px;\n}\n.saving span[data-v-120cbde0] {\n    color: #255F83;\n}\n@media (max-width: 440px) {\n.mobile_hide[data-v-120cbde0] {\n    display: none;\n}\n}\n.presential-unit[data-v-120cbde0] {\n  cursor: not-allowed;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  font-size: 32px;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.85);\n  position: absolute;\n  top: 0;\n  left: 0;\n  border-radius: 10px;\n}\n@media (max-width: 440px) {\n.presential-unit[data-v-120cbde0] {\n      height: 250px;\n}\n}\n.has-class[data-v-120cbde0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.has-class p[data-v-120cbde0]:first-child {\n    margin-bottom: 5px;\n}\n.topic-warning[data-v-120cbde0] {\n  position: absolute;\n  z-index: 100;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  font-weight: bold;\n  height: calc(100% - 70px);\n  color: #c7031d;\n  height: 100%;\n  width: 100%;\n  padding-top: 13px;\n  padding-bottom: 21px;\n}\n.topic-warning p[data-v-120cbde0] {\n    width: 100px;\n    height: 24px;\n    padding: 5px 10px;\n    background: rgba(255, 255, 255, 0.6);\n    border-radius: 5px 5px 10px 10px;\n}\n.topic-warning svg[data-v-120cbde0] {\n    width: 50px;\n    height: 50px;\n    background: rgba(255, 255, 255, 0.6);\n    padding: 5px;\n    border-radius: 50%;\n}\n[data-v-120cbde0]:focus {\n  outline: none !important;\n  outline-color: none !important;\n}\n.bgwhite[data-v-120cbde0] {\n  background: white !important;\n}\n.letter-spacing-05[data-v-120cbde0] {\n  letter-spacing: .5px;\n}\n.item[data-v-120cbde0] {\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 100%;\n}\n.item__alert[data-v-120cbde0] {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    padding-left: 30px;\n    -ms-flex-preferred-size: 35%;\n        flex-basis: 35%;\n    margin-right: 20px;\n}\n.item__msg[data-v-120cbde0] {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -ms-flex-preferred-size: 50%;\n        flex-basis: 50%;\n}\n@media (max-width: 440px) {\n.item__msg[data-v-120cbde0] {\n        margin-left: 15px;\n}\n}\n.item__msgtwo[data-v-120cbde0] {\n    font-weight: 300;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    height: 40px !important;\n    margin: 5px 20px 23px 20px;\n    -ms-flex-preferred-size: 100%;\n        flex-basis: 100%;\n    height: 70px;\n}\n@media (max-width: 440px) {\n.item__msgtwo p[data-v-120cbde0] {\n        white-space: normal;\n}\n}\n.item__btn[data-v-120cbde0] {\n    width: 100%;\n    height: 100%;\n    font-size: 15px !important;\n    border-radius: 300px;\n    padding: 0px;\n    text-transform: uppercase;\n}\n@media (max-width: 440px) {\n.item__btn[data-v-120cbde0] {\n        margin-top: 20px;\n}\n}\n.item__status[data-v-120cbde0] {\n    width: 100%;\n    height: 100%;\n    padding: 0px;\n    color: #797979;\n    background: #eaeaea;\n    border: 2px solid #b4b4b4;\n    border-radius: 300px;\n    font-weight: 300;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    text-align: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n@media (max-width: 440px) {\n.item__status[data-v-120cbde0] {\n        padding: 30px;\n        margin-top: 30px;\n}\n}\n.item .boxmsg[data-v-120cbde0] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n}\n.item .boxmsg h1[data-v-120cbde0] {\n      font-size: 25px;\n      font-weight: 400;\n      text-transform: uppercase;\n      color: orange;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n}\n.item .boxmsg h1 span[data-v-120cbde0] {\n        height: 7px;\n        width: 102px;\n        background-color: orange;\n        border-radius: 300px;\n        margin: 0px 10px 0px 0px;\n}\n.item .boxmsg h2[data-v-120cbde0] {\n      font-weight: 400;\n      letter-spacing: -1px;\n      text-transform: uppercase;\n      margin-top: -5px;\n}\n.item .boxmsg h3[data-v-120cbde0] {\n      font-size: 15px;\n      font-weight: 200;\n      color: gray;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      padding-right: 15px;\n}\n.item .boxmsg h3 span[data-v-120cbde0] {\n        font-weight: 400;\n        font-size: 16px;\n        color: #ff7f00;\n        display: contents;\n}\n.item .boxmsg img[data-v-120cbde0] {\n      width: 70px;\n      margin: 0px 5px 0px 0px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 907:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container hidden container--current-unit align-items-center"},[_c('div',{staticClass:"container--current-unit__unit container column justify-content-center align-items-center animation-fade animation-delay-05"},[_c('span',{staticClass:"unit-color letter-spacing-05"},[_vm._v("UN"),_c('span',[_vm._v(_vm._s(_vm.data.number > 9 ? _vm.data.number : ("0" + (_vm.data.number))))])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container align-items-start width-full max-width mobile_hide"},[_vm._m(1),_vm._v(" "),_c('metaPercentage',{staticClass:"flex-grow-1",attrs:{"percentage":_vm.unityDonePercent,"height":"46","border-radius":"4"}})],1)]),_vm._v(" "),_c('div',{staticClass:"container--current-unit__exercices container align-items-center full-height relative"},[(_vm.topics.length)?_c('slick',{ref:"slick",staticClass:"slick--unit__exercices",attrs:{"options":_vm.slickOptions}},_vm._l((_vm.topics),function(topic,index){return _c('div',{key:index},[_c('a',{on:{"click":function($event){$event.preventDefault();return _vm.goTopic(topic)}}},[_c('div',{staticClass:"slick--unit__exercices__item container column justify-content-center align-items-center animation-bottom relative",class:{
                 finish: topic.finished && !_vm.isReview,
                 current: ((topic._id == _vm.currentTopic._id) && !topic.finished && !_vm.unit.finished && !_vm.isReview && !_vm.student.teens)
                       || (!topic.value && !topic.finished && !_vm.isReview && !_vm.student.teens)
                       || (_vm.isReview && !!topic.value && !_vm.student.teens)
                       || (_vm.isReview && !topic.value && topic.finished && !_vm.student.teens)
                       || (!!_vm.student.teens && !topic.finished),
                 todo: ((!topic.finished && (topic._id != _vm.currentTopic._id) && !!topic.value) && !_vm.isReview && !_vm.student.teens)
                    || (!topic.value && !topic.finished && _vm.isReview && !_vm.student.teens)
                    || (_vm.unit.finished && !topic.finished && !!topic.value && !_vm.isReview && !_vm.student.teens)
                    || (_vm.madeOnPresential(topic) && !_vm.student.teens)
                    || (_vm.revision && !topic.value && !_vm.student.teens)
                },style:({ animationDelay: (index / 5) + 's', cursor: _vm.clicked ? 'not-allowed' : 'pointer' })},[(_vm.madeOnPresential(topic))?_c('span',{staticClass:"topic-warning"},[_c('font-awesome-icon',{attrs:{"icon":"ban"}}),_vm._v(" "),_c('p',[_vm._v("Presencial")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"slick--unit__exercices__item__image container justify-content-center align-items-center"},[_c('div',{staticClass:"slick--unit__exercices__item__number container justify-content-center align-items-center"},[_c('span',[_vm._v(_vm._s(index + 1))])]),_vm._v(" "),_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__(908)("./" + _vm.topicImage[index] + '.svg'),"width":"40","alt":topic.name}})]),_vm._v(" "),_c('div',{staticClass:"slick--unit__exercices__item__text container justify-content-center align-items-center"},[_c('span',[_vm._v(_vm._s(topic.name))])]),_vm._v(" "),_c('div',{staticClass:"slick--unit__exercices__item__level container justify-content-center align-items-center"},[_c('div',{staticClass:"item__level--container container align-items-center",staticStyle:{"justify-content":"space-evenly"}},[_c('div',{staticClass:"item--level",class:{ check : topic.score >= 25 }}),_vm._v(" "),_c('div',{staticClass:"item--level",class:{ check : topic.score >= 50 }}),_vm._v(" "),_c('div',{staticClass:"item--level",class:{ check : topic.score >= 75 }}),_vm._v(" "),_c('div',{staticClass:"item--level",class:{ check : topic.score == 100 }})])])])])])}),0):_c('div',{staticClass:"slick--unit__exercices"},[_vm._v("\r\n      Loading Topics...\r\n    ")]),_vm._v(" "),(!_vm.isUnitClass && !_vm.isFinished && !_vm.haveSpeakUp && !_vm.student.teens)?_c('div',{staticClass:"bgwhite presential-unit container justify-content-center color-red animation-fade"},[_c('div',{staticClass:"container item full-width"},[_c('div',{staticClass:"boxmsg item__alert"},[_vm._m(2),_vm._v(" "),_c('h2',{staticStyle:{"font-size":"32px !important"}},[_vm._v(_vm._s(_vm.currentClass ? _vm.currentClass.lesson_name : ''))])]),_vm._v(" "),_c('div',{staticClass:"boxmsg item__msg"},[_c('img',{attrs:{"src":__webpack_require__(667),"height":"60px","alt":"Attention"}}),_vm._v(" "),_c('h3',{staticClass:"container"},[_vm._v("Você tem uma aula complementar de "),_c('span',[_vm._v(_vm._s(_vm.currentClass ? _vm.currentClass.lesson_name : ''))]),_vm._v(" a ser feita em sua escola. Bons estudos!")])]),_vm._v(" "),_vm._m(3)])]):(!_vm.isUnitClass && !_vm.isFinished && _vm.haveSpeakUp && !_vm.student.teens)?_c('div',{staticClass:"bgwhite presential-unit container justify-content-center color-red animation-fade"},[_c('div',{staticClass:"container item full-width"},[_c('div',{staticClass:"boxmsg item__alert"},[_vm._m(4),_vm._v(" "),_c('h2',{staticStyle:{"font-size":"32px !important"}},[_vm._v(_vm._s(_vm.speakupClass.lesson))])]),_vm._v(" "),_c('div',{staticClass:"boxmsg item__msg"},[_c('img',{attrs:{"src":__webpack_require__(667),"height":"60px","alt":"Attention"}}),_vm._v(" "),_c('h3',{staticClass:"container"},[_vm._v("Você tem uma aula complementar de "),_c('span',[_vm._v(_vm._s(_vm.speakupClass ? _vm.speakupClass.lesson : ''))]),_vm._v(" a ser feita.")])]),_vm._v(" "),_c('div',{staticClass:"boxmsg item__msgtwo"},[_c('div',{staticClass:"full-width full-height",staticStyle:{"font-size":"16px!important"}},[_c('button',{staticClass:"item__btn btn btn-full btn-gradient-blue",attrs:{"type":"button"},on:{"click":function($event){return _vm.goToSpeakUp()}}},[_vm._v("Go to Speak Up")])])])])]):(!_vm.unit.ead && !_vm.student.teens)?_c('div',{staticClass:"bgwhite presential-unit container justify-content-center color-red animation-fade"},[_c('div',{staticClass:"container item full-width"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"boxmsg item__msg"},[_c('img',{attrs:{"src":__webpack_require__(698),"height":"60px","alt":"Attention"}}),_vm._v(" "),_c('h3',{staticClass:"container"},[_c('span',[_vm._v(_vm._s(_vm.currentClass.lesson_name))]),_vm._v(" deve ser feita "),_c('span',[_vm._v("presencialmente!")]),_vm._v(" Aguardamos você na próxima unidade EAD.")])]),_vm._v(" "),_vm._m(6)])]):(_vm.inTime && !_vm.isFinished && !_vm.student.teens)?_c('div',{staticClass:"bgwhite presential-unit container justify-content-center color-red animation-fade"},[_c('div',{staticClass:"container item full-width"},[_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('div',{staticClass:"boxmsg item__msgtwo"},[_c('div',{staticClass:"item__status btn btn-full",staticStyle:{"font-size":"16px!important"}},[_c('span',{staticStyle:{"color":"#FF7700!important"}},[_vm._v("Wait")]),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.date.days)+" ")]),_vm._v(" Days "),_c('span',[_vm._v(" "+_vm._s(_vm.date.hours)+" ")]),_vm._v(" Hours "),_c('span',[_vm._v(" "+_vm._s(_vm.date.minutes)+" ")]),_vm._v(" Minutes and "),_c('span',[_vm._v(" "+_vm._s(_vm.date.seconds)+" ")]),_vm._v("Seconds\r\n            ")])])])]):(_vm.hasClass && !_vm.isFinished && !_vm.notFinished && !_vm.isReview && !_vm.student.teens)?_c('div',{staticClass:"bgwhite presential-unit container justify-content-center color-red animation-fade has-class"},[_c('div',{staticClass:"container item full-width"},[_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('div',{staticClass:"boxmsg item__msgtwo"},[_c('div',{staticClass:"full-width full-height",staticStyle:{"font-size":"16px!important"}},[_c('button',{staticClass:"item__btn btn btn-full btn-gradient-red",attrs:{"type":"button"},on:{"click":function($event){return _vm.cancelClass(_vm.currentClass)}}},[_vm._v("Cancel class")])])])])]):(_vm.hasClass && !_vm.isFinished && _vm.notFinished && _vm.thisUnitClass.lesson.includes(_vm.unit.number) && !_vm.isReview && !_vm.student.teens)?_c('div',{staticClass:"bgwhite presential-unit container justify-content-center column color-red animation-fade has-class"},[_c('div',{staticClass:"container item full-width"},[_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('div',{staticClass:"boxmsg item__msgtwo"},[_c('div',{staticClass:"full-width full-height container wrap",staticStyle:{"font-size":"16px!important"}},[_c('button',{staticClass:"item__status btn btn-full",staticStyle:{"padding":"0px 30px","margin-right":"15px","flex-basis":"300px","flex-grow":"1"},attrs:{"type":"button"}},[_vm._v("Enquanto isso treine seu inglês na sala virtual.")]),_vm._v(" "),_c('router-link',{staticClass:"btn-gradient-orange btn btn-full",staticStyle:{"flex-basis":"180px","flex-grow":"1","height":"40px","border-radius":"200px"},attrs:{"to":{ name: 'salaVirtual' }}},[_vm._v("\r\n                Virtual Classroom")])],1)])])]):(!_vm.unit.started && !_vm.isFinished && !_vm.isReview && !_vm.student.teens)?_c('div',{staticClass:"bgwhite presential-unit container justify-content-center color-red animation-fade flex-column"},[_c('div',{staticClass:"container item full-width"},[_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_c('div',{staticClass:"boxmsg item__msgtwo"},[_c('div',{staticClass:"full-width full-height",staticStyle:{"font-size":"16px!important"}},[_c('button',{staticClass:"item__btn btn btn-full btn-gradient-orange",attrs:{"type":"button"},on:{"click":function($event){return _vm.startUnit()}}},[_vm._v("Start Unit")])])])])]):(_vm.isFinished && !_vm.unit.finished && _vm.unit.tries > 0 && !_vm.student.teens)?_c('div',{staticClass:"bgwhite presential-unit container justify-content-center color-red animation-fade flex-column"},[_c('div',{staticClass:"container item full-width"},[_vm._m(15),_vm._v(" "),_c('div',{staticClass:"boxmsg item__msg"},[_c('img',{attrs:{"src":__webpack_require__(697),"height":"60px","alt":"Attention"}}),_vm._v(" "),_c('h3',{staticClass:"container"},[_vm._v("Você não alcançou 70 pontos, ainda restam "+_vm._s(2 - _vm.unit.tries)+" / 2 chances para finalizar a unidade.")])]),_vm._v(" "),_c('div',{staticClass:"boxmsg item__msgtwo"},[_c('div',{staticClass:"full-width full-height",staticStyle:{"font-size":"16px!important"}},[_c('button',{staticClass:"item__btn btn btn-full btn-gradient-orange",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.$store.dispatch('unit/reset')}}},[_vm._v("Try again")])])])])]):(_vm.isFinished && !_vm.unit.finished && !_vm.student.teens)?_c('div',{staticClass:"bgwhite presential-unit container justify-content-center color-red animation-fade flex-column"},[_vm._m(16)]):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',{staticClass:"saving letter-spacing-05 mobile_hide"},[_c('span',[_vm._v("Gravando")]),_vm._v(" conteúdo")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"margin-right-10"},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__(695),"width":"40","alt":"Minds"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_c('span'),_vm._v(" Attention!")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxmsg item__msgtwo"},[_c('div',{staticClass:"item__status btn btn-full",staticStyle:{"font-size":"16px!important"}},[_c('p',[_vm._v("Esta aula deve ser feita presencialmente.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_c('span'),_vm._v(" Attention!")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxmsg item__alert"},[_c('h1',[_c('span'),_vm._v(" Attention!")]),_vm._v(" "),_c('h2',{staticStyle:{"font-size":"27px"}},[_vm._v("classroom lesson")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxmsg item__msgtwo"},[_c('div',{staticClass:"item__status btn btn-full",staticStyle:{"font-size":"14.5px!important"}},[_c('p',[_vm._v("Caso não tenha agendado sua aula, entre em contato com sua escola!")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxmsg item__alert"},[_c('h1',[_c('span'),_vm._v(" Attention!")]),_vm._v(" "),_c('h2',{staticStyle:{"font-size":"38.9px!important"}},[_vm._v("Have a class")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxmsg item__msg"},[_c('img',{attrs:{"src":__webpack_require__(702),"height":"60px","alt":"Attention"}}),_vm._v(" "),_c('h3',{staticClass:"container"},[_vm._v("Para continuar com seus estudos aguarde o "),_c('span',[_vm._v("tempo abaixo")]),_vm._v(" e faça sua preparação para próxima unidade!")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxmsg item__alert"},[_c('h1',[_c('span'),_vm._v(" Attention!")]),_vm._v(" "),_c('h2',{staticStyle:{"font-size":"29.9px!important"}},[_vm._v("scheduled class")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxmsg item__msg"},[_c('img',{attrs:{"src":__webpack_require__(699),"height":"60px","alt":"Attention"}}),_vm._v(" "),_c('h3',{staticClass:"container"},[_vm._v("Você tem uma "),_c('span',[_vm._v("aula agêndada")]),_vm._v(" para esta unidade. Caso queira continuar online clicle no botão abaixo.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxmsg item__alert"},[_c('h1',[_c('span'),_vm._v(" Attention!")]),_vm._v(" "),_c('h2',{staticStyle:{"font-size":"25.9px!important"}},[_vm._v("waiting for the end")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxmsg item__msg"},[_c('img',{attrs:{"src":__webpack_require__(700),"height":"55px","alt":"Attention"}}),_vm._v(" "),_c('h3',{staticClass:"container"},[_vm._v("O sistema esta aguardando a finalização desta unidade para liberação do próximo conteúdo.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxmsg item__alert"},[_c('h1',[_c('span'),_vm._v(" Attention!")]),_vm._v(" "),_c('h2',{staticStyle:{"font-size":"48.9px!important"}},[_vm._v("Start unit")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxmsg item__msg"},[_c('img',{attrs:{"src":__webpack_require__(703),"height":"60px","alt":"Attention"}}),_vm._v(" "),_c('h3',{staticClass:"container"},[_vm._v("Vamos começar a estudar! Clique no botão abaixo para liberar sua aula atual!")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxmsg item__alert"},[_c('h1',[_c('span'),_vm._v(" Attention!")]),_vm._v(" "),_c('h2',{staticStyle:{"font-size":"32.9px!important"}},[_vm._v("Second chance")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container item full-width"},[_c('div',{staticClass:"boxmsg item__alert"},[_c('h1',[_c('span'),_vm._v(" Attention!")]),_vm._v(" "),_c('h2',{staticStyle:{"font-size":"56.9px!important"}},[_vm._v("You Lost")])]),_vm._v(" "),_c('div',{staticClass:"boxmsg item__msg"},[_c('img',{attrs:{"src":__webpack_require__(701),"height":"60px","alt":"Attention"}}),_vm._v(" "),_c('h3',{staticClass:"container"},[_vm._v("Você usou "),_c('span',[_vm._v(" 2 / 2 chances ")]),_vm._v("para finalizar a unidade com média. Entre em contato com sua escola.")])]),_vm._v(" "),_c('div',{staticClass:"boxmsg item__msgtwo"},[_c('div',{staticClass:"item__status btn btn-full",staticStyle:{"font-size":"16px!important"}},[_c('p',[_vm._v(" Marque sua aula presencialmente para tentar novamente.")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 908:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./all_ears.svg": 708,
	"./another_brick.svg": 709,
	"./assessment.svg": 710,
	"./game.svg": 711,
	"./words_attack.svg": 712
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 908;

/***/ }),

/***/ 967:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(968);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(568)("2fd85780", content, true, {});

/***/ }),

/***/ 968:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(567)(true);
// imports


// module
exports.push([module.i, "@media (max-width:440px){.hide_mobile[data-v-79cbbf1d]{display:none!important}}@media (max-width:440px){.margin-top-10mobile[data-v-79cbbf1d]{margin-top:10px}}.title--text.timer[data-v-79cbbf1d]{padding:3px 10px;margin:0 10px;border:2px solid #dfdfdf;border-radius:300px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@media (max-width:440px){.title--text.timer[data-v-79cbbf1d]{margin:10px 0}}.title--text.timer h1[data-v-79cbbf1d]{font-size:17px!important;color:#9c9c9c}@media (max-width:440px){.title--text.timer h1[data-v-79cbbf1d]{font-size:20px;padding:10px}}.title--text.timer h1 span[data-v-79cbbf1d]{color:#686868}.btn-month[data-v-79cbbf1d]{height:23px;white-space:nowrap;padding:0 10px;border-radius:50px;background:orange;margin:3px;cursor:pointer;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;outline:none;border:none;-webkit-transition:all .2s ease-in;transition:all .2s ease-in}.btn-month[data-v-79cbbf1d]:hover{background:#632b0f,rgba(99,43,15,.86)}@media (max-width:440px){.title--btn[data-v-79cbbf1d]{width:100%;margin:10px 0}}.title--btn__plus[data-v-79cbbf1d]{margin:0 3px;font-size:22px;font-weight:400;color:#ffe200}@media (max-width:440px){.title--btn__plus[data-v-79cbbf1d]{margin:6px 3px}}.toprevnext[data-v-79cbbf1d]{height:11px}", "", {"version":3,"sources":["D:/Work/monk/minds-pwa-firebase/src/components/titleComponent/index.vue"],"names":[],"mappings":"AACA,yBACA,8BACI,sBAAyB,CAC5B,CACA,AACD,yBACA,sCACI,eAAiB,CACpB,CACA,AACD,oCACE,iBAAkB,AAClB,cAAiB,AACjB,yBAA0B,AAC1B,oBAAqB,AACrB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,yBACA,oCACM,aAAiB,CACtB,CACA,AACD,uCACI,yBAA2B,AAC3B,aAAe,CAClB,AACD,yBACA,uCACQ,eAAgB,AAChB,YAAc,CACrB,CACA,AACD,4CACM,aAAe,CACpB,AACD,4BACE,YAAa,AACb,mBAAoB,AACpB,eAAkB,AAClB,mBAAoB,AACpB,kBAAoB,AACpB,WAAY,AACZ,eAAgB,AAChB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,aAAc,AACd,YAAa,AACb,mCAAqC,AACrC,0BAA6B,CAC9B,AACD,kCACI,qCAA4C,CAC/C,AACD,yBACA,6BACI,WAAY,AACZ,aAAiB,CACpB,CACA,AACD,mCACE,aAAgB,AAChB,eAAgB,AAChB,gBAAiB,AACjB,aAAe,CAChB,AACD,yBACA,mCACM,cAAgB,CACrB,CACA,AACD,6BACE,WAAa,CACd","file":"index.vue","sourcesContent":["\n@media (max-width: 440px) {\n.hide_mobile[data-v-79cbbf1d] {\n    display: none !important;\n}\n}\n@media (max-width: 440px) {\n.margin-top-10mobile[data-v-79cbbf1d] {\n    margin-top: 10px;\n}\n}\n.title--text.timer[data-v-79cbbf1d] {\n  padding: 3px 10px;\n  margin: 0px 10px;\n  border: 2px solid #dfdfdf;\n  border-radius: 300px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n@media (max-width: 440px) {\n.title--text.timer[data-v-79cbbf1d] {\n      margin: 10px 0px;\n}\n}\n.title--text.timer h1[data-v-79cbbf1d] {\n    font-size: 17px !important;\n    color: #9c9c9c;\n}\n@media (max-width: 440px) {\n.title--text.timer h1[data-v-79cbbf1d] {\n        font-size: 20px;\n        padding: 10px;\n}\n}\n.title--text.timer h1 span[data-v-79cbbf1d] {\n      color: #686868;\n}\n.btn-month[data-v-79cbbf1d] {\n  height: 23px;\n  white-space: nowrap;\n  padding: 0px 10px;\n  border-radius: 50px;\n  background: #ffa500;\n  margin: 3px;\n  cursor: pointer;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  outline: none;\n  border: none;\n  -webkit-transition: all 0.2s ease-in;\n  transition: all 0.2s ease-in;\n}\n.btn-month[data-v-79cbbf1d]:hover {\n    background: #632b0f, rgba(99, 43, 15, 0.86);\n}\n@media (max-width: 440px) {\n.title--btn[data-v-79cbbf1d] {\n    width: 100%;\n    margin: 10px 0px;\n}\n}\n.title--btn__plus[data-v-79cbbf1d] {\n  margin: 0px 3px;\n  font-size: 22px;\n  font-weight: 400;\n  color: #ffe200;\n}\n@media (max-width: 440px) {\n.title--btn__plus[data-v-79cbbf1d] {\n      margin: 6px 3px;\n}\n}\n.toprevnext[data-v-79cbbf1d] {\n  height: 11px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 969:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  en: {
    dayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    format: 'MM/yyyy',
    fullFormat: 'dd/MM/yyyy',
    dayEventsTitle: 'All Events',
    notHaveEvents: 'Not Have Events'
  },
  zh: {
    dayNames: ["日", "一", "二", "三", "四", "五", "六"],
    monthNames: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
    format: 'yyyy年MM月',
    fullFormat: 'yyyy年MM月dd日',
    dayEventsTitle: '全部事件',
    notHaveEvents: '没有事件'
  },
  us: {
    dayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    format: 'MM/yyyy',
    fullFormat: 'MM/dd/yyyy',
    dayEventsTitle: 'All Events',
    notHaveEvents: 'Not Have Events'
  },
  es: {
    dayNames: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sá"],
    monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
    format: 'MM/yyyy',
    fullFormat: 'dd/MM/yyyy',
    dayEventsTitle: 'Todos los eventos',
    notHaveEvents: 'Nada'
  },
  'pt-br': {
    dayNames: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
    monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
    format: 'MM/yyyy',
    fullFormat: 'dd/MM/yyyy',
    dayEventsTitle: 'Todos os eventos',
    notHaveEvents: 'Nenhum evento'
  },
  ja: {
    dayNames: ["日", "月", "火", "水", "木", "金", "土"],
    monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
    format: 'yyyy/MM',
    fullFormat: 'yyyy/MM/dd',
    dayEventsTitle: '全てのイベント',
    notHaveEvents: 'イベントはありません'
  },
  ko: {
    dayNames: ["일", "월", "화", "수", "목", "금", "토"],
    monthNames: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
    format: 'yyyy/MM',
    fullFormat: 'yyyy/MM/dd',
    dayEventsTitle: '모든 이벤트',
    notHaveEvents: '일정이 없습니다'
  },
  fr: {
    dayNames: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
    monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
    format: 'MM/yyyy',
    fullFormat: 'dd/MM/yyyy',
    dayEventsTitle: 'Tous les événements',
    notHaveEvents: 'Aucun événement'
  },
  it: {
    dayNames: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
    monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
    format: 'MM/yyyy',
    fullFormat: 'dd/MM/yyyy',
    dayEventsTitle: 'Tutti gli eventi',
    notHaveEvents: 'Nessun evento'
  },
  ru: {
    dayNames: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
    monthNames: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
    format: 'MM/yyyy',
    fullFormat: 'dd/MM/yyyy',
    dayEventsTitle: 'Все события',
    notHaveEvents: 'События отсутствуют'
  },
  sv: {
    dayNames: ["Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör"],
    monthNames: ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"],
    format: 'MM/yyyy',
    fullFormat: 'dd/MM/yyyy',
    dayEventsTitle: 'Alla händelser',
    notHaveEvents: 'Inga händelser'
  },
  de: {
    dayNames: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    monthNames: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
    format: 'MM/yyyy',
    fullFormat: 'dd.MM.yyyy',
    dayEventsTitle: 'Alle Veranstaltungen',
    notHaveEvents: 'Keine Veranstaltungen'
  },
  vi: {
    dayNames: ["T2", "T3", "T4", "T5", "T6", "T7", "CN"],
    monthNames: ["Tháng 1", "Tháng 2", "Tháng 3", "Tháng 4", "Tháng 5", "Tháng 6", "Tháng 7", "Tháng 8", "Tháng 9", "Tháng 10", "Tháng 11", "Tháng 12"],
    format: 'MM/yyyy',
    fullFormat: 'dd/MM/yyyy',
    dayEventsTitle: 'Tất cả sự kiện',
    notHaveEvents: 'Không có sự kiện nào'
  }
});

/***/ }),

/***/ 970:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dateTimeFormatter;
/* unused harmony export isEqualDateStr */
function dateTimeFormatter(date, format) {
  // 时间格式化辅助函数 date:毫秒数 format:'yyyy-MM-dd hh:mm:ss'
  if (!date || date == "") {
    return "";
  }

  if (typeof date === "string") {
    var mts = date.match(/(\/Date\((\d+)\)\/)/);
    if (mts && mts.length >= 3) {
      date = parseInt(mts[2]);
    }
  }

  date = new Date(date);
  if (!date || date.toUTCString() == "Invalid Date") {
    return "";
  }

  var map = {
    "M": date.getMonth() + 1, //月份
    "d": date.getUTCDate(), //日
    "h": date.getHours(), //小时
    "m": date.getMinutes(), //分
    "s": date.getSeconds(), //秒
    "q": Math.floor((date.getMonth() + 3) / 3), //季度
    "S": date.getMilliseconds() //毫秒
  };

  format = format.replace(/([yMdhmsqS])+/g, function (all, t) {
    var v = map[t];
    if (v !== undefined) {
      if (all.length > 1) {
        v = '0' + v;
        v = v.substr(v.length - 2);
      }
      return v;
    } else if (t === 'y') {
      return (date.getFullYear() + '').substr(4 - all.length);
    }
    return all;
  });

  return format;
}
function isEqualDateStr(dateStr1, dateStr2) {
  var dateArr1 = dateStr1.split('/');
  var dateArr2 = dateStr2.split('/');
  if (parseInt(dateArr1[0], 10) !== parseInt(dateArr2[0], 10)) {
    return false;
  }
  if (parseInt(dateArr1[1], 10) !== parseInt(dateArr2[1], 10)) {
    return false;
  }
  if (parseInt(dateArr1[2], 10) !== parseInt(dateArr2[2], 10)) {
    return false;
  }
  return true;
}

/***/ }),

/***/ 971:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title container align-items-center justify-content-center",staticStyle:{"flex-wrap":"wrap"}},[_c('div',{staticClass:"flex-basis-100 title--mark animation-left animation-delay-01"},[_c('div',{staticClass:"title--mark-bt",class:_vm.color},[_vm._v("\r\n        "+_vm._s(_vm.mark)+"\r\n      ")])]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 title--text animation-right animation-delay-03"},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.value)}})]),_vm._v(" "),(_vm.titleBtn)?_c('div',{staticClass:"flex-grow-1 title--text animation-right animation-delay-03 margin-top-10mobile"},[_c('div',{staticClass:"flex-basis-100 animation-left animation-delay-01"},[_c('button',{staticClass:"btn btn-md btn-gradient-orange btn-strong btn-full btn-rounded",attrs:{"type":"button","name":"button"},on:{"click":function($event){return _vm.btnAction()}}},[_vm._v("AGENDAR AULA")])])]):_vm._e(),_vm._v(" "),(_vm.inTime && _vm.unitStarted && _vm.showTimer)?_c('div',{staticClass:"flex-grow-1 title--text timer animation-fade animation-delay-2 container justify-content-start align-items-center"},[_c('h1',{staticStyle:{"line-height":"1"}},[_vm._v("\r\n          Unit ends in\r\n          "),_c('span',[_vm._v(_vm._s(_vm.date.hours))]),_vm._v("h :\r\n          "),_c('span',[_vm._v(_vm._s(_vm.date.minutes > 9 ? _vm.date.minutes : ("0" + (_vm.date.minutes))))]),_vm._v("m :\r\n          "),_c('span',[_vm._v(_vm._s(_vm.date.seconds > 9 ? _vm.date.seconds : ("0" + (_vm.date.seconds))))]),_vm._v("s\r\n        ")])]):_vm._e(),_vm._v(" "),(_vm.showOnlineClass)?_c('div',{staticClass:"title--btn animation-left animation-delay-05",style:({ marginRight: !_vm.button ? 0 : '5px' })},[_c('router-link',{staticClass:"btn btn-sm btn-full btn-rounded btn-gradient-orange btn-strong",staticStyle:{"padding":"5px"},attrs:{"to":{ name: 'onlineClass' }}},[_c('span',{},[_vm._v(" Online Class")])])],1):_vm._e(),_vm._v(" "),(_vm.button)?_c('div',{staticClass:"title--btn animation-left animation-delay-05"},[(_vm.hasBook)?_c('router-link',{staticClass:"btn btn-sm btn-full btn-rounded btn-gradient-orange btn-strong",staticStyle:{"padding":"5px"},attrs:{"to":{ name: 'book', params: { book: _vm.currentBook.title } }}},[_c('span',{},[_vm._v(" UNITS")]),_vm._v(" "),_c('span',{staticClass:"title--btn__plus"},[_vm._v("+")])]):_c('router-link',{staticClass:"btn btn-sm btn-full btn-rounded btn-orange btn-strong",attrs:{"to":{ name: 'home' }}},[_vm._v("\r\n          Empty Book\r\n        ")])],1):_vm._e(),_vm._v(" "),(_vm.calendar)?_c('div',{staticClass:"title--btn animation-left animation-delay-05 container align-items-center"},[_c('div',{staticClass:"title--btn-date container justify-content-between align-items-center"},[_c('div',{staticClass:"container",staticStyle:{"z-index":"2"}},[_c('button',{staticClass:"btn-month",attrs:{"type":"button","name":"button"},on:{"click":function($event){return _vm.preMonth()}}},[_c('img',{staticClass:"toprevnext",staticStyle:{"transform":"rotate(180deg)"},attrs:{"src":__webpack_require__(719)}})])]),_vm._v(" "),_c('span',{staticClass:"margin-left-10 margin-right-10",staticStyle:{"width":"155px"}},[_vm._v(_vm._s(_vm.formatedMonth))]),_vm._v(" "),_c('div',{staticStyle:{"z-index":"2"}},[_c('button',{staticClass:"btn-month",attrs:{"type":"button","name":"button"},on:{"click":function($event){return _vm.nextMonth()}}},[_c('img',{staticClass:"toprevnext",attrs:{"src":__webpack_require__(719)}})])])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.416f37c32a3a795bf9a2.js